//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { apiUrl } from "./utils/env";
import { parseJSON, isValid, isMatch } from "date-fns";
export class GestitClientBase {
  constructor(private clientOptions: GestitClientOptions) {}

  getBaseUrl(defaultUrl: string | undefined, requestedUrl: string | undefined) {
    return defaultUrl || requestedUrl || apiUrl;
  }

  transformOptions(options: RequestInit): Promise<RequestInit> {
    if (this.clientOptions && this.clientOptions.accessToken) {
      let headers: any = {
        Authorization: "Bearer " + this.clientOptions.accessToken,
      };

      if (this.clientOptions.role) {
        headers["Role"] = this.clientOptions.role;
      }

      options.headers = {
        ...options.headers,
        ...headers,
      };
    }

    return Promise.resolve(options);
  }
}

export class DeadlineItemsClient extends GestitClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: GestitClientOptions,
    baseUrl?: string,
    http?: {
      fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
    }
  ) {
    super(configuration);

    // @ts-ignore
    this.http = http ? http : (window as any);
    // @ts-ignore
    this.baseUrl = this.getBaseUrl("", baseUrl);

    this.jsonParseReviver = (k, v) => dateReviver(k, v, dateProperties);
  }

  getDeadlineItems(
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined,
    includeClosedCommissions: boolean | undefined,
    includeSuspendedCommissions: boolean | undefined,
    includeDelivered: boolean | undefined
  ): Promise<SwaggerResponse<PaginatedOfDeadlineItemDto>> {
    let url_ = this.baseUrl + "/deadline?";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    if (includeClosedCommissions === null)
      throw new Error(
        "The parameter 'includeClosedCommissions' cannot be null."
      );
    else if (includeClosedCommissions !== undefined)
      url_ +=
        "includeClosedCommissions=" +
        encodeURIComponent("" + includeClosedCommissions) +
        "&";
    if (includeSuspendedCommissions === null)
      throw new Error(
        "The parameter 'includeSuspendedCommissions' cannot be null."
      );
    else if (includeSuspendedCommissions !== undefined)
      url_ +=
        "includeSuspendedCommissions=" +
        encodeURIComponent("" + includeSuspendedCommissions) +
        "&";
    if (includeDelivered === null)
      throw new Error("The parameter 'includeDelivered' cannot be null.");
    else if (includeDelivered !== undefined)
      url_ +=
        "includeDelivered=" + encodeURIComponent("" + includeDelivered) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetDeadlineItems(_response);
      });
  }

  protected processGetDeadlineItems(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfDeadlineItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfDeadlineItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfDeadlineItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getDeadlineCommissions(
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined,
    includeClosedCommissions: boolean | undefined,
    includeSuspendedCommissions: boolean | undefined,
    includeDelivered: boolean | undefined
  ): Promise<SwaggerResponse<PaginatedOfCommissionDto>> {
    let url_ = this.baseUrl + "/deadline/commissions?";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    if (includeClosedCommissions === null)
      throw new Error(
        "The parameter 'includeClosedCommissions' cannot be null."
      );
    else if (includeClosedCommissions !== undefined)
      url_ +=
        "includeClosedCommissions=" +
        encodeURIComponent("" + includeClosedCommissions) +
        "&";
    if (includeSuspendedCommissions === null)
      throw new Error(
        "The parameter 'includeSuspendedCommissions' cannot be null."
      );
    else if (includeSuspendedCommissions !== undefined)
      url_ +=
        "includeSuspendedCommissions=" +
        encodeURIComponent("" + includeSuspendedCommissions) +
        "&";
    if (includeDelivered === null)
      throw new Error("The parameter 'includeDelivered' cannot be null.");
    else if (includeDelivered !== undefined)
      url_ +=
        "includeDelivered=" + encodeURIComponent("" + includeDelivered) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetDeadlineCommissions(_response);
      });
  }

  protected processGetDeadlineCommissions(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfCommissionDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfCommissionDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfCommissionDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportDeadlineItems(
    fields: string | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    includeClosedCommissions: boolean | undefined,
    includeSuspendedCommissions: boolean | undefined,
    includeDelivered: boolean | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/deadline/export?";
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (includeClosedCommissions === null)
      throw new Error(
        "The parameter 'includeClosedCommissions' cannot be null."
      );
    else if (includeClosedCommissions !== undefined)
      url_ +=
        "includeClosedCommissions=" +
        encodeURIComponent("" + includeClosedCommissions) +
        "&";
    if (includeSuspendedCommissions === null)
      throw new Error(
        "The parameter 'includeSuspendedCommissions' cannot be null."
      );
    else if (includeSuspendedCommissions !== undefined)
      url_ +=
        "includeSuspendedCommissions=" +
        encodeURIComponent("" + includeSuspendedCommissions) +
        "&";
    if (includeDelivered === null)
      throw new Error("The parameter 'includeDelivered' cannot be null.");
    else if (includeDelivered !== undefined)
      url_ +=
        "includeDelivered=" + encodeURIComponent("" + includeDelivered) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportDeadlineItems(_response);
      });
  }

  protected processExportDeadlineItems(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }
}

export class BanksClient extends GestitClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: GestitClientOptions,
    baseUrl?: string,
    http?: {
      fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
    }
  ) {
    super(configuration);

    // @ts-ignore
    this.http = http ? http : (window as any);
    // @ts-ignore
    this.baseUrl = this.getBaseUrl("", baseUrl);

    this.jsonParseReviver = (k, v) => dateReviver(k, v, dateProperties);
  }

  getBanks(
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfBankDto>> {
    let url_ = this.baseUrl + "/banks?";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetBanks(_response);
      });
  }

  protected processGetBanks(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfBankDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfBankDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfBankDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createBank(model: ManageBankDto): Promise<SwaggerResponse<BankDto>> {
    let url_ = this.baseUrl + "/banks";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateBank(_response);
      });
  }

  protected processCreateBank(
    response: Response
  ): Promise<SwaggerResponse<BankDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as BankDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<BankDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportBanks(
    fields: string | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/banks/export?";
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportBanks(_response);
      });
  }

  protected processExportBanks(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getBank(id: string): Promise<SwaggerResponse<BankDto>> {
    let url_ = this.baseUrl + "/banks/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetBank(_response);
      });
  }

  protected processGetBank(
    response: Response
  ): Promise<SwaggerResponse<BankDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as BankDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<BankDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateBank(
    id: string,
    model: ManageBankDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/banks/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateBank(_response);
      });
  }

  protected processUpdateBank(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteBank(id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/banks/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteBank(_response);
      });
  }

  protected processDeleteBank(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getBankAccounts(
    bankId: string,
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfBankAccountDto>> {
    let url_ = this.baseUrl + "/banks/{bankId}/accounts?";
    if (bankId === undefined || bankId === null)
      throw new Error("The parameter 'bankId' must be defined.");
    url_ = url_.replace("{bankId}", encodeURIComponent("" + bankId));
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetBankAccounts(_response);
      });
  }

  protected processGetBankAccounts(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfBankAccountDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfBankAccountDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfBankAccountDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createBankAccount(
    bankId: string,
    model: ManageBankAccountDto
  ): Promise<SwaggerResponse<BankAccountDto>> {
    let url_ = this.baseUrl + "/banks/{bankId}/accounts";
    if (bankId === undefined || bankId === null)
      throw new Error("The parameter 'bankId' must be defined.");
    url_ = url_.replace("{bankId}", encodeURIComponent("" + bankId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateBankAccount(_response);
      });
  }

  protected processCreateBankAccount(
    response: Response
  ): Promise<SwaggerResponse<BankAccountDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as BankAccountDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<BankAccountDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportBankAccounts(
    bankId: string,
    fields: string | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/banks/{bankId}/accounts/export?";
    if (bankId === undefined || bankId === null)
      throw new Error("The parameter 'bankId' must be defined.");
    url_ = url_.replace("{bankId}", encodeURIComponent("" + bankId));
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportBankAccounts(_response);
      });
  }

  protected processExportBankAccounts(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getBankAccount(
    bankId: string,
    accountId: string
  ): Promise<SwaggerResponse<BankAccountDto>> {
    let url_ = this.baseUrl + "/banks/{bankId}/accounts/{accountId}";
    if (bankId === undefined || bankId === null)
      throw new Error("The parameter 'bankId' must be defined.");
    url_ = url_.replace("{bankId}", encodeURIComponent("" + bankId));
    if (accountId === undefined || accountId === null)
      throw new Error("The parameter 'accountId' must be defined.");
    url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetBankAccount(_response);
      });
  }

  protected processGetBankAccount(
    response: Response
  ): Promise<SwaggerResponse<BankAccountDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as BankAccountDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<BankAccountDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateBankAccount(
    bankId: string,
    accountId: string,
    model: ManageBankAccountDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/banks/{bankId}/accounts/{accountId}";
    if (bankId === undefined || bankId === null)
      throw new Error("The parameter 'bankId' must be defined.");
    url_ = url_.replace("{bankId}", encodeURIComponent("" + bankId));
    if (accountId === undefined || accountId === null)
      throw new Error("The parameter 'accountId' must be defined.");
    url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateBankAccount(_response);
      });
  }

  protected processUpdateBankAccount(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteBankAccount(
    bankId: string,
    accountId: string
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/banks/{bankId}/accounts/{accountId}";
    if (bankId === undefined || bankId === null)
      throw new Error("The parameter 'bankId' must be defined.");
    url_ = url_.replace("{bankId}", encodeURIComponent("" + bankId));
    if (accountId === undefined || accountId === null)
      throw new Error("The parameter 'accountId' must be defined.");
    url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteBankAccount(_response);
      });
  }

  protected processDeleteBankAccount(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getAllBankAccounts(
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfBankAccountDto>> {
    let url_ = this.baseUrl + "/bankAccounts?";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAllBankAccounts(_response);
      });
  }

  protected processGetAllBankAccounts(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfBankAccountDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfBankAccountDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfBankAccountDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getAccount(id: string): Promise<SwaggerResponse<BankAccountDto>> {
    let url_ = this.baseUrl + "/bankAccounts/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAccount(_response);
      });
  }

  protected processGetAccount(
    response: Response
  ): Promise<SwaggerResponse<BankAccountDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as BankAccountDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<BankAccountDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }
}

export class BillingDocumentsClient extends GestitClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: GestitClientOptions,
    baseUrl?: string,
    http?: {
      fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
    }
  ) {
    super(configuration);

    // @ts-ignore
    this.http = http ? http : (window as any);
    // @ts-ignore
    this.baseUrl = this.getBaseUrl("", baseUrl);

    this.jsonParseReviver = (k, v) => dateReviver(k, v, dateProperties);
  }

  getBillingDocuments(
    type: BillingDocumentType | undefined,
    sortBy: string | null | undefined,
    filterBy: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined,
    includeTotals: boolean | undefined
  ): Promise<SwaggerResponse<PaginatedWithTotalOfBillingDocumentDto>> {
    let url_ = this.baseUrl + "/billingDocuments?";
    if (type === null) throw new Error("The parameter 'type' cannot be null.");
    else if (type !== undefined)
      url_ += "type=" + encodeURIComponent("" + type) + "&";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (filterBy !== undefined && filterBy !== null)
      url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    if (includeTotals === null)
      throw new Error("The parameter 'includeTotals' cannot be null.");
    else if (includeTotals !== undefined)
      url_ += "includeTotals=" + encodeURIComponent("" + includeTotals) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetBillingDocuments(_response);
      });
  }

  protected processGetBillingDocuments(
    response: Response
  ): Promise<SwaggerResponse<PaginatedWithTotalOfBillingDocumentDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedWithTotalOfBillingDocumentDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<
      SwaggerResponse<PaginatedWithTotalOfBillingDocumentDto>
    >(new SwaggerResponse(status, _headers, null as any));
  }

  createBillingDocument(
    model: ManageBillingDocumentDto
  ): Promise<SwaggerResponse<BillingDocumentDto>> {
    let url_ = this.baseUrl + "/billingDocuments";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateBillingDocument(_response);
      });
  }

  protected processCreateBillingDocument(
    response: Response
  ): Promise<SwaggerResponse<BillingDocumentDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as BillingDocumentDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<BillingDocumentDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportBillingDocuments(
    type: BillingDocumentType | undefined,
    fields: string | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/billingDocuments/export?";
    if (type === null) throw new Error("The parameter 'type' cannot be null.");
    else if (type !== undefined)
      url_ += "type=" + encodeURIComponent("" + type) + "&";
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportBillingDocuments(_response);
      });
  }

  protected processExportBillingDocuments(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  generateBillingDocumentsReport(
    documents: BillingDocumentDto[]
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/billingDocuments/reports";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(documents);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGenerateBillingDocumentsReport(_response);
      });
  }

  protected processGenerateBillingDocumentsReport(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getBillingDocument(id: string): Promise<SwaggerResponse<BillingDocumentDto>> {
    let url_ = this.baseUrl + "/billingDocuments/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetBillingDocument(_response);
      });
  }

  protected processGetBillingDocument(
    response: Response
  ): Promise<SwaggerResponse<BillingDocumentDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as BillingDocumentDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<BillingDocumentDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateBillingDocument(
    id: string,
    model: ManageBillingDocumentDto
  ): Promise<SwaggerResponse<BillingDocumentDto>> {
    let url_ = this.baseUrl + "/billingDocuments/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateBillingDocument(_response);
      });
  }

  protected processUpdateBillingDocument(
    response: Response
  ): Promise<SwaggerResponse<BillingDocumentDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as BillingDocumentDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<BillingDocumentDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteBillingDocument(id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/billingDocuments/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteBillingDocument(_response);
      });
  }

  protected processDeleteBillingDocument(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  checkValidBillingDocumentTaxable(
    id: string,
    itemId: string | null | undefined,
    nextItemPrice: number | undefined
  ): Promise<SwaggerResponse<boolean>> {
    let url_ = this.baseUrl + "/billingDocuments/{id}/checkTaxable?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (itemId !== undefined && itemId !== null)
      url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
    if (nextItemPrice === null)
      throw new Error("The parameter 'nextItemPrice' cannot be null.");
    else if (nextItemPrice !== undefined)
      url_ += "nextItemPrice=" + encodeURIComponent("" + nextItemPrice) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCheckValidBillingDocumentTaxable(_response);
      });
  }

  protected processCheckValidBillingDocumentTaxable(
    response: Response
  ): Promise<SwaggerResponse<boolean>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<boolean>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getDeliveryDocumentsToBill(
    type: BillingDocumentType | undefined,
    startDate: Date | undefined,
    endDate: Date | undefined,
    sortBy: string | null | undefined,
    filterBy: string | null | undefined
  ): Promise<SwaggerResponse<DeliveryDocumentDto[]>> {
    let url_ = this.baseUrl + "/billingDocuments/deliveryDocumentsToBill?";
    if (type === null) throw new Error("The parameter 'type' cannot be null.");
    else if (type !== undefined)
      url_ += "type=" + encodeURIComponent("" + type) + "&";
    if (startDate === null)
      throw new Error("The parameter 'startDate' cannot be null.");
    else if (startDate !== undefined)
      url_ +=
        "startDate=" +
        encodeURIComponent(startDate ? "" + startDate.toISOString() : "") +
        "&";
    if (endDate === null)
      throw new Error("The parameter 'endDate' cannot be null.");
    else if (endDate !== undefined)
      url_ +=
        "endDate=" +
        encodeURIComponent(endDate ? "" + endDate.toISOString() : "") +
        "&";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (filterBy !== undefined && filterBy !== null)
      url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetDeliveryDocumentsToBill(_response);
      });
  }

  protected processGetDeliveryDocumentsToBill(
    response: Response
  ): Promise<SwaggerResponse<DeliveryDocumentDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as DeliveryDocumentDto[]);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<DeliveryDocumentDto[]>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createBillingDocumentsFromDeliveryDocuments(
    model: CreateBillingDocumentsFromDeliveryDocumentsDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ =
      this.baseUrl + "/billingDocuments/createInvoicesFromDeliveryDocuments";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateBillingDocumentsFromDeliveryDocuments(
          _response
        );
      });
  }

  protected processCreateBillingDocumentsFromDeliveryDocuments(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  generateBillingDocumentReport(
    id: string
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/billingDocuments/{id}/report";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGenerateBillingDocumentReport(_response);
      });
  }

  protected processGenerateBillingDocumentReport(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getBillingDocumentDeliveryDocuments(
    id: string,
    sortBy: string | null | undefined,
    filterBy: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined
  ): Promise<SwaggerResponse<PaginatedOfDeliveryDocumentDto>> {
    let url_ = this.baseUrl + "/billingDocuments/{id}/deliveryDocuments?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (filterBy !== undefined && filterBy !== null)
      url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetBillingDocumentDeliveryDocuments(_response);
      });
  }

  protected processGetBillingDocumentDeliveryDocuments(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfDeliveryDocumentDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfDeliveryDocumentDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfDeliveryDocumentDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportBillingDocumentDeliveryDocuments(
    id: string,
    fields: string | undefined,
    sortBy: string | null | undefined,
    filterBy: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ =
      this.baseUrl + "/billingDocuments/{id}/deliveryDocuments/export?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (filterBy !== undefined && filterBy !== null)
      url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportBillingDocumentDeliveryDocuments(_response);
      });
  }

  protected processExportBillingDocumentDeliveryDocuments(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getBillingDocumentSaleOrders(
    id: string,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined
  ): Promise<SwaggerResponse<PaginatedOfSaleOrderDto>> {
    let url_ = this.baseUrl + "/billingDocuments/{id}/orders?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetBillingDocumentSaleOrders(_response);
      });
  }

  protected processGetBillingDocumentSaleOrders(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfSaleOrderDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfSaleOrderDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfSaleOrderDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportBillingDocumentSaleOrders(
    id: string,
    fields: string | undefined,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/billingDocuments/{id}/orders/export?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportBillingDocumentSaleOrders(_response);
      });
  }

  protected processExportBillingDocumentSaleOrders(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getBillingDocumentItems(
    id: string,
    sortBy: string | null | undefined,
    filterBy: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined
  ): Promise<SwaggerResponse<PaginatedOfBillingDocumentItemDto>> {
    let url_ = this.baseUrl + "/billingDocuments/{id}/items?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (filterBy !== undefined && filterBy !== null)
      url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetBillingDocumentItems(_response);
      });
  }

  protected processGetBillingDocumentItems(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfBillingDocumentItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfBillingDocumentItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfBillingDocumentItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createBillingDocumentItem(
    id: string,
    model: ManageBillingDocumentItemDto
  ): Promise<SwaggerResponse<BillingDocumentItemDto>> {
    let url_ = this.baseUrl + "/billingDocuments/{id}/items";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateBillingDocumentItem(_response);
      });
  }

  protected processCreateBillingDocumentItem(
    response: Response
  ): Promise<SwaggerResponse<BillingDocumentItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as BillingDocumentItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<BillingDocumentItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportBillingDocumentItems(
    id: string,
    fields: string | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/billingDocuments/{id}/items/export?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportBillingDocumentItems(_response);
      });
  }

  protected processExportBillingDocumentItems(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getBillingDocumentItem(
    id: string,
    itemId: string
  ): Promise<SwaggerResponse<BillingDocumentItemDto>> {
    let url_ = this.baseUrl + "/billingDocuments/{id}/items/{itemId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (itemId === undefined || itemId === null)
      throw new Error("The parameter 'itemId' must be defined.");
    url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetBillingDocumentItem(_response);
      });
  }

  protected processGetBillingDocumentItem(
    response: Response
  ): Promise<SwaggerResponse<BillingDocumentItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as BillingDocumentItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<BillingDocumentItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateBillingDocumentItem(
    id: string,
    itemId: string,
    model: ManageBillingDocumentItemDto
  ): Promise<SwaggerResponse<BillingDocumentItemDto>> {
    let url_ = this.baseUrl + "/billingDocuments/{id}/items/{itemId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (itemId === undefined || itemId === null)
      throw new Error("The parameter 'itemId' must be defined.");
    url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateBillingDocumentItem(_response);
      });
  }

  protected processUpdateBillingDocumentItem(
    response: Response
  ): Promise<SwaggerResponse<BillingDocumentItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as BillingDocumentItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<BillingDocumentItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  removeBillingDocumentItem(
    id: string,
    itemId: string
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/billingDocuments/{id}/items/{itemId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (itemId === undefined || itemId === null)
      throw new Error("The parameter 'itemId' must be defined.");
    url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processRemoveBillingDocumentItem(_response);
      });
  }

  protected processRemoveBillingDocumentItem(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateBillingDocumentItemOrder(
    id: string,
    itemId: string,
    model: ManageBillingDocumentItemsOrderDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/billingDocuments/{id}/items/{itemId}/sort";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (itemId === undefined || itemId === null)
      throw new Error("The parameter 'itemId' must be defined.");
    url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateBillingDocumentItemOrder(_response);
      });
  }

  protected processUpdateBillingDocumentItemOrder(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getInvoiceItemsAvailable(
    id: string,
    sortBy: string | null | undefined,
    filterBy: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfItemDto>> {
    let url_ = this.baseUrl + "/billingDocuments/{id}/items/available?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (filterBy !== undefined && filterBy !== null)
      url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetInvoiceItemsAvailable(_response);
      });
  }

  protected processGetInvoiceItemsAvailable(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getInvoiceTransmissionById(
    id: string,
    sortBy: string | null | undefined,
    filterBy: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined
  ): Promise<SwaggerResponse<PaginatedOfInvoiceTransmissionFlattenDto>> {
    let url_ = this.baseUrl + "/billingDocuments/{id}/transmission?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (filterBy !== undefined && filterBy !== null)
      url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetInvoiceTransmissionById(_response);
      });
  }

  protected processGetInvoiceTransmissionById(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfInvoiceTransmissionFlattenDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfInvoiceTransmissionFlattenDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<
      SwaggerResponse<PaginatedOfInvoiceTransmissionFlattenDto>
    >(new SwaggerResponse(status, _headers, null as any));
  }

  sendInvoice(id: string): Promise<SwaggerResponse<BillingDocumentItemDto>> {
    let url_ = this.baseUrl + "/billingDocuments/{id}/transmission/send";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSendInvoice(_response);
      });
  }

  protected processSendInvoice(
    response: Response
  ): Promise<SwaggerResponse<BillingDocumentItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as BillingDocumentItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<BillingDocumentItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateSendedInvoiceStatus(
    code: string,
    model: UpdateInvoiceTransmissionStatusDto
  ): Promise<SwaggerResponse<BillingDocumentItemDto>> {
    let url_ = this.baseUrl + "/billingDocuments/transmission/{code}/status";
    if (code === undefined || code === null)
      throw new Error("The parameter 'code' must be defined.");
    url_ = url_.replace("{code}", encodeURIComponent("" + code));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateSendedInvoiceStatus(_response);
      });
  }

  protected processUpdateSendedInvoiceStatus(
    response: Response
  ): Promise<SwaggerResponse<BillingDocumentItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as BillingDocumentItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<BillingDocumentItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }
}

export class BillOfMaterialsClient extends GestitClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: GestitClientOptions,
    baseUrl?: string,
    http?: {
      fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
    }
  ) {
    super(configuration);

    // @ts-ignore
    this.http = http ? http : (window as any);
    // @ts-ignore
    this.baseUrl = this.getBaseUrl("", baseUrl);

    this.jsonParseReviver = (k, v) => dateReviver(k, v, dateProperties);
  }

  getBillOfMaterials(
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfBillOfMaterialDto>> {
    let url_ = this.baseUrl + "/billofmaterials?";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetBillOfMaterials(_response);
      });
  }

  protected processGetBillOfMaterials(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfBillOfMaterialDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfBillOfMaterialDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfBillOfMaterialDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getBillOfMaterial(id: string): Promise<SwaggerResponse<BillOfMaterialDto>> {
    let url_ = this.baseUrl + "/billofmaterials/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetBillOfMaterial(_response);
      });
  }

  protected processGetBillOfMaterial(
    response: Response
  ): Promise<SwaggerResponse<BillOfMaterialDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as BillOfMaterialDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<BillOfMaterialDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteBillOfMaterial(id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/billofmaterials/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteBillOfMaterial(_response);
      });
  }

  protected processDeleteBillOfMaterial(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getBillOfMaterialByItemId(
    itemId: string
  ): Promise<SwaggerResponse<BillOfMaterialDto>> {
    let url_ = this.baseUrl + "/billofmaterials/search/{itemId}";
    if (itemId === undefined || itemId === null)
      throw new Error("The parameter 'itemId' must be defined.");
    url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetBillOfMaterialByItemId(_response);
      });
  }

  protected processGetBillOfMaterialByItemId(
    response: Response
  ): Promise<SwaggerResponse<BillOfMaterialDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as BillOfMaterialDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<BillOfMaterialDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getBOMOperations(
    id: string,
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfOperationDto>> {
    let url_ = this.baseUrl + "/billofmaterials/{id}/operations?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetBOMOperations(_response);
      });
  }

  protected processGetBOMOperations(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfOperationDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfOperationDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfOperationDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  addOperation(
    id: string,
    operationId: string
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/billofmaterials/{id}/operations/{operationId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (operationId === undefined || operationId === null)
      throw new Error("The parameter 'operationId' must be defined.");
    url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "PUT",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAddOperation(_response);
      });
  }

  protected processAddOperation(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteOperation(
    id: string,
    operationId: string
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/billofmaterials/{id}/operations/{operationId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (operationId === undefined || operationId === null)
      throw new Error("The parameter 'operationId' must be defined.");
    url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteOperation(_response);
      });
  }

  protected processDeleteOperation(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getBOMComponents(
    id: string,
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfBillOfMaterialComponentDto>> {
    let url_ = this.baseUrl + "/billofmaterials/{id}/components?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetBOMComponents(_response);
      });
  }

  protected processGetBOMComponents(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfBillOfMaterialComponentDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfBillOfMaterialComponentDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<
      SwaggerResponse<PaginatedOfBillOfMaterialComponentDto>
    >(new SwaggerResponse(status, _headers, null as any));
  }

  addComponent(
    id: string,
    itemId: string | undefined,
    quantity: number | undefined
  ): Promise<SwaggerResponse<BillOfMaterialComponentDto>> {
    let url_ = this.baseUrl + "/billofmaterials/{id}/components?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (itemId === null)
      throw new Error("The parameter 'itemId' cannot be null.");
    else if (itemId !== undefined)
      url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
    if (quantity === null)
      throw new Error("The parameter 'quantity' cannot be null.");
    else if (quantity !== undefined)
      url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAddComponent(_response);
      });
  }

  protected processAddComponent(
    response: Response
  ): Promise<SwaggerResponse<BillOfMaterialComponentDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as BillOfMaterialComponentDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<BillOfMaterialComponentDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getAvailableBOMComponents(
    id: string,
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfItemDto>> {
    let url_ = this.baseUrl + "/billofmaterials/{id}/components/available?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAvailableBOMComponents(_response);
      });
  }

  protected processGetAvailableBOMComponents(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getRequiredBOMComponent(
    id: string,
    itemId: string
  ): Promise<SwaggerResponse<BillOfMaterialComponentDto>> {
    let url_ = this.baseUrl + "/billofmaterials/{id}/components/{itemId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (itemId === undefined || itemId === null)
      throw new Error("The parameter 'itemId' must be defined.");
    url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetRequiredBOMComponent(_response);
      });
  }

  protected processGetRequiredBOMComponent(
    response: Response
  ): Promise<SwaggerResponse<BillOfMaterialComponentDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as BillOfMaterialComponentDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<BillOfMaterialComponentDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateComponent(
    id: string,
    itemId: string,
    quantity: number | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/billofmaterials/{id}/components/{itemId}?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (itemId === undefined || itemId === null)
      throw new Error("The parameter 'itemId' must be defined.");
    url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
    if (quantity === null)
      throw new Error("The parameter 'quantity' cannot be null.");
    else if (quantity !== undefined)
      url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "PUT",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateComponent(_response);
      });
  }

  protected processUpdateComponent(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteComponent(
    id: string,
    itemId: string
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/billofmaterials/{id}/components/{itemId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (itemId === undefined || itemId === null)
      throw new Error("The parameter 'itemId' must be defined.");
    url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteComponent(_response);
      });
  }

  protected processDeleteComponent(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createBillOfMaterial(
    model: ManageBillOfMaterialDto
  ): Promise<SwaggerResponse<BillOfMaterialDto>> {
    let url_ = this.baseUrl + "/billofmaterials/create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateBillOfMaterial(_response);
      });
  }

  protected processCreateBillOfMaterial(
    response: Response
  ): Promise<SwaggerResponse<BillOfMaterialDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as BillOfMaterialDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<BillOfMaterialDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }
}

export class BillsOfLadingClient extends GestitClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: GestitClientOptions,
    baseUrl?: string,
    http?: {
      fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
    }
  ) {
    super(configuration);

    // @ts-ignore
    this.http = http ? http : (window as any);
    // @ts-ignore
    this.baseUrl = this.getBaseUrl("", baseUrl);

    this.jsonParseReviver = (k, v) => dateReviver(k, v, dateProperties);
  }

  getBillsOfLading(
    target: DocumentTarget | undefined,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined,
    includeTotals: boolean | undefined
  ): Promise<SwaggerResponse<PaginatedWithTotalOfBillOfLadingDto>> {
    let url_ = this.baseUrl + "/billsOfLading?";
    if (target === null)
      throw new Error("The parameter 'target' cannot be null.");
    else if (target !== undefined)
      url_ += "target=" + encodeURIComponent("" + target) + "&";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    if (includeTotals === null)
      throw new Error("The parameter 'includeTotals' cannot be null.");
    else if (includeTotals !== undefined)
      url_ += "includeTotals=" + encodeURIComponent("" + includeTotals) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetBillsOfLading(_response);
      });
  }

  protected processGetBillsOfLading(
    response: Response
  ): Promise<SwaggerResponse<PaginatedWithTotalOfBillOfLadingDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedWithTotalOfBillOfLadingDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<
      SwaggerResponse<PaginatedWithTotalOfBillOfLadingDto>
    >(new SwaggerResponse(status, _headers, null as any));
  }

  createBillOfLading(
    model: ManageBillOfLadingDto
  ): Promise<SwaggerResponse<BillOfLadingDto>> {
    let url_ = this.baseUrl + "/billsOfLading";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateBillOfLading(_response);
      });
  }

  protected processCreateBillOfLading(
    response: Response
  ): Promise<SwaggerResponse<BillOfLadingDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as BillOfLadingDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<BillOfLadingDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportBillsOfLading(
    target: DocumentTarget | undefined,
    fields: string | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/billsOfLading/export?";
    if (target === null)
      throw new Error("The parameter 'target' cannot be null.");
    else if (target !== undefined)
      url_ += "target=" + encodeURIComponent("" + target) + "&";
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportBillsOfLading(_response);
      });
  }

  protected processExportBillsOfLading(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  checkValidBillsOfLadingTaxable(
    id: string,
    itemId: string | null | undefined,
    nextItemPrice: number | undefined
  ): Promise<SwaggerResponse<boolean>> {
    let url_ = this.baseUrl + "/billsOfLading/{id}/checkTaxable?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (itemId !== undefined && itemId !== null)
      url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
    if (nextItemPrice === null)
      throw new Error("The parameter 'nextItemPrice' cannot be null.");
    else if (nextItemPrice !== undefined)
      url_ += "nextItemPrice=" + encodeURIComponent("" + nextItemPrice) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCheckValidBillsOfLadingTaxable(_response);
      });
  }

  protected processCheckValidBillsOfLadingTaxable(
    response: Response
  ): Promise<SwaggerResponse<boolean>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<boolean>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateBillOfLading(
    id: string,
    model: ManageBillOfLadingDto
  ): Promise<SwaggerResponse<BillOfLadingDto>> {
    let url_ = this.baseUrl + "/billsOfLading/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateBillOfLading(_response);
      });
  }

  protected processUpdateBillOfLading(
    response: Response
  ): Promise<SwaggerResponse<BillOfLadingDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as BillOfLadingDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<BillOfLadingDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteBillOfLading(id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/billsOfLading/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteBillOfLading(_response);
      });
  }

  protected processDeleteBillOfLading(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getBillOfLading(id: string): Promise<SwaggerResponse<BillOfLadingDto>> {
    let url_ = this.baseUrl + "/billsOfLading/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetBillOfLading(_response);
      });
  }

  protected processGetBillOfLading(
    response: Response
  ): Promise<SwaggerResponse<BillOfLadingDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as BillOfLadingDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<BillOfLadingDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getBillOfLadingItems(
    id: string,
    sortBy: string | null | undefined,
    filterBy: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined
  ): Promise<SwaggerResponse<PaginatedOfBillOfLadingItemDto>> {
    let url_ = this.baseUrl + "/billsOfLading/{id}/items?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (filterBy !== undefined && filterBy !== null)
      url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetBillOfLadingItems(_response);
      });
  }

  protected processGetBillOfLadingItems(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfBillOfLadingItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfBillOfLadingItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfBillOfLadingItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  addBillOfLadingItem(
    id: string,
    model: ManageBillOfLadingItemDto
  ): Promise<SwaggerResponse<BillOfLadingItemDto>> {
    let url_ = this.baseUrl + "/billsOfLading/{id}/items";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAddBillOfLadingItem(_response);
      });
  }

  protected processAddBillOfLadingItem(
    response: Response
  ): Promise<SwaggerResponse<BillOfLadingItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as BillOfLadingItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<BillOfLadingItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateBillOfLadingItemOrder(
    id: string,
    billOfLadingItemId: string,
    model: ManageBillOfLadingItemsOrderDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ =
      this.baseUrl + "/billsOfLading/{id}/items/{billOfLadingItemId}/sort";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (billOfLadingItemId === undefined || billOfLadingItemId === null)
      throw new Error("The parameter 'billOfLadingItemId' must be defined.");
    url_ = url_.replace(
      "{billOfLadingItemId}",
      encodeURIComponent("" + billOfLadingItemId)
    );
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateBillOfLadingItemOrder(_response);
      });
  }

  protected processUpdateBillOfLadingItemOrder(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  removeBillOfLadingItem(
    id: string,
    billOfLadingItemId: string
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/billsOfLading/{id}/items/{billOfLadingItemId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (billOfLadingItemId === undefined || billOfLadingItemId === null)
      throw new Error("The parameter 'billOfLadingItemId' must be defined.");
    url_ = url_.replace(
      "{billOfLadingItemId}",
      encodeURIComponent("" + billOfLadingItemId)
    );
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processRemoveBillOfLadingItem(_response);
      });
  }

  protected processRemoveBillOfLadingItem(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getBillOfLadingItem(
    id: string,
    billOfLadingItemId: string
  ): Promise<SwaggerResponse<BillOfLadingItemDto>> {
    let url_ = this.baseUrl + "/billsOfLading/{id}/items/{billOfLadingItemId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (billOfLadingItemId === undefined || billOfLadingItemId === null)
      throw new Error("The parameter 'billOfLadingItemId' must be defined.");
    url_ = url_.replace(
      "{billOfLadingItemId}",
      encodeURIComponent("" + billOfLadingItemId)
    );
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetBillOfLadingItem(_response);
      });
  }

  protected processGetBillOfLadingItem(
    response: Response
  ): Promise<SwaggerResponse<BillOfLadingItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as BillOfLadingItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<BillOfLadingItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateBillOfLadingItem(
    id: string,
    billOfLadingItemId: string,
    model: ManageBillOfLadingItemDto
  ): Promise<SwaggerResponse<BillOfLadingItemDto>> {
    let url_ = this.baseUrl + "/billsOfLading/{id}/items/{billOfLadingItemId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (billOfLadingItemId === undefined || billOfLadingItemId === null)
      throw new Error("The parameter 'billOfLadingItemId' must be defined.");
    url_ = url_.replace(
      "{billOfLadingItemId}",
      encodeURIComponent("" + billOfLadingItemId)
    );
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateBillOfLadingItem(_response);
      });
  }

  protected processUpdateBillOfLadingItem(
    response: Response
  ): Promise<SwaggerResponse<BillOfLadingItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as BillOfLadingItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<BillOfLadingItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }
}

export class CarriersClient extends GestitClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: GestitClientOptions,
    baseUrl?: string,
    http?: {
      fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
    }
  ) {
    super(configuration);

    // @ts-ignore
    this.http = http ? http : (window as any);
    // @ts-ignore
    this.baseUrl = this.getBaseUrl("", baseUrl);

    this.jsonParseReviver = (k, v) => dateReviver(k, v, dateProperties);
  }

  getCarriers(
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfCarrierDto>> {
    let url_ = this.baseUrl + "/carriers?";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCarriers(_response);
      });
  }

  protected processGetCarriers(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfCarrierDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfCarrierDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfCarrierDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createCarrier(model: ManageCarrierDto): Promise<SwaggerResponse<CarrierDto>> {
    let url_ = this.baseUrl + "/carriers";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateCarrier(_response);
      });
  }

  protected processCreateCarrier(
    response: Response
  ): Promise<SwaggerResponse<CarrierDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as CarrierDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<CarrierDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportCarriers(
    fields: string | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/carriers/export?";
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportCarriers(_response);
      });
  }

  protected processExportCarriers(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getCarrier(id: string): Promise<SwaggerResponse<CarrierDto>> {
    let url_ = this.baseUrl + "/carriers/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCarrier(_response);
      });
  }

  protected processGetCarrier(
    response: Response
  ): Promise<SwaggerResponse<CarrierDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as CarrierDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<CarrierDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateCarrier(
    id: string,
    model: ManageCarrierDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/carriers/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateCarrier(_response);
      });
  }

  protected processUpdateCarrier(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteCarrier(id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/carriers/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteCarrier(_response);
      });
  }

  protected processDeleteCarrier(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }
}

export class CommissionsClient extends GestitClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: GestitClientOptions,
    baseUrl?: string,
    http?: {
      fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
    }
  ) {
    super(configuration);

    // @ts-ignore
    this.http = http ? http : (window as any);
    // @ts-ignore
    this.baseUrl = this.getBaseUrl("", baseUrl);

    this.jsonParseReviver = (k, v) => dateReviver(k, v, dateProperties);
  }

  getCommissions(
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined,
    startAt: Date | null | undefined,
    endAt: Date | null | undefined
  ): Promise<SwaggerResponse<PaginatedOfCommissionDto>> {
    let url_ = this.baseUrl + "/commissions?";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    if (startAt !== undefined && startAt !== null)
      url_ +=
        "startAt=" +
        encodeURIComponent(startAt ? "" + startAt.toISOString() : "") +
        "&";
    if (endAt !== undefined && endAt !== null)
      url_ +=
        "endAt=" +
        encodeURIComponent(endAt ? "" + endAt.toISOString() : "") +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCommissions(_response);
      });
  }

  protected processGetCommissions(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfCommissionDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfCommissionDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfCommissionDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createCommission(
    model: CreateCommissionDto
  ): Promise<SwaggerResponse<CommissionDto>> {
    let url_ = this.baseUrl + "/commissions";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateCommission(_response);
      });
  }

  protected processCreateCommission(
    response: Response
  ): Promise<SwaggerResponse<CommissionDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as CommissionDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<CommissionDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getSuggestedColor(): Promise<SwaggerResponse<string>> {
    let url_ = this.baseUrl + "/commissions/suggestedColor";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetSuggestedColor(_response);
      });
  }

  protected processGetSuggestedColor(
    response: Response
  ): Promise<SwaggerResponse<string>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<string>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportCommissions(
    fields: string | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/commissions/export?";
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportCommissions(_response);
      });
  }

  protected processExportCommissions(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getCommissionSaleOrders(
    id: string,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined
  ): Promise<SwaggerResponse<PaginatedOfSaleOrderDto>> {
    let url_ = this.baseUrl + "/commissions/{id}/orders?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCommissionSaleOrders(_response);
      });
  }

  protected processGetCommissionSaleOrders(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfSaleOrderDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfSaleOrderDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfSaleOrderDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportCommissionSaleOrders(
    id: string,
    fields: string | undefined,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/commissions/{id}/orders/export?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportCommissionSaleOrders(_response);
      });
  }

  protected processExportCommissionSaleOrders(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getMyCommissions(
    startAt: Date | undefined,
    endAt: Date | undefined,
    sortBy: string | undefined,
    q: string | null | undefined
  ): Promise<SwaggerResponse<EmployeeCommissionDto[]>> {
    let url_ = this.baseUrl + "/employees/me/commissions?";
    if (startAt === null)
      throw new Error("The parameter 'startAt' cannot be null.");
    else if (startAt !== undefined)
      url_ +=
        "startAt=" +
        encodeURIComponent(startAt ? "" + startAt.toISOString() : "") +
        "&";
    if (endAt === null)
      throw new Error("The parameter 'endAt' cannot be null.");
    else if (endAt !== undefined)
      url_ +=
        "endAt=" +
        encodeURIComponent(endAt ? "" + endAt.toISOString() : "") +
        "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetMyCommissions(_response);
      });
  }

  protected processGetMyCommissions(
    response: Response
  ): Promise<SwaggerResponse<EmployeeCommissionDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as EmployeeCommissionDto[]);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<EmployeeCommissionDto[]>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getEmployeeCommissions(
    id: string,
    startAt: Date | undefined,
    endAt: Date | undefined,
    sortBy: string | undefined,
    q: string | null | undefined
  ): Promise<SwaggerResponse<EmployeeCommissionDto[]>> {
    let url_ = this.baseUrl + "/employees/{id}/commissions?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (startAt === null)
      throw new Error("The parameter 'startAt' cannot be null.");
    else if (startAt !== undefined)
      url_ +=
        "startAt=" +
        encodeURIComponent(startAt ? "" + startAt.toISOString() : "") +
        "&";
    if (endAt === null)
      throw new Error("The parameter 'endAt' cannot be null.");
    else if (endAt !== undefined)
      url_ +=
        "endAt=" +
        encodeURIComponent(endAt ? "" + endAt.toISOString() : "") +
        "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetEmployeeCommissions(_response);
      });
  }

  protected processGetEmployeeCommissions(
    response: Response
  ): Promise<SwaggerResponse<EmployeeCommissionDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as EmployeeCommissionDto[]);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<EmployeeCommissionDto[]>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  suspendCommission(
    id: string
  ): Promise<SwaggerResponse<EmployeeCommissionDto[]>> {
    let url_ = this.baseUrl + "/commission/{id}/suspend";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSuspendCommission(_response);
      });
  }

  protected processSuspendCommission(
    response: Response
  ): Promise<SwaggerResponse<EmployeeCommissionDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as EmployeeCommissionDto[]);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<EmployeeCommissionDto[]>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  resumeCommission(
    id: string
  ): Promise<SwaggerResponse<EmployeeCommissionDto[]>> {
    let url_ = this.baseUrl + "/commission/{id}/resume";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processResumeCommission(_response);
      });
  }

  protected processResumeCommission(
    response: Response
  ): Promise<SwaggerResponse<EmployeeCommissionDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as EmployeeCommissionDto[]);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<EmployeeCommissionDto[]>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getCommission(id: string): Promise<SwaggerResponse<CommissionDto>> {
    let url_ = this.baseUrl + "/commissions/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCommission(_response);
      });
  }

  protected processGetCommission(
    response: Response
  ): Promise<SwaggerResponse<CommissionDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as CommissionDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<CommissionDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateCommission(
    id: string,
    model: ManageCommissionDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/commissions/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateCommission(_response);
      });
  }

  protected processUpdateCommission(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateCommissionFromTemplate(
    id: string,
    fromTemplateId: string | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/commissions/{id}?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (fromTemplateId === null)
      throw new Error("The parameter 'fromTemplateId' cannot be null.");
    else if (fromTemplateId !== undefined)
      url_ += "fromTemplateId=" + encodeURIComponent("" + fromTemplateId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "PATCH",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateCommissionFromTemplate(_response);
      });
  }

  protected processUpdateCommissionFromTemplate(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteCommission(id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/commissions/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteCommission(_response);
      });
  }

  protected processDeleteCommission(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportCommercialReport(id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/commissions/{id}/exportCommercial";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportCommercialReport(_response);
      });
  }

  protected processExportCommercialReport(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getEmployeesAvailableForCommission(
    id: string,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfEmployeeOverviewDto>> {
    let url_ = this.baseUrl + "/commissions/{id}/employees/available?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetEmployeesAvailableForCommission(_response);
      });
  }

  protected processGetEmployeesAvailableForCommission(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfEmployeeOverviewDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfEmployeeOverviewDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfEmployeeOverviewDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getCommissionEmployees(
    id: string,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined,
    startAt: Date | null | undefined,
    endAt: Date | null | undefined
  ): Promise<SwaggerResponse<PaginatedOfCommissionEmployeeDto>> {
    let url_ = this.baseUrl + "/commissions/{id}/employees?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    if (startAt !== undefined && startAt !== null)
      url_ +=
        "startAt=" +
        encodeURIComponent(startAt ? "" + startAt.toISOString() : "") +
        "&";
    if (endAt !== undefined && endAt !== null)
      url_ +=
        "endAt=" +
        encodeURIComponent(endAt ? "" + endAt.toISOString() : "") +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCommissionEmployees(_response);
      });
  }

  protected processGetCommissionEmployees(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfCommissionEmployeeDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfCommissionEmployeeDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfCommissionEmployeeDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  addCommissionEmployees(
    id: string,
    model: AddCommissionEmployeesDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/commissions/{id}/employees";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAddCommissionEmployees(_response);
      });
  }

  protected processAddCommissionEmployees(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  removeCommissionEmployee(
    id: string,
    employeeId: string
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/commissions/{id}/employees/{employeeId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (employeeId === undefined || employeeId === null)
      throw new Error("The parameter 'employeeId' must be defined.");
    url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processRemoveCommissionEmployee(_response);
      });
  }

  protected processRemoveCommissionEmployee(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getCommissionTasks(
    commissionId: string,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfCommissionTaskDto>> {
    let url_ = this.baseUrl + "/commissions/{commissionId}/tasks?";
    if (commissionId === undefined || commissionId === null)
      throw new Error("The parameter 'commissionId' must be defined.");
    url_ = url_.replace(
      "{commissionId}",
      encodeURIComponent("" + commissionId)
    );
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCommissionTasks(_response);
      });
  }

  protected processGetCommissionTasks(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfCommissionTaskDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfCommissionTaskDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfCommissionTaskDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createCommissionTask(
    commissionId: string,
    model: ManageCommissionTaskDto
  ): Promise<SwaggerResponse<CommissionTaskDto>> {
    let url_ = this.baseUrl + "/commissions/{commissionId}/tasks";
    if (commissionId === undefined || commissionId === null)
      throw new Error("The parameter 'commissionId' must be defined.");
    url_ = url_.replace(
      "{commissionId}",
      encodeURIComponent("" + commissionId)
    );
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateCommissionTask(_response);
      });
  }

  protected processCreateCommissionTask(
    response: Response
  ): Promise<SwaggerResponse<CommissionTaskDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as CommissionTaskDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<CommissionTaskDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getCommissionTask(
    commissionId: string,
    taskId: string
  ): Promise<SwaggerResponse<CommissionTaskDto>> {
    let url_ = this.baseUrl + "/commissions/{commissionId}/tasks/{taskId}";
    if (commissionId === undefined || commissionId === null)
      throw new Error("The parameter 'commissionId' must be defined.");
    url_ = url_.replace(
      "{commissionId}",
      encodeURIComponent("" + commissionId)
    );
    if (taskId === undefined || taskId === null)
      throw new Error("The parameter 'taskId' must be defined.");
    url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCommissionTask(_response);
      });
  }

  protected processGetCommissionTask(
    response: Response
  ): Promise<SwaggerResponse<CommissionTaskDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as CommissionTaskDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<CommissionTaskDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateCommissionTask(
    commissionId: string,
    taskId: string,
    model: ManageCommissionTaskDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/commissions/{commissionId}/tasks/{taskId}";
    if (commissionId === undefined || commissionId === null)
      throw new Error("The parameter 'commissionId' must be defined.");
    url_ = url_.replace(
      "{commissionId}",
      encodeURIComponent("" + commissionId)
    );
    if (taskId === undefined || taskId === null)
      throw new Error("The parameter 'taskId' must be defined.");
    url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateCommissionTask(_response);
      });
  }

  protected processUpdateCommissionTask(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteCommissionTask(
    commissionId: string,
    taskId: string
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/commissions/{commissionId}/tasks/{taskId}";
    if (commissionId === undefined || commissionId === null)
      throw new Error("The parameter 'commissionId' must be defined.");
    url_ = url_.replace(
      "{commissionId}",
      encodeURIComponent("" + commissionId)
    );
    if (taskId === undefined || taskId === null)
      throw new Error("The parameter 'taskId' must be defined.");
    url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteCommissionTask(_response);
      });
  }

  protected processDeleteCommissionTask(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateCommissionTasksOrder(
    commissionId: string,
    taskId: string,
    model: ManageCommissionTasksOrderDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/commissions/{commissionId}/tasks/{taskId}/sort";
    if (commissionId === undefined || commissionId === null)
      throw new Error("The parameter 'commissionId' must be defined.");
    url_ = url_.replace(
      "{commissionId}",
      encodeURIComponent("" + commissionId)
    );
    if (taskId === undefined || taskId === null)
      throw new Error("The parameter 'taskId' must be defined.");
    url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateCommissionTasksOrder(_response);
      });
  }

  protected processUpdateCommissionTasksOrder(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getCommissionAssignments(
    commissionId: string,
    taskId: string,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfCommissionAssignmentDto>> {
    let url_ =
      this.baseUrl + "/commissions/{commissionId}/tasks/{taskId}/employees?";
    if (commissionId === undefined || commissionId === null)
      throw new Error("The parameter 'commissionId' must be defined.");
    url_ = url_.replace(
      "{commissionId}",
      encodeURIComponent("" + commissionId)
    );
    if (taskId === undefined || taskId === null)
      throw new Error("The parameter 'taskId' must be defined.");
    url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCommissionAssignments(_response);
      });
  }

  protected processGetCommissionAssignments(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfCommissionAssignmentDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfCommissionAssignmentDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfCommissionAssignmentDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getCommissionAssignment(
    commissionId: string,
    taskId: string,
    employeeId: string,
    skillId: string
  ): Promise<SwaggerResponse<CommissionAssignmentDto>> {
    let url_ =
      this.baseUrl +
      "/commissions/{commissionId}/tasks/{taskId}/employees/{employeeId}/skills/{skillId}";
    if (commissionId === undefined || commissionId === null)
      throw new Error("The parameter 'commissionId' must be defined.");
    url_ = url_.replace(
      "{commissionId}",
      encodeURIComponent("" + commissionId)
    );
    if (taskId === undefined || taskId === null)
      throw new Error("The parameter 'taskId' must be defined.");
    url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
    if (employeeId === undefined || employeeId === null)
      throw new Error("The parameter 'employeeId' must be defined.");
    url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
    if (skillId === undefined || skillId === null)
      throw new Error("The parameter 'skillId' must be defined.");
    url_ = url_.replace("{skillId}", encodeURIComponent("" + skillId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCommissionAssignment(_response);
      });
  }

  protected processGetCommissionAssignment(
    response: Response
  ): Promise<SwaggerResponse<CommissionAssignmentDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as CommissionAssignmentDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<CommissionAssignmentDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  addOrUpdateCommissionAssignment(
    commissionId: string,
    taskId: string,
    employeeId: string,
    skillId: string,
    model: ManageCommissionAssignmentDto
  ): Promise<SwaggerResponse<CommissionAssignmentDto>> {
    let url_ =
      this.baseUrl +
      "/commissions/{commissionId}/tasks/{taskId}/employees/{employeeId}/skills/{skillId}";
    if (commissionId === undefined || commissionId === null)
      throw new Error("The parameter 'commissionId' must be defined.");
    url_ = url_.replace(
      "{commissionId}",
      encodeURIComponent("" + commissionId)
    );
    if (taskId === undefined || taskId === null)
      throw new Error("The parameter 'taskId' must be defined.");
    url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
    if (employeeId === undefined || employeeId === null)
      throw new Error("The parameter 'employeeId' must be defined.");
    url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
    if (skillId === undefined || skillId === null)
      throw new Error("The parameter 'skillId' must be defined.");
    url_ = url_.replace("{skillId}", encodeURIComponent("" + skillId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAddOrUpdateCommissionAssignment(_response);
      });
  }

  protected processAddOrUpdateCommissionAssignment(
    response: Response
  ): Promise<SwaggerResponse<CommissionAssignmentDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as CommissionAssignmentDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<CommissionAssignmentDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  removeCommissionAssignment(
    commissionId: string,
    taskId: string,
    employeeId: string,
    skillId: string
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ =
      this.baseUrl +
      "/commissions/{commissionId}/tasks/{taskId}/employees/{employeeId}/skills/{skillId}";
    if (commissionId === undefined || commissionId === null)
      throw new Error("The parameter 'commissionId' must be defined.");
    url_ = url_.replace(
      "{commissionId}",
      encodeURIComponent("" + commissionId)
    );
    if (taskId === undefined || taskId === null)
      throw new Error("The parameter 'taskId' must be defined.");
    url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
    if (employeeId === undefined || employeeId === null)
      throw new Error("The parameter 'employeeId' must be defined.");
    url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
    if (skillId === undefined || skillId === null)
      throw new Error("The parameter 'skillId' must be defined.");
    url_ = url_.replace("{skillId}", encodeURIComponent("" + skillId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processRemoveCommissionAssignment(_response);
      });
  }

  protected processRemoveCommissionAssignment(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getCommissionItems(
    commissionId: string,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfCommissionItemDto>> {
    let url_ = this.baseUrl + "/commissions/{commissionId}/items?";
    if (commissionId === undefined || commissionId === null)
      throw new Error("The parameter 'commissionId' must be defined.");
    url_ = url_.replace(
      "{commissionId}",
      encodeURIComponent("" + commissionId)
    );
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCommissionItems(_response);
      });
  }

  protected processGetCommissionItems(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfCommissionItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfCommissionItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfCommissionItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createCommissionItem(
    commissionId: string,
    model: ManageCommissionItemDto
  ): Promise<SwaggerResponse<CommissionItemDto>> {
    let url_ = this.baseUrl + "/commissions/{commissionId}/items";
    if (commissionId === undefined || commissionId === null)
      throw new Error("The parameter 'commissionId' must be defined.");
    url_ = url_.replace(
      "{commissionId}",
      encodeURIComponent("" + commissionId)
    );
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateCommissionItem(_response);
      });
  }

  protected processCreateCommissionItem(
    response: Response
  ): Promise<SwaggerResponse<CommissionItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as CommissionItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<CommissionItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getCommissionItem(
    commissionId: string,
    itemId: string
  ): Promise<SwaggerResponse<CommissionItemDto>> {
    let url_ = this.baseUrl + "/commissions/{commissionId}/items/{itemId}";
    if (commissionId === undefined || commissionId === null)
      throw new Error("The parameter 'commissionId' must be defined.");
    url_ = url_.replace(
      "{commissionId}",
      encodeURIComponent("" + commissionId)
    );
    if (itemId === undefined || itemId === null)
      throw new Error("The parameter 'itemId' must be defined.");
    url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCommissionItem(_response);
      });
  }

  protected processGetCommissionItem(
    response: Response
  ): Promise<SwaggerResponse<CommissionItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as CommissionItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<CommissionItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateCommissionItem(
    commissionId: string,
    itemId: string,
    model: ManageCommissionItemDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/commissions/{commissionId}/items/{itemId}";
    if (commissionId === undefined || commissionId === null)
      throw new Error("The parameter 'commissionId' must be defined.");
    url_ = url_.replace(
      "{commissionId}",
      encodeURIComponent("" + commissionId)
    );
    if (itemId === undefined || itemId === null)
      throw new Error("The parameter 'itemId' must be defined.");
    url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateCommissionItem(_response);
      });
  }

  protected processUpdateCommissionItem(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteCommissionItem(
    commissionId: string,
    itemId: string
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/commissions/{commissionId}/items/{itemId}";
    if (commissionId === undefined || commissionId === null)
      throw new Error("The parameter 'commissionId' must be defined.");
    url_ = url_.replace(
      "{commissionId}",
      encodeURIComponent("" + commissionId)
    );
    if (itemId === undefined || itemId === null)
      throw new Error("The parameter 'itemId' must be defined.");
    url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteCommissionItem(_response);
      });
  }

  protected processDeleteCommissionItem(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  generateCommissionItemReport(
    commissionId: string,
    itemId: string,
    bomItemId: string
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ =
      this.baseUrl +
      "/commissions/{commissionId}/items/{itemId}/report/{bomItemId}";
    if (commissionId === undefined || commissionId === null)
      throw new Error("The parameter 'commissionId' must be defined.");
    url_ = url_.replace(
      "{commissionId}",
      encodeURIComponent("" + commissionId)
    );
    if (itemId === undefined || itemId === null)
      throw new Error("The parameter 'itemId' must be defined.");
    url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
    if (bomItemId === undefined || bomItemId === null)
      throw new Error("The parameter 'bomItemId' must be defined.");
    url_ = url_.replace("{bomItemId}", encodeURIComponent("" + bomItemId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGenerateCommissionItemReport(_response);
      });
  }

  protected processGenerateCommissionItemReport(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  generateCommissionItemsReport(
    commissionId: string,
    model: CommissionItemsReportDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/commissions/{commissionId}/items/reports";
    if (commissionId === undefined || commissionId === null)
      throw new Error("The parameter 'commissionId' must be defined.");
    url_ = url_.replace(
      "{commissionId}",
      encodeURIComponent("" + commissionId)
    );
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGenerateCommissionItemsReport(_response);
      });
  }

  protected processGenerateCommissionItemsReport(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getTemplateCommissions(
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfTemplateCommissionDto>> {
    let url_ = this.baseUrl + "/commissions/templates?";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetTemplateCommissions(_response);
      });
  }

  protected processGetTemplateCommissions(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfTemplateCommissionDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfTemplateCommissionDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfTemplateCommissionDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createTemplateCommission(
    model: ManageTemplateCommissionDto
  ): Promise<SwaggerResponse<TemplateCommissionDto>> {
    let url_ = this.baseUrl + "/commissions/templates";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateTemplateCommission(_response);
      });
  }

  protected processCreateTemplateCommission(
    response: Response
  ): Promise<SwaggerResponse<TemplateCommissionDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as TemplateCommissionDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<TemplateCommissionDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getTemplateCommission(
    id: string
  ): Promise<SwaggerResponse<TemplateCommissionDto>> {
    let url_ = this.baseUrl + "/commissions/templates/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetTemplateCommission(_response);
      });
  }

  protected processGetTemplateCommission(
    response: Response
  ): Promise<SwaggerResponse<TemplateCommissionDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as TemplateCommissionDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<TemplateCommissionDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateTemplateCommission(
    id: string,
    model: ManageTemplateCommissionDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/commissions/templates/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateTemplateCommission(_response);
      });
  }

  protected processUpdateTemplateCommission(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteTemplateCommission(id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/commissions/templates/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteTemplateCommission(_response);
      });
  }

  protected processDeleteTemplateCommission(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getTemplateCommissionTasks(
    templateId: string,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined
  ): Promise<SwaggerResponse<PaginatedOfTemplateCommissionTaskDto>> {
    let url_ = this.baseUrl + "/commissions/templates/{templateId}/tasks?";
    if (templateId === undefined || templateId === null)
      throw new Error("The parameter 'templateId' must be defined.");
    url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetTemplateCommissionTasks(_response);
      });
  }

  protected processGetTemplateCommissionTasks(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfTemplateCommissionTaskDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfTemplateCommissionTaskDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<
      SwaggerResponse<PaginatedOfTemplateCommissionTaskDto>
    >(new SwaggerResponse(status, _headers, null as any));
  }

  createTemplateCommissionTask(
    templateId: string,
    model: ManageTemplateCommissionTaskDto
  ): Promise<SwaggerResponse<TemplateCommissionTaskDto>> {
    let url_ = this.baseUrl + "/commissions/templates/{templateId}/tasks";
    if (templateId === undefined || templateId === null)
      throw new Error("The parameter 'templateId' must be defined.");
    url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateTemplateCommissionTask(_response);
      });
  }

  protected processCreateTemplateCommissionTask(
    response: Response
  ): Promise<SwaggerResponse<TemplateCommissionTaskDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as TemplateCommissionTaskDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<TemplateCommissionTaskDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getTemplateCommissionTask(
    templateId: string,
    id: string
  ): Promise<SwaggerResponse<TemplateCommissionTaskDto>> {
    let url_ = this.baseUrl + "/commissions/templates/{templateId}/tasks/{id}";
    if (templateId === undefined || templateId === null)
      throw new Error("The parameter 'templateId' must be defined.");
    url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetTemplateCommissionTask(_response);
      });
  }

  protected processGetTemplateCommissionTask(
    response: Response
  ): Promise<SwaggerResponse<TemplateCommissionTaskDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as TemplateCommissionTaskDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<TemplateCommissionTaskDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateTemplateCommissionTask(
    templateId: string,
    id: string,
    model: ManageTemplateCommissionTaskDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/commissions/templates/{templateId}/tasks/{id}";
    if (templateId === undefined || templateId === null)
      throw new Error("The parameter 'templateId' must be defined.");
    url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateTemplateCommissionTask(_response);
      });
  }

  protected processUpdateTemplateCommissionTask(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteTemplateCommissionTask(
    templateId: string,
    id: string
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/commissions/templates/{templateId}/tasks/{id}";
    if (templateId === undefined || templateId === null)
      throw new Error("The parameter 'templateId' must be defined.");
    url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteTemplateCommissionTask(_response);
      });
  }

  protected processDeleteTemplateCommissionTask(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getEmployeesAvailableForTemplateCommission(
    templateId: string,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfEmployeeOverviewDto>> {
    let url_ =
      this.baseUrl + "/commissions/templates/{templateId}/employees/available?";
    if (templateId === undefined || templateId === null)
      throw new Error("The parameter 'templateId' must be defined.");
    url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetEmployeesAvailableForTemplateCommission(
          _response
        );
      });
  }

  protected processGetEmployeesAvailableForTemplateCommission(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfEmployeeOverviewDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfEmployeeOverviewDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfEmployeeOverviewDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getTemplateCommissionEmployees(
    templateId: string,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined
  ): Promise<SwaggerResponse<PaginatedOfTemplateCommissionEmployeeDto>> {
    let url_ = this.baseUrl + "/commissions/templates/{templateId}/employees?";
    if (templateId === undefined || templateId === null)
      throw new Error("The parameter 'templateId' must be defined.");
    url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetTemplateCommissionEmployees(_response);
      });
  }

  protected processGetTemplateCommissionEmployees(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfTemplateCommissionEmployeeDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfTemplateCommissionEmployeeDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<
      SwaggerResponse<PaginatedOfTemplateCommissionEmployeeDto>
    >(new SwaggerResponse(status, _headers, null as any));
  }

  addTemplateCommissionEmployees(
    templateId: string,
    model: AddTemplateCommissionEmployeesDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/commissions/templates/{templateId}/employees";
    if (templateId === undefined || templateId === null)
      throw new Error("The parameter 'templateId' must be defined.");
    url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAddTemplateCommissionEmployees(_response);
      });
  }

  protected processAddTemplateCommissionEmployees(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  removeTemplateCommissionEmployee(
    templateId: string,
    employeeId: string
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ =
      this.baseUrl +
      "/commissions/templates/{templateId}/employees/{employeeId}";
    if (templateId === undefined || templateId === null)
      throw new Error("The parameter 'templateId' must be defined.");
    url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
    if (employeeId === undefined || employeeId === null)
      throw new Error("The parameter 'employeeId' must be defined.");
    url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processRemoveTemplateCommissionEmployee(_response);
      });
  }

  protected processRemoveTemplateCommissionEmployee(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getTemplateCommissionAssignments(
    templateId: string,
    taskId: string,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfTemplateCommissionAssignmentDto>> {
    let url_ =
      this.baseUrl +
      "/commissions/templates/{templateId}/tasks/{taskId}/employees?";
    if (templateId === undefined || templateId === null)
      throw new Error("The parameter 'templateId' must be defined.");
    url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
    if (taskId === undefined || taskId === null)
      throw new Error("The parameter 'taskId' must be defined.");
    url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetTemplateCommissionAssignments(_response);
      });
  }

  protected processGetTemplateCommissionAssignments(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfTemplateCommissionAssignmentDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfTemplateCommissionAssignmentDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<
      SwaggerResponse<PaginatedOfTemplateCommissionAssignmentDto>
    >(new SwaggerResponse(status, _headers, null as any));
  }

  getTemplateCommissionAssignment(
    templateId: string,
    taskId: string,
    employeeId: string,
    skillId: string
  ): Promise<SwaggerResponse<TemplateCommissionAssignmentDto>> {
    let url_ =
      this.baseUrl +
      "/commissions/templates/{templateId}/tasks/{taskId}/employees/{employeeId}/skills/{skillId}";
    if (templateId === undefined || templateId === null)
      throw new Error("The parameter 'templateId' must be defined.");
    url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
    if (taskId === undefined || taskId === null)
      throw new Error("The parameter 'taskId' must be defined.");
    url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
    if (employeeId === undefined || employeeId === null)
      throw new Error("The parameter 'employeeId' must be defined.");
    url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
    if (skillId === undefined || skillId === null)
      throw new Error("The parameter 'skillId' must be defined.");
    url_ = url_.replace("{skillId}", encodeURIComponent("" + skillId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetTemplateCommissionAssignment(_response);
      });
  }

  protected processGetTemplateCommissionAssignment(
    response: Response
  ): Promise<SwaggerResponse<TemplateCommissionAssignmentDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as TemplateCommissionAssignmentDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<TemplateCommissionAssignmentDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  addOrUpdateTemplateCommissionAssignment(
    templateId: string,
    taskId: string,
    employeeId: string,
    skillId: string
  ): Promise<SwaggerResponse<TemplateCommissionAssignmentDto>> {
    let url_ =
      this.baseUrl +
      "/commissions/templates/{templateId}/tasks/{taskId}/employees/{employeeId}/skills/{skillId}";
    if (templateId === undefined || templateId === null)
      throw new Error("The parameter 'templateId' must be defined.");
    url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
    if (taskId === undefined || taskId === null)
      throw new Error("The parameter 'taskId' must be defined.");
    url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
    if (employeeId === undefined || employeeId === null)
      throw new Error("The parameter 'employeeId' must be defined.");
    url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
    if (skillId === undefined || skillId === null)
      throw new Error("The parameter 'skillId' must be defined.");
    url_ = url_.replace("{skillId}", encodeURIComponent("" + skillId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "PUT",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAddOrUpdateTemplateCommissionAssignment(_response);
      });
  }

  protected processAddOrUpdateTemplateCommissionAssignment(
    response: Response
  ): Promise<SwaggerResponse<TemplateCommissionAssignmentDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as TemplateCommissionAssignmentDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<TemplateCommissionAssignmentDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  removeTemplateCommissionAssignment(
    templateId: string,
    taskId: string,
    employeeId: string,
    skillId: string
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ =
      this.baseUrl +
      "/commissions/templates/{templateId}/tasks/{taskId}/employees/{employeeId}/skills/{skillId}";
    if (templateId === undefined || templateId === null)
      throw new Error("The parameter 'templateId' must be defined.");
    url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
    if (taskId === undefined || taskId === null)
      throw new Error("The parameter 'taskId' must be defined.");
    url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
    if (employeeId === undefined || employeeId === null)
      throw new Error("The parameter 'employeeId' must be defined.");
    url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
    if (skillId === undefined || skillId === null)
      throw new Error("The parameter 'skillId' must be defined.");
    url_ = url_.replace("{skillId}", encodeURIComponent("" + skillId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processRemoveTemplateCommissionAssignment(_response);
      });
  }

  protected processRemoveTemplateCommissionAssignment(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }
}

export class CompanyClient extends GestitClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: GestitClientOptions,
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    super(configuration);
    this.http = http ? http : (window as any);
    this.baseUrl = this.getBaseUrl("", baseUrl);
  }

  getConfiguration(): Promise<SwaggerResponse<ConfigurationDto>> {
    let url_ = this.baseUrl + "/configuration";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetConfiguration(_response);
      });
  }

  protected processGetConfiguration(
    response: Response
  ): Promise<SwaggerResponse<ConfigurationDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as ConfigurationDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ConfigurationDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  saveCompanyConfiguration(
    model: ManageCompanyConfigurationDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/configuration/saveCompany";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSaveCompanyConfiguration(_response);
      });
  }

  protected processSaveCompanyConfiguration(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getCompanyOffice(id: string): Promise<SwaggerResponse<CompanyOfficeDto>> {
    let url_ = this.baseUrl + "/offices/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCompanyOffice(_response);
      });
  }

  protected processGetCompanyOffice(
    response: Response
  ): Promise<SwaggerResponse<CompanyOfficeDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as CompanyOfficeDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<CompanyOfficeDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getCompanyOffices(
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfCompanyOfficeDto>> {
    let url_ = this.baseUrl + "/offices?";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCompanyOffices(_response);
      });
  }

  protected processGetCompanyOffices(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfCompanyOfficeDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfCompanyOfficeDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfCompanyOfficeDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  addCompanyOffice(
    model: CompanyOfficeManageDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/offices";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAddCompanyOffice(_response);
      });
  }

  protected processAddCompanyOffice(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  editCompanyOffice(
    id: string | undefined,
    model: CompanyOfficeManageDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/offices?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processEditCompanyOffice(_response);
      });
  }

  protected processEditCompanyOffice(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteCompanyOffice(
    id: string | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/offices?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteCompanyOffice(_response);
      });
  }

  protected processDeleteCompanyOffice(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }
}

export class CountriesClient extends GestitClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: GestitClientOptions,
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    super(configuration);
    this.http = http ? http : (window as any);
    this.baseUrl = this.getBaseUrl("", baseUrl);
  }

  getCountries(
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfCountryDto>> {
    let url_ = this.baseUrl + "/countries?";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCountries(_response);
      });
  }

  protected processGetCountries(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfCountryDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfCountryDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfCountryDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getCountry(code: string): Promise<SwaggerResponse<CountryDto>> {
    let url_ = this.baseUrl + "/countries/{code}";
    if (code === undefined || code === null)
      throw new Error("The parameter 'code' must be defined.");
    url_ = url_.replace("{code}", encodeURIComponent("" + code));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCountry(_response);
      });
  }

  protected processGetCountry(
    response: Response
  ): Promise<SwaggerResponse<CountryDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as CountryDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<CountryDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }
}

export class CurrencyClient extends GestitClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: GestitClientOptions,
    baseUrl?: string,
    http?: {
      fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
    }
  ) {
    super(configuration);

    // @ts-ignore
    this.http = http ? http : (window as any);
    // @ts-ignore
    this.baseUrl = this.getBaseUrl("", baseUrl);

    this.jsonParseReviver = (k, v) => dateReviver(k, v, dateProperties);
  }

  getCurrencies(
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfCurrencyDto>> {
    let url_ = this.baseUrl + "/currencies?";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCurrencies(_response);
      });
  }

  protected processGetCurrencies(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfCurrencyDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfCurrencyDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfCurrencyDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createCurrency(
    model: ManageCurrencyDto
  ): Promise<SwaggerResponse<CurrencyDto>> {
    let url_ = this.baseUrl + "/currencies";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateCurrency(_response);
      });
  }

  protected processCreateCurrency(
    response: Response
  ): Promise<SwaggerResponse<CurrencyDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as CurrencyDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<CurrencyDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportCurrencies(
    fields: string | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/currencies/export?";
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportCurrencies(_response);
      });
  }

  protected processExportCurrencies(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getCurrency(id: string): Promise<SwaggerResponse<CurrencyDto>> {
    let url_ = this.baseUrl + "/currencies/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCurrency(_response);
      });
  }

  protected processGetCurrency(
    response: Response
  ): Promise<SwaggerResponse<CurrencyDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as CurrencyDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<CurrencyDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateCurrency(
    id: string,
    model: ManageCurrencyDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/currencies/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateCurrency(_response);
      });
  }

  protected processUpdateCurrency(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteCurrency(id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/currencies/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteCurrency(_response);
      });
  }

  protected processDeleteCurrency(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }
}

export class CustomersClient extends GestitClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: GestitClientOptions,
    baseUrl?: string,
    http?: {
      fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
    }
  ) {
    super(configuration);

    // @ts-ignore
    this.http = http ? http : (window as any);
    // @ts-ignore
    this.baseUrl = this.getBaseUrl("", baseUrl);

    this.jsonParseReviver = (k, v) => dateReviver(k, v, dateProperties);
  }

  getCustomers(
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfCustomerDto>> {
    let url_ = this.baseUrl + "/customers?";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCustomers(_response);
      });
  }

  protected processGetCustomers(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfCustomerDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfCustomerDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfCustomerDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createCustomer(
    model: ManageCustomerDto
  ): Promise<SwaggerResponse<CustomerDto>> {
    let url_ = this.baseUrl + "/customers";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateCustomer(_response);
      });
  }

  protected processCreateCustomer(
    response: Response
  ): Promise<SwaggerResponse<CustomerDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as CustomerDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<CustomerDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportCustomers(
    fields: string | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/customers/export?";
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportCustomers(_response);
      });
  }

  protected processExportCustomers(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getDefaultCustomer(): Promise<SwaggerResponse<CustomerDto>> {
    let url_ = this.baseUrl + "/customers/default";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetDefaultCustomer(_response);
      });
  }

  protected processGetDefaultCustomer(
    response: Response
  ): Promise<SwaggerResponse<CustomerDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as CustomerDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<CustomerDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getCustomer(id: string): Promise<SwaggerResponse<CustomerDto>> {
    let url_ = this.baseUrl + "/customers/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCustomer(_response);
      });
  }

  protected processGetCustomer(
    response: Response
  ): Promise<SwaggerResponse<CustomerDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as CustomerDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<CustomerDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateCustomer(
    id: string,
    model: ManageCustomerDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/customers/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateCustomer(_response);
      });
  }

  protected processUpdateCustomer(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteCustomer(id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/customers/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteCustomer(_response);
      });
  }

  protected processDeleteCustomer(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getCustomerContacts(
    id: string,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfCustomerContactDto>> {
    let url_ = this.baseUrl + "/customers/{id}/contacts?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCustomerContacts(_response);
      });
  }

  protected processGetCustomerContacts(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfCustomerContactDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfCustomerContactDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfCustomerContactDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createCustomerContact(
    id: string,
    model: CustomerContactManageDto
  ): Promise<SwaggerResponse<CustomerContactDto>> {
    let url_ = this.baseUrl + "/customers/{id}/contacts";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateCustomerContact(_response);
      });
  }

  protected processCreateCustomerContact(
    response: Response
  ): Promise<SwaggerResponse<CustomerContactDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as CustomerContactDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<CustomerContactDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteCustomerContact(
    id: string,
    contactId: string
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/customers/{id}/contacts/{contactId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (contactId === undefined || contactId === null)
      throw new Error("The parameter 'contactId' must be defined.");
    url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteCustomerContact(_response);
      });
  }

  protected processDeleteCustomerContact(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateCustomerContact(
    id: string,
    contactId: string,
    model: CustomerContactManageDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/customers/{id}/contacts/{contactId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (contactId === undefined || contactId === null)
      throw new Error("The parameter 'contactId' must be defined.");
    url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateCustomerContact(_response);
      });
  }

  protected processUpdateCustomerContact(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getCustomerContact(
    id: string,
    contactId: string
  ): Promise<SwaggerResponse<CustomerContactDto>> {
    let url_ = this.baseUrl + "/customers/{id}/contacts/{contactId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (contactId === undefined || contactId === null)
      throw new Error("The parameter 'contactId' must be defined.");
    url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCustomerContact(_response);
      });
  }

  protected processGetCustomerContact(
    response: Response
  ): Promise<SwaggerResponse<CustomerContactDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as CustomerContactDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<CustomerContactDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getCustomerOffices(
    id: string,
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfCustomerOfficeDto>> {
    let url_ = this.baseUrl + "/customers/{id}/offices?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCustomerOffices(_response);
      });
  }

  protected processGetCustomerOffices(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfCustomerOfficeDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfCustomerOfficeDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfCustomerOfficeDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createCustomerOffice(
    id: string,
    model: CustomerOfficeManageDto
  ): Promise<SwaggerResponse<CustomerOfficeDto>> {
    let url_ = this.baseUrl + "/customers/{id}/offices";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateCustomerOffice(_response);
      });
  }

  protected processCreateCustomerOffice(
    response: Response
  ): Promise<SwaggerResponse<CustomerOfficeDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as CustomerOfficeDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<CustomerOfficeDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateCustomerOffice(
    id: string,
    customerOfficeId: string,
    model: CustomerOfficeManageDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/customers/{id}/offices/{customerOfficeId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (customerOfficeId === undefined || customerOfficeId === null)
      throw new Error("The parameter 'customerOfficeId' must be defined.");
    url_ = url_.replace(
      "{customerOfficeId}",
      encodeURIComponent("" + customerOfficeId)
    );
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateCustomerOffice(_response);
      });
  }

  protected processUpdateCustomerOffice(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getCustomerOffice(
    id: string,
    customerOfficeId: string
  ): Promise<SwaggerResponse<CustomerOfficeDto>> {
    let url_ = this.baseUrl + "/customers/{id}/offices/{customerOfficeId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (customerOfficeId === undefined || customerOfficeId === null)
      throw new Error("The parameter 'customerOfficeId' must be defined.");
    url_ = url_.replace(
      "{customerOfficeId}",
      encodeURIComponent("" + customerOfficeId)
    );
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCustomerOffice(_response);
      });
  }

  protected processGetCustomerOffice(
    response: Response
  ): Promise<SwaggerResponse<CustomerOfficeDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as CustomerOfficeDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<CustomerOfficeDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteCustomerOffice(
    id: string,
    customerOfficeId: string
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/customers/{id}/offices/{customerOfficeId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (customerOfficeId === undefined || customerOfficeId === null)
      throw new Error("The parameter 'customerOfficeId' must be defined.");
    url_ = url_.replace(
      "{customerOfficeId}",
      encodeURIComponent("" + customerOfficeId)
    );
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteCustomerOffice(_response);
      });
  }

  protected processDeleteCustomerOffice(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getCustomerDeclarationsOfIntent(
    id: string,
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfCustomerDeclarationOfIntentDto>> {
    let url_ = this.baseUrl + "/customers/{id}/declarationsOfIntent?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCustomerDeclarationsOfIntent(_response);
      });
  }

  protected processGetCustomerDeclarationsOfIntent(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfCustomerDeclarationOfIntentDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfCustomerDeclarationOfIntentDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<
      SwaggerResponse<PaginatedOfCustomerDeclarationOfIntentDto>
    >(new SwaggerResponse(status, _headers, null as any));
  }

  createCustomerDeclarationOfIntent(
    id: string,
    model: ManageCustomerDeclarationOfIntentDto
  ): Promise<SwaggerResponse<CustomerDeclarationOfIntentDto>> {
    let url_ = this.baseUrl + "/customers/{id}/declarationsOfIntent";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateCustomerDeclarationOfIntent(_response);
      });
  }

  protected processCreateCustomerDeclarationOfIntent(
    response: Response
  ): Promise<SwaggerResponse<CustomerDeclarationOfIntentDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as CustomerDeclarationOfIntentDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<CustomerDeclarationOfIntentDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getCustomerDeclarationOfIntent(
    id: string,
    declarationOfIntentId: string
  ): Promise<SwaggerResponse<CustomerDeclarationOfIntentDto>> {
    let url_ =
      this.baseUrl +
      "/customers/{id}/declarationsOfIntent/{declarationOfIntentId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (declarationOfIntentId === undefined || declarationOfIntentId === null)
      throw new Error("The parameter 'declarationOfIntentId' must be defined.");
    url_ = url_.replace(
      "{declarationOfIntentId}",
      encodeURIComponent("" + declarationOfIntentId)
    );
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCustomerDeclarationOfIntent(_response);
      });
  }

  protected processGetCustomerDeclarationOfIntent(
    response: Response
  ): Promise<SwaggerResponse<CustomerDeclarationOfIntentDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as CustomerDeclarationOfIntentDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<CustomerDeclarationOfIntentDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteCustomerDeclarationOfIntent(
    id: string,
    declarationOfIntentId: string
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ =
      this.baseUrl +
      "/customers/{id}/declarationsOfIntent/{declarationOfIntentId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (declarationOfIntentId === undefined || declarationOfIntentId === null)
      throw new Error("The parameter 'declarationOfIntentId' must be defined.");
    url_ = url_.replace(
      "{declarationOfIntentId}",
      encodeURIComponent("" + declarationOfIntentId)
    );
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteCustomerDeclarationOfIntent(_response);
      });
  }

  protected processDeleteCustomerDeclarationOfIntent(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateCustomerDeclarationOfIntent(
    id: string,
    declarationOfIntentId: string,
    model: ManageCustomerDeclarationOfIntentDto
  ): Promise<SwaggerResponse<CustomerDeclarationOfIntentDto>> {
    let url_ =
      this.baseUrl +
      "/customers/{id}/declarationsOfIntent/{declarationOfIntentId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (declarationOfIntentId === undefined || declarationOfIntentId === null)
      throw new Error("The parameter 'declarationOfIntentId' must be defined.");
    url_ = url_.replace(
      "{declarationOfIntentId}",
      encodeURIComponent("" + declarationOfIntentId)
    );
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateCustomerDeclarationOfIntent(_response);
      });
  }

  protected processUpdateCustomerDeclarationOfIntent(
    response: Response
  ): Promise<SwaggerResponse<CustomerDeclarationOfIntentDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as CustomerDeclarationOfIntentDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<CustomerDeclarationOfIntentDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getCustomerDeclarationOfIntentForDate(
    id: string,
    date: Date
  ): Promise<SwaggerResponse<CustomerDeclarationOfIntentDto>> {
    let url_ =
      this.baseUrl + "/customers/{id}/declarationsOfIntent/dates/{date}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (date === undefined || date === null)
      throw new Error("The parameter 'date' must be defined.");
    url_ = url_.replace(
      "{date}",
      encodeURIComponent(date ? "" + date.toISOString() : "null")
    );
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCustomerDeclarationOfIntentForDate(_response);
      });
  }

  protected processGetCustomerDeclarationOfIntentForDate(
    response: Response
  ): Promise<SwaggerResponse<CustomerDeclarationOfIntentDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as CustomerDeclarationOfIntentDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<CustomerDeclarationOfIntentDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getSubCustomers(
    id: string,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfCustomerDto>> {
    let url_ = this.baseUrl + "/customers/{id}/subCustomers?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetSubCustomers(_response);
      });
  }

  protected processGetSubCustomers(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfCustomerDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfCustomerDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfCustomerDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getCustomerDeliveryDocuments(
    id: string,
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfDeliveryDocumentDto>> {
    let url_ = this.baseUrl + "/customers/{id}/deliveryDocuments?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCustomerDeliveryDocuments(_response);
      });
  }

  protected processGetCustomerDeliveryDocuments(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfDeliveryDocumentDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfDeliveryDocumentDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfDeliveryDocumentDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }
}

export class DefaultsClient extends GestitClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: GestitClientOptions,
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    super(configuration);
    this.http = http ? http : (window as any);
    this.baseUrl = this.getBaseUrl("", baseUrl);
  }

  getDefaults(): Promise<SwaggerResponse<DefaultsDto>> {
    let url_ = this.baseUrl + "/defaults";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetDefaults(_response);
      });
  }

  protected processGetDefaults(
    response: Response
  ): Promise<SwaggerResponse<DefaultsDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as DefaultsDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<DefaultsDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  saveDefaults(
    model: ManageDefaultsDto
  ): Promise<SwaggerResponse<DefaultsDto>> {
    let url_ = this.baseUrl + "/defaults";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSaveDefaults(_response);
      });
  }

  protected processSaveDefaults(
    response: Response
  ): Promise<SwaggerResponse<DefaultsDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as DefaultsDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<DefaultsDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }
}

export class DeliveryDocumentsClient extends GestitClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: GestitClientOptions,
    baseUrl?: string,
    http?: {
      fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
    }
  ) {
    super(configuration);

    // @ts-ignore
    this.http = http ? http : (window as any);
    // @ts-ignore
    this.baseUrl = this.getBaseUrl("", baseUrl);

    this.jsonParseReviver = (k, v) => dateReviver(k, v, dateProperties);
  }

  getDeliveryDocuments(
    target: DocumentTarget | undefined,
    sortBy: string | null | undefined,
    filterBy: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined,
    includeTotals: boolean | undefined
  ): Promise<SwaggerResponse<PaginatedWithTotalOfDeliveryDocumentDto>> {
    let url_ = this.baseUrl + "/deliveryDocuments?";
    if (target === null)
      throw new Error("The parameter 'target' cannot be null.");
    else if (target !== undefined)
      url_ += "target=" + encodeURIComponent("" + target) + "&";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (filterBy !== undefined && filterBy !== null)
      url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    if (includeTotals === null)
      throw new Error("The parameter 'includeTotals' cannot be null.");
    else if (includeTotals !== undefined)
      url_ += "includeTotals=" + encodeURIComponent("" + includeTotals) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetDeliveryDocuments(_response);
      });
  }

  protected processGetDeliveryDocuments(
    response: Response
  ): Promise<SwaggerResponse<PaginatedWithTotalOfDeliveryDocumentDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedWithTotalOfDeliveryDocumentDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<
      SwaggerResponse<PaginatedWithTotalOfDeliveryDocumentDto>
    >(new SwaggerResponse(status, _headers, null as any));
  }

  createDeliveryDocument(
    model: ManageDeliveryDocumentDto
  ): Promise<SwaggerResponse<DeliveryDocumentDto>> {
    let url_ = this.baseUrl + "/deliveryDocuments";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateDeliveryDocument(_response);
      });
  }

  protected processCreateDeliveryDocument(
    response: Response
  ): Promise<SwaggerResponse<DeliveryDocumentDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as DeliveryDocumentDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<DeliveryDocumentDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  checkValidDeliveryDocumentTaxable(
    id: string,
    itemId: string | null | undefined,
    nextItemPrice: number | undefined
  ): Promise<SwaggerResponse<boolean>> {
    let url_ = this.baseUrl + "/deliveryDocuments/{id}/checkTaxable?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (itemId !== undefined && itemId !== null)
      url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
    if (nextItemPrice === null)
      throw new Error("The parameter 'nextItemPrice' cannot be null.");
    else if (nextItemPrice !== undefined)
      url_ += "nextItemPrice=" + encodeURIComponent("" + nextItemPrice) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCheckValidDeliveryDocumentTaxable(_response);
      });
  }

  protected processCheckValidDeliveryDocumentTaxable(
    response: Response
  ): Promise<SwaggerResponse<boolean>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<boolean>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getDeliveryDocumentsAvailableForItem(
    itemId: string | undefined,
    sampleId: string | undefined,
    sortBy: string | null | undefined,
    filterBy: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined
  ): Promise<SwaggerResponse<PaginatedOfDeliveryDocumentDto>> {
    let url_ = this.baseUrl + "/deliveryDocuments/available?";
    if (itemId === null)
      throw new Error("The parameter 'itemId' cannot be null.");
    else if (itemId !== undefined)
      url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
    if (sampleId === null)
      throw new Error("The parameter 'sampleId' cannot be null.");
    else if (sampleId !== undefined)
      url_ += "sampleId=" + encodeURIComponent("" + sampleId) + "&";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (filterBy !== undefined && filterBy !== null)
      url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetDeliveryDocumentsAvailableForItem(_response);
      });
  }

  protected processGetDeliveryDocumentsAvailableForItem(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfDeliveryDocumentDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfDeliveryDocumentDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfDeliveryDocumentDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportDeliveryDocuments(
    target: DocumentTarget | undefined,
    fields: string | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/deliveryDocuments/export?";
    if (target === null)
      throw new Error("The parameter 'target' cannot be null.");
    else if (target !== undefined)
      url_ += "target=" + encodeURIComponent("" + target) + "&";
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportDeliveryDocuments(_response);
      });
  }

  protected processExportDeliveryDocuments(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateDeliveryDocument(
    id: string,
    model: ManageDeliveryDocumentDto
  ): Promise<SwaggerResponse<DeliveryDocumentDto>> {
    let url_ = this.baseUrl + "/deliveryDocuments/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateDeliveryDocument(_response);
      });
  }

  protected processUpdateDeliveryDocument(
    response: Response
  ): Promise<SwaggerResponse<DeliveryDocumentDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as DeliveryDocumentDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<DeliveryDocumentDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteDeliveryDocument(id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/deliveryDocuments/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteDeliveryDocument(_response);
      });
  }

  protected processDeleteDeliveryDocument(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getDeliveryDocument(
    id: string
  ): Promise<SwaggerResponse<DeliveryDocumentDto>> {
    let url_ = this.baseUrl + "/deliveryDocuments/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetDeliveryDocument(_response);
      });
  }

  protected processGetDeliveryDocument(
    response: Response
  ): Promise<SwaggerResponse<DeliveryDocumentDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as DeliveryDocumentDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<DeliveryDocumentDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getDeliveryDocumentSaleOrders(
    id: string,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined
  ): Promise<SwaggerResponse<PaginatedOfSaleOrderDto>> {
    let url_ = this.baseUrl + "/deliveryDocuments/{id}/orders?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetDeliveryDocumentSaleOrders(_response);
      });
  }

  protected processGetDeliveryDocumentSaleOrders(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfSaleOrderDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfSaleOrderDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfSaleOrderDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportDeliveryDocumentSaleOrders(
    id: string,
    fields: string | undefined,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/deliveryDocuments/{id}/orders/export?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportDeliveryDocumentSaleOrders(_response);
      });
  }

  protected processExportDeliveryDocumentSaleOrders(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getDeliveryDocumentBillingDocuments(
    id: string,
    sortBy: string | null | undefined,
    filterBy: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined
  ): Promise<SwaggerResponse<PaginatedOfBillingDocumentDto>> {
    let url_ = this.baseUrl + "/deliveryDocuments/{id}/billingDocuments?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (filterBy !== undefined && filterBy !== null)
      url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetDeliveryDocumentBillingDocuments(_response);
      });
  }

  protected processGetDeliveryDocumentBillingDocuments(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfBillingDocumentDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfBillingDocumentDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfBillingDocumentDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportDeliveryDocumentBillingDocuments(
    id: string,
    fields: string | undefined,
    sortBy: string | null | undefined,
    filterBy: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ =
      this.baseUrl + "/deliveryDocuments/{id}/billingDocuments/export?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (filterBy !== undefined && filterBy !== null)
      url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportDeliveryDocumentBillingDocuments(_response);
      });
  }

  protected processExportDeliveryDocumentBillingDocuments(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  generateDeliveryDocumentReport(
    id: string,
    reportType: DeliveryDocumentReportType | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/deliveryDocuments/{id}/report?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (reportType === null)
      throw new Error("The parameter 'reportType' cannot be null.");
    else if (reportType !== undefined)
      url_ += "reportType=" + encodeURIComponent("" + reportType) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGenerateDeliveryDocumentReport(_response);
      });
  }

  protected processGenerateDeliveryDocumentReport(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getDeliveryDocumentItems(
    id: string,
    sortBy: string | null | undefined,
    filterBy: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined
  ): Promise<SwaggerResponse<PaginatedOfDeliveryDocumentItemDto>> {
    let url_ = this.baseUrl + "/deliveryDocuments/{id}/items?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (filterBy !== undefined && filterBy !== null)
      url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetDeliveryDocumentItems(_response);
      });
  }

  protected processGetDeliveryDocumentItems(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfDeliveryDocumentItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfDeliveryDocumentItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfDeliveryDocumentItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  addDeliveryDocumentItem(
    id: string,
    model: ManageDeliveryDocumentItemDto
  ): Promise<SwaggerResponse<DeliveryDocumentItemDto>> {
    let url_ = this.baseUrl + "/deliveryDocuments/{id}/items";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAddDeliveryDocumentItem(_response);
      });
  }

  protected processAddDeliveryDocumentItem(
    response: Response
  ): Promise<SwaggerResponse<DeliveryDocumentItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as DeliveryDocumentItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<DeliveryDocumentItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportDeliveryDocumentItems(
    id: string,
    fields: string | undefined,
    sortBy: string | null | undefined,
    filterBy: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/deliveryDocuments/{id}/items/export?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (filterBy !== undefined && filterBy !== null)
      url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportDeliveryDocumentItems(_response);
      });
  }

  protected processExportDeliveryDocumentItems(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getOrderItemsAvailableForDeliveryDocument(
    id: string,
    filterBy: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined
  ): Promise<SwaggerResponse<PaginatedOfSaleOrderItemDto>> {
    let url_ = this.baseUrl + "/deliveryDocuments/{id}/ordersItems/available?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (filterBy !== undefined && filterBy !== null)
      url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetOrderItemsAvailableForDeliveryDocument(_response);
      });
  }

  protected processGetOrderItemsAvailableForDeliveryDocument(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfSaleOrderItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfSaleOrderItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfSaleOrderItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createDeliveryDocumentItemFromOrdersItems(
    id: string,
    orderItems: ManageSaleOrderItemForDocumentDto[]
  ): Promise<SwaggerResponse<DeliveryDocumentItemDto[]>> {
    let url_ = this.baseUrl + "/deliveryDocuments/{id}/items/fromOrdersItems";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(orderItems);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateDeliveryDocumentItemFromOrdersItems(_response);
      });
  }

  protected processCreateDeliveryDocumentItemFromOrdersItems(
    response: Response
  ): Promise<SwaggerResponse<DeliveryDocumentItemDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as DeliveryDocumentItemDto[]);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<DeliveryDocumentItemDto[]>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getDeliveryDocumentItemsAvailable(
    id: string,
    sortBy: string | null | undefined,
    filterBy: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfItemDto>> {
    let url_ = this.baseUrl + "/deliveryDocuments/{id}/items/available?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (filterBy !== undefined && filterBy !== null)
      url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetDeliveryDocumentItemsAvailable(_response);
      });
  }

  protected processGetDeliveryDocumentItemsAvailable(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateDeliveryDocumentItemOrder(
    id: string,
    deliveryDocumentItemId: string,
    model: ManageDeliveryDocumentItemsOrderDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ =
      this.baseUrl +
      "/deliveryDocuments/{id}/items/{deliveryDocumentItemId}/sort";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (deliveryDocumentItemId === undefined || deliveryDocumentItemId === null)
      throw new Error(
        "The parameter 'deliveryDocumentItemId' must be defined."
      );
    url_ = url_.replace(
      "{deliveryDocumentItemId}",
      encodeURIComponent("" + deliveryDocumentItemId)
    );
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateDeliveryDocumentItemOrder(_response);
      });
  }

  protected processUpdateDeliveryDocumentItemOrder(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  removeDeliveryDocumentItem(
    id: string,
    deliveryDocumentItemId: string
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ =
      this.baseUrl + "/deliveryDocuments/{id}/items/{deliveryDocumentItemId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (deliveryDocumentItemId === undefined || deliveryDocumentItemId === null)
      throw new Error(
        "The parameter 'deliveryDocumentItemId' must be defined."
      );
    url_ = url_.replace(
      "{deliveryDocumentItemId}",
      encodeURIComponent("" + deliveryDocumentItemId)
    );
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processRemoveDeliveryDocumentItem(_response);
      });
  }

  protected processRemoveDeliveryDocumentItem(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getDeliveryDocumentItem(
    id: string,
    deliveryDocumentItemId: string
  ): Promise<SwaggerResponse<DeliveryDocumentItemDto>> {
    let url_ =
      this.baseUrl + "/deliveryDocuments/{id}/items/{deliveryDocumentItemId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (deliveryDocumentItemId === undefined || deliveryDocumentItemId === null)
      throw new Error(
        "The parameter 'deliveryDocumentItemId' must be defined."
      );
    url_ = url_.replace(
      "{deliveryDocumentItemId}",
      encodeURIComponent("" + deliveryDocumentItemId)
    );
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetDeliveryDocumentItem(_response);
      });
  }

  protected processGetDeliveryDocumentItem(
    response: Response
  ): Promise<SwaggerResponse<DeliveryDocumentItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as DeliveryDocumentItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<DeliveryDocumentItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateDeliveryDocumentItem(
    id: string,
    deliveryDocumentItemId: string,
    model: ManageDeliveryDocumentItemDto
  ): Promise<SwaggerResponse<DeliveryDocumentItemDto>> {
    let url_ =
      this.baseUrl + "/deliveryDocuments/{id}/items/{deliveryDocumentItemId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (deliveryDocumentItemId === undefined || deliveryDocumentItemId === null)
      throw new Error(
        "The parameter 'deliveryDocumentItemId' must be defined."
      );
    url_ = url_.replace(
      "{deliveryDocumentItemId}",
      encodeURIComponent("" + deliveryDocumentItemId)
    );
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateDeliveryDocumentItem(_response);
      });
  }

  protected processUpdateDeliveryDocumentItem(
    response: Response
  ): Promise<SwaggerResponse<DeliveryDocumentItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as DeliveryDocumentItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<DeliveryDocumentItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }
}

export class DepartmentsClient extends GestitClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: GestitClientOptions,
    baseUrl?: string,
    http?: {
      fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
    }
  ) {
    super(configuration);

    // @ts-ignore
    this.http = http ? http : (window as any);
    // @ts-ignore
    this.baseUrl = this.getBaseUrl("", baseUrl);

    this.jsonParseReviver = (k, v) => dateReviver(k, v, dateProperties);
  }

  getDepartments(
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfDepartmentDto>> {
    let url_ = this.baseUrl + "/departments?";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetDepartments(_response);
      });
  }

  protected processGetDepartments(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfDepartmentDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfDepartmentDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfDepartmentDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createDepartment(
    model: ManageDepartmentDto
  ): Promise<SwaggerResponse<DepartmentDto>> {
    let url_ = this.baseUrl + "/departments";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateDepartment(_response);
      });
  }

  protected processCreateDepartment(
    response: Response
  ): Promise<SwaggerResponse<DepartmentDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as DepartmentDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<DepartmentDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportDepartments(
    fields: string | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/departments/export?";
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportDepartments(_response);
      });
  }

  protected processExportDepartments(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getDepartmentEmployees(
    id: string,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined
  ): Promise<SwaggerResponse<PaginatedOfDepartmentEmployeeDto>> {
    let url_ = this.baseUrl + "/departments/{id}/employees?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetDepartmentEmployees(_response);
      });
  }

  protected processGetDepartmentEmployees(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfDepartmentEmployeeDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfDepartmentEmployeeDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfDepartmentEmployeeDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  addDepartmentEmployees(
    id: string,
    model: AddDepartmentEmployeesDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/departments/{id}/employees";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAddDepartmentEmployees(_response);
      });
  }

  protected processAddDepartmentEmployees(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getEmployeesAvailableForDepartment(
    id: string,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfEmployeeOverviewDto>> {
    let url_ = this.baseUrl + "/departments/{id}/employees/available?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetEmployeesAvailableForDepartment(_response);
      });
  }

  protected processGetEmployeesAvailableForDepartment(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfEmployeeOverviewDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfEmployeeOverviewDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfEmployeeOverviewDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  removeDepartmentEmployee(
    id: string,
    employeeId: string
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/departments/{id}/employees/{employeeId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (employeeId === undefined || employeeId === null)
      throw new Error("The parameter 'employeeId' must be defined.");
    url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processRemoveDepartmentEmployee(_response);
      });
  }

  protected processRemoveDepartmentEmployee(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getDepartment(id: string): Promise<SwaggerResponse<DepartmentDto>> {
    let url_ = this.baseUrl + "/departments/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetDepartment(_response);
      });
  }

  protected processGetDepartment(
    response: Response
  ): Promise<SwaggerResponse<DepartmentDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as DepartmentDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<DepartmentDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateDepartment(
    id: string,
    model: ManageDepartmentDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/departments/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateDepartment(_response);
      });
  }

  protected processUpdateDepartment(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteDepartment(id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/departments/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteDepartment(_response);
      });
  }

  protected processDeleteDepartment(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }
}

export class EmployeesClient extends GestitClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: GestitClientOptions,
    baseUrl?: string,
    http?: {
      fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
    }
  ) {
    super(configuration);

    // @ts-ignore
    this.http = http ? http : (window as any);
    // @ts-ignore
    this.baseUrl = this.getBaseUrl("", baseUrl);

    this.jsonParseReviver = (k, v) => dateReviver(k, v, dateProperties);
  }

  getEmployees(
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfEmployeeDto>> {
    let url_ = this.baseUrl + "/employees?";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetEmployees(_response);
      });
  }

  protected processGetEmployees(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfEmployeeDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfEmployeeDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfEmployeeDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createEmployee(
    model: ManageEmployeeDto
  ): Promise<SwaggerResponse<EmployeeDto>> {
    let url_ = this.baseUrl + "/employees";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateEmployee(_response);
      });
  }

  protected processCreateEmployee(
    response: Response
  ): Promise<SwaggerResponse<EmployeeDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as EmployeeDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<EmployeeDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportEmployees(
    fields: string | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/employees/export?";
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportEmployees(_response);
      });
  }

  protected processExportEmployees(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getEmployee(id: string): Promise<SwaggerResponse<EmployeeDto>> {
    let url_ = this.baseUrl + "/employees/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetEmployee(_response);
      });
  }

  protected processGetEmployee(
    response: Response
  ): Promise<SwaggerResponse<EmployeeDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as EmployeeDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<EmployeeDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateEmployee(
    id: string,
    model: ManageEmployeeDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/employees/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateEmployee(_response);
      });
  }

  protected processUpdateEmployee(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteEmployee(id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/employees/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteEmployee(_response);
      });
  }

  protected processDeleteEmployee(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getMe(): Promise<SwaggerResponse<EmployeeDto>> {
    let url_ = this.baseUrl + "/employees/me";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetMe(_response);
      });
  }

  protected processGetMe(
    response: Response
  ): Promise<SwaggerResponse<EmployeeDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as EmployeeDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<EmployeeDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }
}

export class ItemsClient extends GestitClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: GestitClientOptions,
    baseUrl?: string,
    http?: {
      fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
    }
  ) {
    super(configuration);

    // @ts-ignore
    this.http = http ? http : (window as any);
    // @ts-ignore
    this.baseUrl = this.getBaseUrl("", baseUrl);

    this.jsonParseReviver = (k, v) => dateReviver(k, v, dateProperties);
  }

  getItems(
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined,
    queryType: string | null | undefined
  ): Promise<SwaggerResponse<PaginatedOfItemDto>> {
    let url_ = this.baseUrl + "/items?";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    if (queryType !== undefined && queryType !== null)
      url_ += "queryType=" + encodeURIComponent("" + queryType) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetItems(_response);
      });
  }

  protected processGetItems(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getWarehouseMovements(
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<ItemMovementsPage>> {
    let url_ = this.baseUrl + "/items/warehouse/movements?";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetWarehouseMovements(_response);
      });
  }

  protected processGetWarehouseMovements(
    response: Response
  ): Promise<SwaggerResponse<ItemMovementsPage>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as ItemMovementsPage);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ItemMovementsPage>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportWarehouseMovements(
    fields: string | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/items/warehouse/movements/export?";
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportWarehouseMovements(_response);
      });
  }

  protected processExportWarehouseMovements(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getItemMovements(
    id: string,
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined,
    showAsService: boolean | undefined
  ): Promise<SwaggerResponse<ItemMovementsPage>> {
    let url_ = this.baseUrl + "/items/{id}/movements?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    if (showAsService === null)
      throw new Error("The parameter 'showAsService' cannot be null.");
    else if (showAsService !== undefined)
      url_ += "showAsService=" + encodeURIComponent("" + showAsService) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetItemMovements(_response);
      });
  }

  protected processGetItemMovements(
    response: Response
  ): Promise<SwaggerResponse<ItemMovementsPage>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as ItemMovementsPage);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ItemMovementsPage>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createItemMovement(
    id: string,
    model: ManageWarehouseMovementDto
  ): Promise<SwaggerResponse<ItemMovementDto>> {
    let url_ = this.baseUrl + "/items/{id}/movements";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateItemMovement(_response);
      });
  }

  protected processCreateItemMovement(
    response: Response
  ): Promise<SwaggerResponse<ItemMovementDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as ItemMovementDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ItemMovementDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportItemMovements(
    id: string,
    fields: string | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    showAsService: boolean | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/items/{id}/movements/export?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (showAsService === null)
      throw new Error("The parameter 'showAsService' cannot be null.");
    else if (showAsService !== undefined)
      url_ += "showAsService=" + encodeURIComponent("" + showAsService) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportItemMovements(_response);
      });
  }

  protected processExportItemMovements(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteItemMovement(
    id: string,
    movementId: string
  ): Promise<SwaggerResponse<ItemMovementDto>> {
    let url_ = this.baseUrl + "/items/{id}/movements/{movementId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (movementId === undefined || movementId === null)
      throw new Error("The parameter 'movementId' must be defined.");
    url_ = url_.replace("{movementId}", encodeURIComponent("" + movementId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteItemMovement(_response);
      });
  }

  protected processDeleteItemMovement(
    response: Response
  ): Promise<SwaggerResponse<ItemMovementDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as ItemMovementDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ItemMovementDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getDerivedItems(
    id: string,
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfItemDto>> {
    let url_ = this.baseUrl + "/items/{id}/derived?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetDerivedItems(_response);
      });
  }

  protected processGetDerivedItems(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportDerivedItems(
    id: string,
    fields: string | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/items/{id}/derived/export?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportDerivedItems(_response);
      });
  }

  protected processExportDerivedItems(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getAllItemsInBOMHierarchies(
    rootItemsIds: string[] | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined,
    employeeId: string | null | undefined,
    orderItemId: string | null | undefined
  ): Promise<SwaggerResponse<PaginatedOfItemInBomHierarchyDto>> {
    let url_ = this.baseUrl + "/items/inBOMHierarchies?";
    if (rootItemsIds === null)
      throw new Error("The parameter 'rootItemsIds' cannot be null.");
    else if (rootItemsIds !== undefined)
      rootItemsIds &&
        rootItemsIds.forEach((item) => {
          url_ += "rootItemsIds=" + encodeURIComponent("" + item) + "&";
        });
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    if (employeeId !== undefined && employeeId !== null)
      url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
    if (orderItemId !== undefined && orderItemId !== null)
      url_ += "orderItemId=" + encodeURIComponent("" + orderItemId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAllItemsInBOMHierarchies(_response);
      });
  }

  protected processGetAllItemsInBOMHierarchies(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfItemInBomHierarchyDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfItemInBomHierarchyDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfItemInBomHierarchyDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getBOMHierarchyStocks(
    id: string,
    requiredQuantity: number | null | undefined
  ): Promise<SwaggerResponse<ItemStockDto[]>> {
    let url_ = this.baseUrl + "/items/{id}/stocks?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (requiredQuantity !== undefined && requiredQuantity !== null)
      url_ +=
        "requiredQuantity=" + encodeURIComponent("" + requiredQuantity) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetBOMHierarchyStocks(_response);
      });
  }

  protected processGetBOMHierarchyStocks(
    response: Response
  ): Promise<SwaggerResponse<ItemStockDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as ItemStockDto[]);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ItemStockDto[]>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getItem(id: string): Promise<SwaggerResponse<ItemDto>> {
    let url_ = this.baseUrl + "/items/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetItem(_response);
      });
  }

  protected processGetItem(
    response: Response
  ): Promise<SwaggerResponse<ItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteItem(id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/items/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteItem(_response);
      });
  }

  protected processDeleteItem(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateItem(
    id: string,
    model: ManageItemDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/items/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateItem(_response);
      });
  }

  protected processUpdateItem(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createItem(model: ManageItemDto): Promise<SwaggerResponse<ItemDto>> {
    let url_ = this.baseUrl + "/items/create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateItem(_response);
      });
  }

  protected processCreateItem(
    response: Response
  ): Promise<SwaggerResponse<ItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  copyItem(
    id: string,
    newCode: string | undefined
  ): Promise<SwaggerResponse<ItemDto>> {
    let url_ = this.baseUrl + "/items/{id}/copy?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (newCode === null)
      throw new Error("The parameter 'newCode' cannot be null.");
    else if (newCode !== undefined)
      url_ += "newCode=" + encodeURIComponent("" + newCode) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCopyItem(_response);
      });
  }

  protected processCopyItem(
    response: Response
  ): Promise<SwaggerResponse<ItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  associateSample(
    id: string,
    sampleId: string | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/items/{id}/associateSample?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sampleId === null)
      throw new Error("The parameter 'sampleId' cannot be null.");
    else if (sampleId !== undefined)
      url_ += "sampleId=" + encodeURIComponent("" + sampleId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAssociateSample(_response);
      });
  }

  protected processAssociateSample(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  removeSample(id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/items/{id}/removeSample";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processRemoveSample(_response);
      });
  }

  protected processRemoveSample(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportItems(
    fields: string | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/items/export?";
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportItems(_response);
      });
  }

  protected processExportItems(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getItemAvailableSamples(
    id: string,
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfItemDto>> {
    let url_ = this.baseUrl + "/items/{id}/availableSamples?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetItemAvailableSamples(_response);
      });
  }

  protected processGetItemAvailableSamples(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getItemCategories(
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfItemCategoryDto>> {
    let url_ = this.baseUrl + "/items/categories?";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetItemCategories(_response);
      });
  }

  protected processGetItemCategories(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfItemCategoryDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfItemCategoryDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfItemCategoryDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getItemCategory(id: string): Promise<SwaggerResponse<ItemCategoryDto>> {
    let url_ = this.baseUrl + "/items/categories/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetItemCategory(_response);
      });
  }

  protected processGetItemCategory(
    response: Response
  ): Promise<SwaggerResponse<ItemCategoryDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as ItemCategoryDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ItemCategoryDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteItemCategory(id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/items/categories/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteItemCategory(_response);
      });
  }

  protected processDeleteItemCategory(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateItemCategory(
    id: string,
    model: ManageItemCategoryDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/items/categories/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateItemCategory(_response);
      });
  }

  protected processUpdateItemCategory(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createItemCategory(
    model: ManageItemCategoryDto
  ): Promise<SwaggerResponse<ItemCategoryDto>> {
    let url_ = this.baseUrl + "/items/categories/create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateItemCategory(_response);
      });
  }

  protected processCreateItemCategory(
    response: Response
  ): Promise<SwaggerResponse<ItemCategoryDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as ItemCategoryDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ItemCategoryDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportItemCategories(
    fields: string | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/items/categories/export?";
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportItemCategories(_response);
      });
  }

  protected processExportItemCategories(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getItemCommodityCategories(
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfCommodityCategoryDto>> {
    let url_ = this.baseUrl + "/items/commodityCategories?";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetItemCommodityCategories(_response);
      });
  }

  protected processGetItemCommodityCategories(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfCommodityCategoryDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfCommodityCategoryDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfCommodityCategoryDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createCommodityCategory(
    model: ManageCommodityCategoryDto
  ): Promise<SwaggerResponse<CommodityCategoryDto>> {
    let url_ = this.baseUrl + "/items/commodityCategories";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateCommodityCategory(_response);
      });
  }

  protected processCreateCommodityCategory(
    response: Response
  ): Promise<SwaggerResponse<CommodityCategoryDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as CommodityCategoryDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<CommodityCategoryDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getCommodityCategory(
    id: string
  ): Promise<SwaggerResponse<CommodityCategoryDto>> {
    let url_ = this.baseUrl + "/items/commodityCategories/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCommodityCategory(_response);
      });
  }

  protected processGetCommodityCategory(
    response: Response
  ): Promise<SwaggerResponse<CommodityCategoryDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as CommodityCategoryDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<CommodityCategoryDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteCommodityCategory(id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/items/commodityCategories/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteCommodityCategory(_response);
      });
  }

  protected processDeleteCommodityCategory(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateCommodityCategory(
    id: string,
    model: ManageCommodityCategoryDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/items/commodityCategories/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateCommodityCategory(_response);
      });
  }

  protected processUpdateCommodityCategory(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportCommodityCategories(
    fields: string | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/items/commodityCategories/export?";
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportCommodityCategories(_response);
      });
  }

  protected processExportCommodityCategories(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getItemCustomers(
    id: string,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfItemCustomerDto>> {
    let url_ = this.baseUrl + "/items/{id}/customers?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetItemCustomers(_response);
      });
  }

  protected processGetItemCustomers(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfItemCustomerDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfItemCustomerDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfItemCustomerDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  addItemCustomer(
    id: string,
    customerId: string | undefined,
    itemCode: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/items/{id}/customers?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (customerId === null)
      throw new Error("The parameter 'customerId' cannot be null.");
    else if (customerId !== undefined)
      url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
    if (itemCode !== undefined && itemCode !== null)
      url_ += "itemCode=" + encodeURIComponent("" + itemCode) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAddItemCustomer(_response);
      });
  }

  protected processAddItemCustomer(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateItemCustomer(
    id: string,
    customerId: string | undefined,
    itemCode: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/items/{id}/customers?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (customerId === null)
      throw new Error("The parameter 'customerId' cannot be null.");
    else if (customerId !== undefined)
      url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
    if (itemCode !== undefined && itemCode !== null)
      url_ += "itemCode=" + encodeURIComponent("" + itemCode) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "PUT",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateItemCustomer(_response);
      });
  }

  protected processUpdateItemCustomer(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getItemCustomer(
    id: string,
    customerId: string
  ): Promise<SwaggerResponse<ItemCustomerDto>> {
    let url_ = this.baseUrl + "/items/{id}/customers/{customerId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (customerId === undefined || customerId === null)
      throw new Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetItemCustomer(_response);
      });
  }

  protected processGetItemCustomer(
    response: Response
  ): Promise<SwaggerResponse<ItemCustomerDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as ItemCustomerDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ItemCustomerDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteItemCustomer(
    id: string,
    customerId: string
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/items/{id}/customers/{customerId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (customerId === undefined || customerId === null)
      throw new Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteItemCustomer(_response);
      });
  }

  protected processDeleteItemCustomer(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getCustomersAvailableForItem(
    id: string,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfCustomerDto>> {
    let url_ = this.baseUrl + "/items/{id}/customers/available?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCustomersAvailableForItem(_response);
      });
  }

  protected processGetCustomersAvailableForItem(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfCustomerDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfCustomerDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfCustomerDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getItemSuppliers(
    id: string,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfItemSupplierDto>> {
    let url_ = this.baseUrl + "/items/{id}/suppliers?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetItemSuppliers(_response);
      });
  }

  protected processGetItemSuppliers(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfItemSupplierDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfItemSupplierDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfItemSupplierDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  addItemSupplier(
    id: string,
    supplierId: string | undefined,
    itemCode: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/items/{id}/suppliers?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (supplierId === null)
      throw new Error("The parameter 'supplierId' cannot be null.");
    else if (supplierId !== undefined)
      url_ += "supplierId=" + encodeURIComponent("" + supplierId) + "&";
    if (itemCode !== undefined && itemCode !== null)
      url_ += "itemCode=" + encodeURIComponent("" + itemCode) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAddItemSupplier(_response);
      });
  }

  protected processAddItemSupplier(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateItemSupplier(
    id: string,
    supplierId: string | undefined,
    itemCode: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/items/{id}/suppliers?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (supplierId === null)
      throw new Error("The parameter 'supplierId' cannot be null.");
    else if (supplierId !== undefined)
      url_ += "supplierId=" + encodeURIComponent("" + supplierId) + "&";
    if (itemCode !== undefined && itemCode !== null)
      url_ += "itemCode=" + encodeURIComponent("" + itemCode) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "PUT",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateItemSupplier(_response);
      });
  }

  protected processUpdateItemSupplier(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getItemSupplier(
    id: string,
    supplierId: string
  ): Promise<SwaggerResponse<ItemSupplierDto>> {
    let url_ = this.baseUrl + "/items/{id}/suppliers/{supplierId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (supplierId === undefined || supplierId === null)
      throw new Error("The parameter 'supplierId' must be defined.");
    url_ = url_.replace("{supplierId}", encodeURIComponent("" + supplierId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetItemSupplier(_response);
      });
  }

  protected processGetItemSupplier(
    response: Response
  ): Promise<SwaggerResponse<ItemSupplierDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as ItemSupplierDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ItemSupplierDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteItemSupplier(
    id: string,
    supplierId: string
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/items/{id}/suppliers/{supplierId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (supplierId === undefined || supplierId === null)
      throw new Error("The parameter 'supplierId' must be defined.");
    url_ = url_.replace("{supplierId}", encodeURIComponent("" + supplierId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteItemSupplier(_response);
      });
  }

  protected processDeleteItemSupplier(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getSuppliersAvailableForItem(
    id: string,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfSupplierDto>> {
    let url_ = this.baseUrl + "/items/{id}/suppliers/available?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetSuppliersAvailableForItem(_response);
      });
  }

  protected processGetSuppliersAvailableForItem(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfSupplierDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfSupplierDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfSupplierDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getItemPriceLists(
    id: string,
    sortBy: string | null | undefined,
    filterBy: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined
  ): Promise<SwaggerResponse<PaginatedOfPriceListItemDto>> {
    let url_ = this.baseUrl + "/items/{id}/priceLists?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (filterBy !== undefined && filterBy !== null)
      url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetItemPriceLists(_response);
      });
  }

  protected processGetItemPriceLists(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfPriceListItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfPriceListItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfPriceListItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  addItemPriceList(
    id: string,
    model: ItemPriceListManageDto
  ): Promise<SwaggerResponse<PriceListItemDto>> {
    let url_ = this.baseUrl + "/items/{id}/priceLists";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAddItemPriceList(_response);
      });
  }

  protected processAddItemPriceList(
    response: Response
  ): Promise<SwaggerResponse<PriceListItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PriceListItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PriceListItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getItemPriceListsAvailable(
    id: string,
    sortBy: string | null | undefined,
    filterBy: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfPriceListDto>> {
    let url_ = this.baseUrl + "/items/{id}/priceLists/available?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (filterBy !== undefined && filterBy !== null)
      url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetItemPriceListsAvailable(_response);
      });
  }

  protected processGetItemPriceListsAvailable(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfPriceListDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfPriceListDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfPriceListDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateItemPriceList(
    id: string,
    priceListItemId: string,
    model: ItemPriceListManageDto
  ): Promise<SwaggerResponse<PriceListItemDto>> {
    let url_ = this.baseUrl + "/items/{id}/priceLists/{priceListItemId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (priceListItemId === undefined || priceListItemId === null)
      throw new Error("The parameter 'priceListItemId' must be defined.");
    url_ = url_.replace(
      "{priceListItemId}",
      encodeURIComponent("" + priceListItemId)
    );
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateItemPriceList(_response);
      });
  }

  protected processUpdateItemPriceList(
    response: Response
  ): Promise<SwaggerResponse<PriceListItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PriceListItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PriceListItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getSampleCustomersAcceptances(
    id: string,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfItemSampleCustomerAcceptanceDto>> {
    let url_ = this.baseUrl + "/items/{id}/sampleAcceptances?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetSampleCustomersAcceptances(_response);
      });
  }

  protected processGetSampleCustomersAcceptances(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfItemSampleCustomerAcceptanceDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfItemSampleCustomerAcceptanceDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<
      SwaggerResponse<PaginatedOfItemSampleCustomerAcceptanceDto>
    >(new SwaggerResponse(status, _headers, null as any));
  }

  addSampleCustomerAcceptance(
    id: string,
    customerId: string | undefined,
    acceptedAt: Date | undefined,
    deliveryDocumentId: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/items/{id}/sampleAcceptances?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (customerId === null)
      throw new Error("The parameter 'customerId' cannot be null.");
    else if (customerId !== undefined)
      url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
    if (acceptedAt === null)
      throw new Error("The parameter 'acceptedAt' cannot be null.");
    else if (acceptedAt !== undefined)
      url_ +=
        "acceptedAt=" +
        encodeURIComponent(acceptedAt ? "" + acceptedAt.toISOString() : "") +
        "&";
    if (deliveryDocumentId !== undefined && deliveryDocumentId !== null)
      url_ +=
        "deliveryDocumentId=" +
        encodeURIComponent("" + deliveryDocumentId) +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAddSampleCustomerAcceptance(_response);
      });
  }

  protected processAddSampleCustomerAcceptance(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateSampleCustomerAcceptance(
    id: string,
    customerId: string | undefined,
    acceptedAt: Date | undefined,
    deliveryDocumentId: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/items/{id}/sampleAcceptances?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (customerId === null)
      throw new Error("The parameter 'customerId' cannot be null.");
    else if (customerId !== undefined)
      url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
    if (acceptedAt === null)
      throw new Error("The parameter 'acceptedAt' cannot be null.");
    else if (acceptedAt !== undefined)
      url_ +=
        "acceptedAt=" +
        encodeURIComponent(acceptedAt ? "" + acceptedAt.toISOString() : "") +
        "&";
    if (deliveryDocumentId !== undefined && deliveryDocumentId !== null)
      url_ +=
        "deliveryDocumentId=" +
        encodeURIComponent("" + deliveryDocumentId) +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "PUT",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateSampleCustomerAcceptance(_response);
      });
  }

  protected processUpdateSampleCustomerAcceptance(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteSampleCustomerAcceptance(
    id: string,
    customerId: string
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/items/{id}/sampleAcceptances/{customerId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (customerId === undefined || customerId === null)
      throw new Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteSampleCustomerAcceptance(_response);
      });
  }

  protected processDeleteSampleCustomerAcceptance(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getSampleProducts(
    id: string,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfItemDto>> {
    let url_ = this.baseUrl + "/items/{id}/products?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetSampleProducts(_response);
      });
  }

  protected processGetSampleProducts(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportItemLabels(
    id: string,
    model: CreateLabelDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/items/{id}/labels";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportItemLabels(_response);
      });
  }

  protected processExportItemLabels(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }
}

export class JustificativesClient extends GestitClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: GestitClientOptions,
    baseUrl?: string,
    http?: {
      fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
    }
  ) {
    super(configuration);

    // @ts-ignore
    this.http = http ? http : (window as any);
    // @ts-ignore
    this.baseUrl = this.getBaseUrl("", baseUrl);

    this.jsonParseReviver = (k, v) => dateReviver(k, v, dateProperties);
  }

  getJustificatives(
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfJustificativeDto>> {
    let url_ = this.baseUrl + "/justificatives?";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetJustificatives(_response);
      });
  }

  protected processGetJustificatives(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfJustificativeDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfJustificativeDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfJustificativeDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createJustificative(
    model: ManageJustificativeDto
  ): Promise<SwaggerResponse<JustificativeDto>> {
    let url_ = this.baseUrl + "/justificatives";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateJustificative(_response);
      });
  }

  protected processCreateJustificative(
    response: Response
  ): Promise<SwaggerResponse<JustificativeDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as JustificativeDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<JustificativeDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  convertCommissionToJustificative(
    commissionId: string | undefined
  ): Promise<SwaggerResponse<JustificativeDto>> {
    let url_ = this.baseUrl + "/justificatives?";
    if (commissionId === null)
      throw new Error("The parameter 'commissionId' cannot be null.");
    else if (commissionId !== undefined)
      url_ += "commissionId=" + encodeURIComponent("" + commissionId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "PUT",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processConvertCommissionToJustificative(_response);
      });
  }

  protected processConvertCommissionToJustificative(
    response: Response
  ): Promise<SwaggerResponse<JustificativeDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as JustificativeDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<JustificativeDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportJustificatives(
    fields: string | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/justificatives/export?";
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportJustificatives(_response);
      });
  }

  protected processExportJustificatives(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getJustificative(id: string): Promise<SwaggerResponse<JustificativeDto>> {
    let url_ = this.baseUrl + "/justificatives/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetJustificative(_response);
      });
  }

  protected processGetJustificative(
    response: Response
  ): Promise<SwaggerResponse<JustificativeDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as JustificativeDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<JustificativeDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateJustificative(
    id: string,
    model: ManageJustificativeDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/justificatives/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateJustificative(_response);
      });
  }

  protected processUpdateJustificative(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteJustificative(id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/justificatives/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteJustificative(_response);
      });
  }

  protected processDeleteJustificative(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }
}

export class MovementReasonsClient extends GestitClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: GestitClientOptions,
    baseUrl?: string,
    http?: {
      fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
    }
  ) {
    super(configuration);

    // @ts-ignore
    this.http = http ? http : (window as any);
    // @ts-ignore
    this.baseUrl = this.getBaseUrl("", baseUrl);

    this.jsonParseReviver = (k, v) => dateReviver(k, v, dateProperties);
  }

  getMovementReasons(
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfMovementReasonDto>> {
    let url_ = this.baseUrl + "/movementReasons?";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetMovementReasons(_response);
      });
  }

  protected processGetMovementReasons(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfMovementReasonDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfMovementReasonDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfMovementReasonDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getMovementReason(id: string): Promise<SwaggerResponse<MovementReasonDto>> {
    let url_ = this.baseUrl + "/movementReasons/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetMovementReason(_response);
      });
  }

  protected processGetMovementReason(
    response: Response
  ): Promise<SwaggerResponse<MovementReasonDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as MovementReasonDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<MovementReasonDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteMovementReason(id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/movementReasons/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteMovementReason(_response);
      });
  }

  protected processDeleteMovementReason(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateMovementReason(
    id: string,
    model: ManageMovementReasonDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/movementReasons/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateMovementReason(_response);
      });
  }

  protected processUpdateMovementReason(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createMovementReason(
    model: ManageMovementReasonDto
  ): Promise<SwaggerResponse<MovementReasonDto>> {
    let url_ = this.baseUrl + "/movementReasons/create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateMovementReason(_response);
      });
  }

  protected processCreateMovementReason(
    response: Response
  ): Promise<SwaggerResponse<MovementReasonDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as MovementReasonDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<MovementReasonDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportMovementReasons(
    fields: string | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/movementReasons/export?";
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportMovementReasons(_response);
      });
  }

  protected processExportMovementReasons(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }
}

export class OperationsClient extends GestitClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: GestitClientOptions,
    baseUrl?: string,
    http?: {
      fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
    }
  ) {
    super(configuration);

    // @ts-ignore
    this.http = http ? http : (window as any);
    // @ts-ignore
    this.baseUrl = this.getBaseUrl("", baseUrl);

    this.jsonParseReviver = (k, v) => dateReviver(k, v, dateProperties);
  }

  getOperations(
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined,
    bomId: string | null | undefined
  ): Promise<SwaggerResponse<PaginatedOfOperationDto>> {
    let url_ = this.baseUrl + "/operations?";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    if (bomId !== undefined && bomId !== null)
      url_ += "bomId=" + encodeURIComponent("" + bomId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetOperations(_response);
      });
  }

  protected processGetOperations(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfOperationDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfOperationDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfOperationDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createOperation(
    model: ManageOperationDto
  ): Promise<SwaggerResponse<OperationDto>> {
    let url_ = this.baseUrl + "/operations";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateOperation(_response);
      });
  }

  protected processCreateOperation(
    response: Response
  ): Promise<SwaggerResponse<OperationDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as OperationDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<OperationDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getOperation(id: string): Promise<SwaggerResponse<OperationDto>> {
    let url_ = this.baseUrl + "/operations/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetOperation(_response);
      });
  }

  protected processGetOperation(
    response: Response
  ): Promise<SwaggerResponse<OperationDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as OperationDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<OperationDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteOperation(id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/operations/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteOperation(_response);
      });
  }

  protected processDeleteOperation(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateOperation(
    id: string,
    model: ManageOperationDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/operations/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateOperation(_response);
      });
  }

  protected processUpdateOperation(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportOperations(
    fields: string | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/operations/export?";
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportOperations(_response);
      });
  }

  protected processExportOperations(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }
}

export class PackageAppearancesClient extends GestitClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: GestitClientOptions,
    baseUrl?: string,
    http?: {
      fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
    }
  ) {
    super(configuration);

    // @ts-ignore
    this.http = http ? http : (window as any);
    // @ts-ignore
    this.baseUrl = this.getBaseUrl("", baseUrl);

    this.jsonParseReviver = (k, v) => dateReviver(k, v, dateProperties);
  }

  getPackageAppearances(
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfPackageAppearanceDto>> {
    let url_ = this.baseUrl + "/packageAppearances?";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetPackageAppearances(_response);
      });
  }

  protected processGetPackageAppearances(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfPackageAppearanceDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfPackageAppearanceDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfPackageAppearanceDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createPackageAppearance(
    model: ManagePackageAppearanceDto
  ): Promise<SwaggerResponse<PackageAppearanceDto>> {
    let url_ = this.baseUrl + "/packageAppearances";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreatePackageAppearance(_response);
      });
  }

  protected processCreatePackageAppearance(
    response: Response
  ): Promise<SwaggerResponse<PackageAppearanceDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PackageAppearanceDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PackageAppearanceDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportPackageAppearances(
    fields: string | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/packageAppearances/export?";
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportPackageAppearances(_response);
      });
  }

  protected processExportPackageAppearances(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getPackageAppearance(
    id: string
  ): Promise<SwaggerResponse<PackageAppearanceDto>> {
    let url_ = this.baseUrl + "/packageAppearances/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetPackageAppearance(_response);
      });
  }

  protected processGetPackageAppearance(
    response: Response
  ): Promise<SwaggerResponse<PackageAppearanceDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PackageAppearanceDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PackageAppearanceDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updatePackageAppearance(
    id: string,
    model: ManagePackageAppearanceDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/packageAppearances/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdatePackageAppearance(_response);
      });
  }

  protected processUpdatePackageAppearance(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deletePackageAppearance(id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/packageAppearances/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeletePackageAppearance(_response);
      });
  }

  protected processDeletePackageAppearance(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }
}

export class PackagesClient extends GestitClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: GestitClientOptions,
    baseUrl?: string,
    http?: {
      fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
    }
  ) {
    super(configuration);

    // @ts-ignore
    this.http = http ? http : (window as any);
    // @ts-ignore
    this.baseUrl = this.getBaseUrl("", baseUrl);

    this.jsonParseReviver = (k, v) => dateReviver(k, v, dateProperties);
  }

  getPackages(
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfPackageDto>> {
    let url_ = this.baseUrl + "/packages?";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetPackages(_response);
      });
  }

  protected processGetPackages(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfPackageDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfPackageDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfPackageDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createPackage(model: PackageManageDto): Promise<SwaggerResponse<PackageDto>> {
    let url_ = this.baseUrl + "/packages";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreatePackage(_response);
      });
  }

  protected processCreatePackage(
    response: Response
  ): Promise<SwaggerResponse<PackageDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as PackageDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PackageDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportPackages(
    fields: string | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/packages/export?";
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportPackages(_response);
      });
  }

  protected processExportPackages(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getPackage(id: string): Promise<SwaggerResponse<PackageDto>> {
    let url_ = this.baseUrl + "/packages/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetPackage(_response);
      });
  }

  protected processGetPackage(
    response: Response
  ): Promise<SwaggerResponse<PackageDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as PackageDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PackageDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updatePackage(
    id: string,
    model: PackageManageDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/packages/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdatePackage(_response);
      });
  }

  protected processUpdatePackage(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deletePackage(id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/packages/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeletePackage(_response);
      });
  }

  protected processDeletePackage(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }
}

export class PaymentTermsClient extends GestitClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: GestitClientOptions,
    baseUrl?: string,
    http?: {
      fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
    }
  ) {
    super(configuration);

    // @ts-ignore
    this.http = http ? http : (window as any);
    // @ts-ignore
    this.baseUrl = this.getBaseUrl("", baseUrl);

    this.jsonParseReviver = (k, v) => dateReviver(k, v, dateProperties);
  }

  getAllPaymentTerms(
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfPaymentTermsDto>> {
    let url_ = this.baseUrl + "/paymentTerms?";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAllPaymentTerms(_response);
      });
  }

  protected processGetAllPaymentTerms(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfPaymentTermsDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfPaymentTermsDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfPaymentTermsDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createPaymentTerms(
    model: ManagePaymentTermsDto
  ): Promise<SwaggerResponse<PaymentTermsDto>> {
    let url_ = this.baseUrl + "/paymentTerms";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreatePaymentTerms(_response);
      });
  }

  protected processCreatePaymentTerms(
    response: Response
  ): Promise<SwaggerResponse<PaymentTermsDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaymentTermsDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaymentTermsDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getPaymentTerms(id: string): Promise<SwaggerResponse<PaymentTermsDto>> {
    let url_ = this.baseUrl + "/paymentTerms/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetPaymentTerms(_response);
      });
  }

  protected processGetPaymentTerms(
    response: Response
  ): Promise<SwaggerResponse<PaymentTermsDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaymentTermsDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaymentTermsDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updatePaymentTerms(
    id: string,
    model: ManagePaymentTermsDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/paymentTerms/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdatePaymentTerms(_response);
      });
  }

  protected processUpdatePaymentTerms(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deletePaymentTerms(id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/paymentTerms/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeletePaymentTerms(_response);
      });
  }

  protected processDeletePaymentTerms(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }
}

export class PriceListClient extends GestitClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: GestitClientOptions,
    baseUrl?: string,
    http?: {
      fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
    }
  ) {
    super(configuration);

    // @ts-ignore
    this.http = http ? http : (window as any);
    // @ts-ignore
    this.baseUrl = this.getBaseUrl("", baseUrl);

    this.jsonParseReviver = (k, v) => dateReviver(k, v, dateProperties);
  }

  getAllPriceLists(
    sortBy: string | null | undefined,
    filterBy: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined
  ): Promise<SwaggerResponse<PaginatedOfPriceListDto>> {
    let url_ = this.baseUrl + "/priceLists?";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (filterBy !== undefined && filterBy !== null)
      url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAllPriceLists(_response);
      });
  }

  protected processGetAllPriceLists(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfPriceListDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfPriceListDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfPriceListDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createPriceList(
    model: PriceListManageDto
  ): Promise<SwaggerResponse<PriceListDto>> {
    let url_ = this.baseUrl + "/priceLists";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreatePriceList(_response);
      });
  }

  protected processCreatePriceList(
    response: Response
  ): Promise<SwaggerResponse<PriceListDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PriceListDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PriceListDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createPriceListFromExisting(
    model: PriceListCustomManageDto
  ): Promise<SwaggerResponse<PriceListDto>> {
    let url_ = this.baseUrl + "/priceLists";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreatePriceListFromExisting(_response);
      });
  }

  protected processCreatePriceListFromExisting(
    response: Response
  ): Promise<SwaggerResponse<PriceListDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PriceListDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PriceListDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportAllPriceLists(
    fields: string | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/priceLists/export?";
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportAllPriceLists(_response);
      });
  }

  protected processExportAllPriceLists(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updatePriceList(
    id: string,
    model: PriceListManageDto
  ): Promise<SwaggerResponse<PriceListDto>> {
    let url_ = this.baseUrl + "/priceLists/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdatePriceList(_response);
      });
  }

  protected processUpdatePriceList(
    response: Response
  ): Promise<SwaggerResponse<PriceListDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PriceListDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PriceListDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deletePriceList(id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/priceLists/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeletePriceList(_response);
      });
  }

  protected processDeletePriceList(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getPriceList(id: string): Promise<SwaggerResponse<PriceListDto>> {
    let url_ = this.baseUrl + "/priceLists/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetPriceList(_response);
      });
  }

  protected processGetPriceList(
    response: Response
  ): Promise<SwaggerResponse<PriceListDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PriceListDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PriceListDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getPriceListItems(
    id: string,
    sortBy: string | null | undefined,
    filterBy: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined
  ): Promise<SwaggerResponse<PaginatedOfPriceListItemDto>> {
    let url_ = this.baseUrl + "/priceLists/{id}/items?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (filterBy !== undefined && filterBy !== null)
      url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetPriceListItems(_response);
      });
  }

  protected processGetPriceListItems(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfPriceListItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfPriceListItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfPriceListItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  addPriceListItem(
    id: string,
    model: PriceListItemManageDto
  ): Promise<SwaggerResponse<PriceListItemDto>> {
    let url_ = this.baseUrl + "/priceLists/{id}/items";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAddPriceListItem(_response);
      });
  }

  protected processAddPriceListItem(
    response: Response
  ): Promise<SwaggerResponse<PriceListItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PriceListItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PriceListItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportPriceListItems(
    id: string,
    fields: string | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/priceLists/{id}/items/export?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportPriceListItems(_response);
      });
  }

  protected processExportPriceListItems(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getPriceListItemsAvailable(
    id: string,
    sortBy: string | null | undefined,
    filterBy: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfItemDto>> {
    let url_ = this.baseUrl + "/priceLists/{id}/items/available?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (filterBy !== undefined && filterBy !== null)
      url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetPriceListItemsAvailable(_response);
      });
  }

  protected processGetPriceListItemsAvailable(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  removePriceListItem(
    id: string,
    priceListItemId: string
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/priceLists/{id}/items/{priceListItemId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (priceListItemId === undefined || priceListItemId === null)
      throw new Error("The parameter 'priceListItemId' must be defined.");
    url_ = url_.replace(
      "{priceListItemId}",
      encodeURIComponent("" + priceListItemId)
    );
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processRemovePriceListItem(_response);
      });
  }

  protected processRemovePriceListItem(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getPriceListItem(
    id: string,
    priceListItemId: string
  ): Promise<SwaggerResponse<PriceListItemDto>> {
    let url_ = this.baseUrl + "/priceLists/{id}/items/{priceListItemId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (priceListItemId === undefined || priceListItemId === null)
      throw new Error("The parameter 'priceListItemId' must be defined.");
    url_ = url_.replace(
      "{priceListItemId}",
      encodeURIComponent("" + priceListItemId)
    );
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetPriceListItem(_response);
      });
  }

  protected processGetPriceListItem(
    response: Response
  ): Promise<SwaggerResponse<PriceListItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PriceListItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PriceListItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updatePriceListItem(
    id: string,
    priceListItemId: string,
    model: PriceListItemManageDto
  ): Promise<SwaggerResponse<PriceListItemDto>> {
    let url_ = this.baseUrl + "/priceLists/{id}/items/{priceListItemId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (priceListItemId === undefined || priceListItemId === null)
      throw new Error("The parameter 'priceListItemId' must be defined.");
    url_ = url_.replace(
      "{priceListItemId}",
      encodeURIComponent("" + priceListItemId)
    );
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdatePriceListItem(_response);
      });
  }

  protected processUpdatePriceListItem(
    response: Response
  ): Promise<SwaggerResponse<PriceListItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PriceListItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PriceListItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }
}

export class PurchaseOrdersClient extends GestitClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: GestitClientOptions,
    baseUrl?: string,
    http?: {
      fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
    }
  ) {
    super(configuration);

    // @ts-ignore
    this.http = http ? http : (window as any);
    // @ts-ignore
    this.baseUrl = this.getBaseUrl("", baseUrl);

    this.jsonParseReviver = (k, v) => dateReviver(k, v, dateProperties);
  }

  getPurchaseOrders(
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined,
    includeTotals: boolean | undefined
  ): Promise<SwaggerResponse<PaginatedWithTotalOfPurchaseOrderDto>> {
    let url_ = this.baseUrl + "/purchaseOrders?";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    if (includeTotals === null)
      throw new Error("The parameter 'includeTotals' cannot be null.");
    else if (includeTotals !== undefined)
      url_ += "includeTotals=" + encodeURIComponent("" + includeTotals) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetPurchaseOrders(_response);
      });
  }

  protected processGetPurchaseOrders(
    response: Response
  ): Promise<SwaggerResponse<PaginatedWithTotalOfPurchaseOrderDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedWithTotalOfPurchaseOrderDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<
      SwaggerResponse<PaginatedWithTotalOfPurchaseOrderDto>
    >(new SwaggerResponse(status, _headers, null as any));
  }

  createPurchaseOrder(
    model: ManagePurchaseOrderDto
  ): Promise<SwaggerResponse<PurchaseOrderDto>> {
    let url_ = this.baseUrl + "/purchaseOrders";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreatePurchaseOrder(_response);
      });
  }

  protected processCreatePurchaseOrder(
    response: Response
  ): Promise<SwaggerResponse<PurchaseOrderDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PurchaseOrderDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PurchaseOrderDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  checkValidPurchaseOrderTaxable(
    id: string,
    itemId: string | null | undefined,
    nextItemPrice: number | undefined
  ): Promise<SwaggerResponse<boolean>> {
    let url_ = this.baseUrl + "/purchaseOrders/{id}/checkTaxable?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (itemId !== undefined && itemId !== null)
      url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
    if (nextItemPrice === null)
      throw new Error("The parameter 'nextItemPrice' cannot be null.");
    else if (nextItemPrice !== undefined)
      url_ += "nextItemPrice=" + encodeURIComponent("" + nextItemPrice) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCheckValidPurchaseOrderTaxable(_response);
      });
  }

  protected processCheckValidPurchaseOrderTaxable(
    response: Response
  ): Promise<SwaggerResponse<boolean>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<boolean>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportPurchaseOrders(
    fields: string | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/purchaseOrders/export?";
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportPurchaseOrders(_response);
      });
  }

  protected processExportPurchaseOrders(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getPurchaseOrder(id: string): Promise<SwaggerResponse<PurchaseOrderDto>> {
    let url_ = this.baseUrl + "/purchaseOrders/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetPurchaseOrder(_response);
      });
  }

  protected processGetPurchaseOrder(
    response: Response
  ): Promise<SwaggerResponse<PurchaseOrderDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PurchaseOrderDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PurchaseOrderDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updatePurchaseOrder(
    id: string,
    model: ManagePurchaseOrderDto
  ): Promise<SwaggerResponse<PurchaseOrderDto>> {
    let url_ = this.baseUrl + "/purchaseOrders/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdatePurchaseOrder(_response);
      });
  }

  protected processUpdatePurchaseOrder(
    response: Response
  ): Promise<SwaggerResponse<PurchaseOrderDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PurchaseOrderDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PurchaseOrderDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deletePurchaseOrder(id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/purchaseOrders/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeletePurchaseOrder(_response);
      });
  }

  protected processDeletePurchaseOrder(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  generatePurchaseOrderReport(
    id: string
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/purchaseOrders/{id}/report";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGeneratePurchaseOrderReport(_response);
      });
  }

  protected processGeneratePurchaseOrderReport(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getPurchaseOrderItems(
    id: string,
    sortBy: string | null | undefined,
    filterBy: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined
  ): Promise<SwaggerResponse<PaginatedOfPurchaseOrderItemDto>> {
    let url_ = this.baseUrl + "/purchaseOrders/{id}/items?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (filterBy !== undefined && filterBy !== null)
      url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetPurchaseOrderItems(_response);
      });
  }

  protected processGetPurchaseOrderItems(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfPurchaseOrderItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfPurchaseOrderItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfPurchaseOrderItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createPurchaseOrderItem(
    id: string,
    model: ManagePurchaseOrderItemDto
  ): Promise<SwaggerResponse<PurchaseOrderItemDto>> {
    let url_ = this.baseUrl + "/purchaseOrders/{id}/items";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreatePurchaseOrderItem(_response);
      });
  }

  protected processCreatePurchaseOrderItem(
    response: Response
  ): Promise<SwaggerResponse<PurchaseOrderItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PurchaseOrderItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PurchaseOrderItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getPurchaseOrderItemsWithBom(
    id: string,
    sortBy: string | null | undefined,
    filterBy: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined
  ): Promise<SwaggerResponse<PaginatedOfItemDto>> {
    let url_ = this.baseUrl + "/purchaseOrders/{id}/itemswithBom?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (filterBy !== undefined && filterBy !== null)
      url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetPurchaseOrderItemsWithBom(_response);
      });
  }

  protected processGetPurchaseOrderItemsWithBom(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getOrderItemsAvailable(
    id: string,
    sortBy: string | null | undefined,
    filterBy: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfItemDto>> {
    let url_ = this.baseUrl + "/purchaseOrders/{id}/items/available?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (filterBy !== undefined && filterBy !== null)
      url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetOrderItemsAvailable(_response);
      });
  }

  protected processGetOrderItemsAvailable(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportPurchaseOrderItems(
    id: string,
    fields: string | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/purchaseOrders/{id}/items/export?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportPurchaseOrderItems(_response);
      });
  }

  protected processExportPurchaseOrderItems(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getPurchaseOrderItem(
    purchaseOrderId: string,
    purchaseOrderitemId: string,
    itemId: string | null | undefined
  ): Promise<SwaggerResponse<PurchaseOrderItemDto>> {
    let url_ =
      this.baseUrl +
      "/purchaseOrders/{purchaseOrderId}/items/{purchaseOrderitemId}?";
    if (purchaseOrderId === undefined || purchaseOrderId === null)
      throw new Error("The parameter 'purchaseOrderId' must be defined.");
    url_ = url_.replace(
      "{purchaseOrderId}",
      encodeURIComponent("" + purchaseOrderId)
    );
    if (purchaseOrderitemId === undefined || purchaseOrderitemId === null)
      throw new Error("The parameter 'purchaseOrderitemId' must be defined.");
    url_ = url_.replace(
      "{purchaseOrderitemId}",
      encodeURIComponent("" + purchaseOrderitemId)
    );
    if (itemId !== undefined && itemId !== null)
      url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetPurchaseOrderItem(_response);
      });
  }

  protected processGetPurchaseOrderItem(
    response: Response
  ): Promise<SwaggerResponse<PurchaseOrderItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PurchaseOrderItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PurchaseOrderItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updatePurchaseOrderItem(
    id: string,
    itemId: string,
    model: ManagePurchaseOrderItemDto
  ): Promise<SwaggerResponse<PurchaseOrderItemDto>> {
    let url_ = this.baseUrl + "/purchaseOrders/{id}/items/{itemId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (itemId === undefined || itemId === null)
      throw new Error("The parameter 'itemId' must be defined.");
    url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdatePurchaseOrderItem(_response);
      });
  }

  protected processUpdatePurchaseOrderItem(
    response: Response
  ): Promise<SwaggerResponse<PurchaseOrderItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PurchaseOrderItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PurchaseOrderItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  removePurchaseOrderItem(
    id: string,
    itemId: string
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/purchaseOrders/{id}/items/{itemId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (itemId === undefined || itemId === null)
      throw new Error("The parameter 'itemId' must be defined.");
    url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processRemovePurchaseOrderItem(_response);
      });
  }

  protected processRemovePurchaseOrderItem(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updatePurchaseOrderItemOrder(
    id: string,
    itemId: string,
    model: ManageOrderItemsOrderDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/purchaseOrders/{id}/items/{itemId}/sort";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (itemId === undefined || itemId === null)
      throw new Error("The parameter 'itemId' must be defined.");
    url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdatePurchaseOrderItemOrder(_response);
      });
  }

  protected processUpdatePurchaseOrderItemOrder(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }
}

export class SaleOffersClient extends GestitClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: GestitClientOptions,
    baseUrl?: string,
    http?: {
      fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
    }
  ) {
    super(configuration);

    // @ts-ignore
    this.http = http ? http : (window as any);
    // @ts-ignore
    this.baseUrl = this.getBaseUrl("", baseUrl);

    this.jsonParseReviver = (k, v) => dateReviver(k, v, dateProperties);
  }

  getSaleOffers(
    sortBy: string | null | undefined,
    filterBy: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined,
    includeTotals: boolean | undefined
  ): Promise<SwaggerResponse<PaginatedWithTotalOfSaleOfferDto>> {
    let url_ = this.baseUrl + "/saleOffers?";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (filterBy !== undefined && filterBy !== null)
      url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    if (includeTotals === null)
      throw new Error("The parameter 'includeTotals' cannot be null.");
    else if (includeTotals !== undefined)
      url_ += "includeTotals=" + encodeURIComponent("" + includeTotals) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetSaleOffers(_response);
      });
  }

  protected processGetSaleOffers(
    response: Response
  ): Promise<SwaggerResponse<PaginatedWithTotalOfSaleOfferDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedWithTotalOfSaleOfferDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedWithTotalOfSaleOfferDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createSaleOffer(
    model: ManageSaleOfferDto
  ): Promise<SwaggerResponse<SaleOfferDto>> {
    let url_ = this.baseUrl + "/saleOffers";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateSaleOffer(_response);
      });
  }

  protected processCreateSaleOffer(
    response: Response
  ): Promise<SwaggerResponse<SaleOfferDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as SaleOfferDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<SaleOfferDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  checkValidSaleOfferTaxable(
    id: string,
    itemId: string | null | undefined,
    nextItemPrice: number | undefined
  ): Promise<SwaggerResponse<boolean>> {
    let url_ = this.baseUrl + "/saleOffers/{id}/checkTaxable?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (itemId !== undefined && itemId !== null)
      url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
    if (nextItemPrice === null)
      throw new Error("The parameter 'nextItemPrice' cannot be null.");
    else if (nextItemPrice !== undefined)
      url_ += "nextItemPrice=" + encodeURIComponent("" + nextItemPrice) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCheckValidSaleOfferTaxable(_response);
      });
  }

  protected processCheckValidSaleOfferTaxable(
    response: Response
  ): Promise<SwaggerResponse<boolean>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<boolean>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportSaleOffers(
    fields: string | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/saleOffers/export?";
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportSaleOffers(_response);
      });
  }

  protected processExportSaleOffers(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getSaleOffer(id: string): Promise<SwaggerResponse<SaleOfferDto>> {
    let url_ = this.baseUrl + "/saleOffers/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetSaleOffer(_response);
      });
  }

  protected processGetSaleOffer(
    response: Response
  ): Promise<SwaggerResponse<SaleOfferDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as SaleOfferDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<SaleOfferDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateSaleOffer(
    id: string,
    model: ManageSaleOfferDto
  ): Promise<SwaggerResponse<SaleOfferDto>> {
    let url_ = this.baseUrl + "/saleOffers/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateSaleOffer(_response);
      });
  }

  protected processUpdateSaleOffer(
    response: Response
  ): Promise<SwaggerResponse<SaleOfferDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as SaleOfferDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<SaleOfferDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteSaleOffer(id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/saleOffers/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteSaleOffer(_response);
      });
  }

  protected processDeleteSaleOffer(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getSaleOfferItems(
    id: string,
    sortBy: string | null | undefined,
    filterBy: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined
  ): Promise<SwaggerResponse<PaginatedOfSaleOfferItemDto>> {
    let url_ = this.baseUrl + "/saleOffers/{id}/items?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (filterBy !== undefined && filterBy !== null)
      url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetSaleOfferItems(_response);
      });
  }

  protected processGetSaleOfferItems(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfSaleOfferItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfSaleOfferItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfSaleOfferItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createSaleOfferItem(
    id: string,
    model: ManageSaleOfferItemDto
  ): Promise<SwaggerResponse<SaleOfferItemDto>> {
    let url_ = this.baseUrl + "/saleOffers/{id}/items";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateSaleOfferItem(_response);
      });
  }

  protected processCreateSaleOfferItem(
    response: Response
  ): Promise<SwaggerResponse<SaleOfferItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as SaleOfferItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<SaleOfferItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportSaleOfferItems(
    id: string,
    fields: string | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/saleOffers/{id}/items/export?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportSaleOfferItems(_response);
      });
  }

  protected processExportSaleOfferItems(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getSaleOfferItem(
    id: string,
    itemId: string
  ): Promise<SwaggerResponse<SaleOfferItemDto>> {
    let url_ = this.baseUrl + "/saleOffers/{id}/items/{itemId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (itemId === undefined || itemId === null)
      throw new Error("The parameter 'itemId' must be defined.");
    url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetSaleOfferItem(_response);
      });
  }

  protected processGetSaleOfferItem(
    response: Response
  ): Promise<SwaggerResponse<SaleOfferItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as SaleOfferItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<SaleOfferItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateSaleOfferItem(
    id: string,
    itemId: string,
    model: ManageSaleOfferItemDto
  ): Promise<SwaggerResponse<SaleOfferItemDto>> {
    let url_ = this.baseUrl + "/saleOffers/{id}/items/{itemId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (itemId === undefined || itemId === null)
      throw new Error("The parameter 'itemId' must be defined.");
    url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateSaleOfferItem(_response);
      });
  }

  protected processUpdateSaleOfferItem(
    response: Response
  ): Promise<SwaggerResponse<SaleOfferItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as SaleOfferItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<SaleOfferItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  removeSaleOfferItem(
    id: string,
    itemId: string
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/saleOffers/{id}/items/{itemId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (itemId === undefined || itemId === null)
      throw new Error("The parameter 'itemId' must be defined.");
    url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processRemoveSaleOfferItem(_response);
      });
  }

  protected processRemoveSaleOfferItem(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateSaleOfferItemOrder(
    id: string,
    itemId: string,
    model: ManageSaleOfferItemsOrderDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/saleOffers/{id}/items/{itemId}/sort";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (itemId === undefined || itemId === null)
      throw new Error("The parameter 'itemId' must be defined.");
    url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateSaleOfferItemOrder(_response);
      });
  }

  protected processUpdateSaleOfferItemOrder(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getOfferItemsAvailable(
    id: string,
    sortBy: string | null | undefined,
    filterBy: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfItemDto>> {
    let url_ = this.baseUrl + "/saleOffers/{id}/items/available?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (filterBy !== undefined && filterBy !== null)
      url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetOfferItemsAvailable(_response);
      });
  }

  protected processGetOfferItemsAvailable(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }
}

export class SaleOrdersClient extends GestitClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: GestitClientOptions,
    baseUrl?: string,
    http?: {
      fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
    }
  ) {
    super(configuration);

    // @ts-ignore
    this.http = http ? http : (window as any);
    // @ts-ignore
    this.baseUrl = this.getBaseUrl("", baseUrl);

    this.jsonParseReviver = (k, v) => dateReviver(k, v, dateProperties);
  }

  getSaleOrders(
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined,
    includeTotals: boolean | undefined
  ): Promise<SwaggerResponse<PaginatedSaleOrderWithTotal>> {
    let url_ = this.baseUrl + "/saleOrders?";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    if (includeTotals === null)
      throw new Error("The parameter 'includeTotals' cannot be null.");
    else if (includeTotals !== undefined)
      url_ += "includeTotals=" + encodeURIComponent("" + includeTotals) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetSaleOrders(_response);
      });
  }

  protected processGetSaleOrders(
    response: Response
  ): Promise<SwaggerResponse<PaginatedSaleOrderWithTotal>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedSaleOrderWithTotal);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedSaleOrderWithTotal>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createSaleOrder(
    model: ManageSaleOrderDto
  ): Promise<SwaggerResponse<SaleOrderDto>> {
    let url_ = this.baseUrl + "/saleOrders";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateSaleOrder(_response);
      });
  }

  protected processCreateSaleOrder(
    response: Response
  ): Promise<SwaggerResponse<SaleOrderDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as SaleOrderDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<SaleOrderDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  checkValidSaleOrderTaxable(
    id: string,
    itemId: string | null | undefined,
    nextItemPrice: number | undefined
  ): Promise<SwaggerResponse<boolean>> {
    let url_ = this.baseUrl + "/saleOrders/{id}/checkTaxable?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (itemId !== undefined && itemId !== null)
      url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
    if (nextItemPrice === null)
      throw new Error("The parameter 'nextItemPrice' cannot be null.");
    else if (nextItemPrice !== undefined)
      url_ += "nextItemPrice=" + encodeURIComponent("" + nextItemPrice) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCheckValidSaleOrderTaxable(_response);
      });
  }

  protected processCheckValidSaleOrderTaxable(
    response: Response
  ): Promise<SwaggerResponse<boolean>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<boolean>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportSaleOrders(
    fields: string | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/saleOrders/export?";
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportSaleOrders(_response);
      });
  }

  protected processExportSaleOrders(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getCommissions(
    id: string,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined
  ): Promise<SwaggerResponse<PaginatedOfCommissionDto>> {
    let url_ = this.baseUrl + "/saleOrders/{id}/commissions?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCommissions(_response);
      });
  }

  protected processGetCommissions(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfCommissionDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfCommissionDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfCommissionDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportCommissions(
    id: string,
    fields: string | undefined,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/saleOrders/{id}/commissions/export?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportCommissions(_response);
      });
  }

  protected processExportCommissions(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getSaleOrder(id: string): Promise<SwaggerResponse<SaleOrderDto>> {
    let url_ = this.baseUrl + "/saleOrders/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetSaleOrder(_response);
      });
  }

  protected processGetSaleOrder(
    response: Response
  ): Promise<SwaggerResponse<SaleOrderDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as SaleOrderDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<SaleOrderDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateSaleOrder(
    id: string,
    model: ManageSaleOrderDto
  ): Promise<SwaggerResponse<SaleOrderDto>> {
    let url_ = this.baseUrl + "/saleOrders/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateSaleOrder(_response);
      });
  }

  protected processUpdateSaleOrder(
    response: Response
  ): Promise<SwaggerResponse<SaleOrderDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as SaleOrderDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<SaleOrderDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteSaleOrder(id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/saleOrders/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteSaleOrder(_response);
      });
  }

  protected processDeleteSaleOrder(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  cancelSaleOrder(id: string): Promise<SwaggerResponse<SaleOrderItemDto>> {
    let url_ = this.baseUrl + "/saleOrders/{id}/cancel";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCancelSaleOrder(_response);
      });
  }

  protected processCancelSaleOrder(
    response: Response
  ): Promise<SwaggerResponse<SaleOrderItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as SaleOrderItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<SaleOrderItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  restoreSaleOrder(id: string): Promise<SwaggerResponse<SaleOrderItemDto>> {
    let url_ = this.baseUrl + "/saleOrders/{id}/restore";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processRestoreSaleOrder(_response);
      });
  }

  protected processRestoreSaleOrder(
    response: Response
  ): Promise<SwaggerResponse<SaleOrderItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as SaleOrderItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<SaleOrderItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  forceSaleOrderDelivery(
    id: string
  ): Promise<SwaggerResponse<SaleOrderItemDto>> {
    let url_ = this.baseUrl + "/saleOrders/{id}/forceDelivered";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processForceSaleOrderDelivery(_response);
      });
  }

  protected processForceSaleOrderDelivery(
    response: Response
  ): Promise<SwaggerResponse<SaleOrderItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as SaleOrderItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<SaleOrderItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  unforceSaleOrderDelivery(
    id: string
  ): Promise<SwaggerResponse<SaleOrderItemDto>> {
    let url_ = this.baseUrl + "/saleOrders/{id}/unforceDelivered";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUnforceSaleOrderDelivery(_response);
      });
  }

  protected processUnforceSaleOrderDelivery(
    response: Response
  ): Promise<SwaggerResponse<SaleOrderItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as SaleOrderItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<SaleOrderItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createCommissionFromSaleOrder(
    id: string,
    useOrderCode: boolean | undefined
  ): Promise<SwaggerResponse<CommissionDto>> {
    let url_ = this.baseUrl + "/saleOrders/{id}/createCommission?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (useOrderCode === null)
      throw new Error("The parameter 'useOrderCode' cannot be null.");
    else if (useOrderCode !== undefined)
      url_ += "useOrderCode=" + encodeURIComponent("" + useOrderCode) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateCommissionFromSaleOrder(_response);
      });
  }

  protected processCreateCommissionFromSaleOrder(
    response: Response
  ): Promise<SwaggerResponse<CommissionDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as CommissionDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<CommissionDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getSaleOrderDeliveryDocuments(
    id: string,
    sortBy: string | null | undefined,
    filterBy: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined
  ): Promise<SwaggerResponse<PaginatedOfDeliveryDocumentDto>> {
    let url_ = this.baseUrl + "/saleOrders/{id}/deliveryDocuments?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (filterBy !== undefined && filterBy !== null)
      url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetSaleOrderDeliveryDocuments(_response);
      });
  }

  protected processGetSaleOrderDeliveryDocuments(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfDeliveryDocumentDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfDeliveryDocumentDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfDeliveryDocumentDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportSaleOrderDeliveryDocuments(
    id: string,
    fields: string | undefined,
    sortBy: string | null | undefined,
    filterBy: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/saleOrders/{id}/deliveryDocuments/export?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (filterBy !== undefined && filterBy !== null)
      url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportSaleOrderDeliveryDocuments(_response);
      });
  }

  protected processExportSaleOrderDeliveryDocuments(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getSaleOrderBillingDocuments(
    id: string,
    sortBy: string | null | undefined,
    filterBy: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined
  ): Promise<SwaggerResponse<PaginatedOfBillingDocumentDto>> {
    let url_ = this.baseUrl + "/saleOrders/{id}/billingDocuments?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (filterBy !== undefined && filterBy !== null)
      url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetSaleOrderBillingDocuments(_response);
      });
  }

  protected processGetSaleOrderBillingDocuments(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfBillingDocumentDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfBillingDocumentDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfBillingDocumentDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportSaleOrderBillingDocuments(
    id: string,
    fields: string | undefined,
    sortBy: string | null | undefined,
    filterBy: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/saleOrders/{id}/billingDocuments/export?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (filterBy !== undefined && filterBy !== null)
      url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportSaleOrderBillingDocuments(_response);
      });
  }

  protected processExportSaleOrderBillingDocuments(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  generateSaleOrderReport(id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/saleOrders/{id}/report";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGenerateSaleOrderReport(_response);
      });
  }

  protected processGenerateSaleOrderReport(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getSaleOrderItems(
    id: string,
    sortBy: string | null | undefined,
    filterBy: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined
  ): Promise<SwaggerResponse<PaginatedOfSaleOrderItemDto>> {
    let url_ = this.baseUrl + "/saleOrders/{id}/items?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (filterBy !== undefined && filterBy !== null)
      url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetSaleOrderItems(_response);
      });
  }

  protected processGetSaleOrderItems(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfSaleOrderItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfSaleOrderItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfSaleOrderItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createSaleOrderItem(
    id: string,
    model: ManageSaleOrderItemDto
  ): Promise<SwaggerResponse<SaleOrderItemDto>> {
    let url_ = this.baseUrl + "/saleOrders/{id}/items";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateSaleOrderItem(_response);
      });
  }

  protected processCreateSaleOrderItem(
    response: Response
  ): Promise<SwaggerResponse<SaleOrderItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as SaleOrderItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<SaleOrderItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getSaleOrderItemsWithBom(
    id: string,
    sortBy: string | null | undefined,
    filterBy: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined
  ): Promise<SwaggerResponse<PaginatedOfSaleOrderItemDto>> {
    let url_ = this.baseUrl + "/saleOrders/{id}/itemswithBom?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (filterBy !== undefined && filterBy !== null)
      url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetSaleOrderItemsWithBom(_response);
      });
  }

  protected processGetSaleOrderItemsWithBom(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfSaleOrderItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfSaleOrderItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfSaleOrderItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getOrderItemsAvailable(
    id: string,
    sortBy: string | null | undefined,
    filterBy: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfItemDto>> {
    let url_ = this.baseUrl + "/saleOrders/{id}/items/available?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (filterBy !== undefined && filterBy !== null)
      url_ += "filterBy=" + encodeURIComponent("" + filterBy) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetOrderItemsAvailable(_response);
      });
  }

  protected processGetOrderItemsAvailable(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportSaleOrderItems(
    id: string,
    fields: string | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/saleOrders/{id}/items/export?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportSaleOrderItems(_response);
      });
  }

  protected processExportSaleOrderItems(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getSaleOrderItem(
    saleOrderId: string,
    saleOrderitemId: string,
    itemId: string | null | undefined
  ): Promise<SwaggerResponse<SaleOrderItemDto>> {
    let url_ =
      this.baseUrl + "/saleOrders/{saleOrderId}/items/{saleOrderitemId}?";
    if (saleOrderId === undefined || saleOrderId === null)
      throw new Error("The parameter 'saleOrderId' must be defined.");
    url_ = url_.replace("{saleOrderId}", encodeURIComponent("" + saleOrderId));
    if (saleOrderitemId === undefined || saleOrderitemId === null)
      throw new Error("The parameter 'saleOrderitemId' must be defined.");
    url_ = url_.replace(
      "{saleOrderitemId}",
      encodeURIComponent("" + saleOrderitemId)
    );
    if (itemId !== undefined && itemId !== null)
      url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetSaleOrderItem(_response);
      });
  }

  protected processGetSaleOrderItem(
    response: Response
  ): Promise<SwaggerResponse<SaleOrderItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as SaleOrderItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<SaleOrderItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateSaleOrderItem(
    id: string,
    itemId: string,
    model: ManageSaleOrderItemDto
  ): Promise<SwaggerResponse<SaleOrderItemDto>> {
    let url_ = this.baseUrl + "/saleOrders/{id}/items/{itemId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (itemId === undefined || itemId === null)
      throw new Error("The parameter 'itemId' must be defined.");
    url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateSaleOrderItem(_response);
      });
  }

  protected processUpdateSaleOrderItem(
    response: Response
  ): Promise<SwaggerResponse<SaleOrderItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as SaleOrderItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<SaleOrderItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  removeSaleOrderItem(
    id: string,
    itemId: string
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/saleOrders/{id}/items/{itemId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (itemId === undefined || itemId === null)
      throw new Error("The parameter 'itemId' must be defined.");
    url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processRemoveSaleOrderItem(_response);
      });
  }

  protected processRemoveSaleOrderItem(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  cancelSaleOrderItem(
    id: string,
    itemId: string
  ): Promise<SwaggerResponse<SaleOrderItemDto>> {
    let url_ = this.baseUrl + "/saleOrders/{id}/items/{itemId}/cancel";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (itemId === undefined || itemId === null)
      throw new Error("The parameter 'itemId' must be defined.");
    url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCancelSaleOrderItem(_response);
      });
  }

  protected processCancelSaleOrderItem(
    response: Response
  ): Promise<SwaggerResponse<SaleOrderItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as SaleOrderItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<SaleOrderItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  restoreSaleOrderItem(
    id: string,
    itemId: string
  ): Promise<SwaggerResponse<SaleOrderItemDto>> {
    let url_ = this.baseUrl + "/saleOrders/{id}/items/{itemId}/restore";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (itemId === undefined || itemId === null)
      throw new Error("The parameter 'itemId' must be defined.");
    url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processRestoreSaleOrderItem(_response);
      });
  }

  protected processRestoreSaleOrderItem(
    response: Response
  ): Promise<SwaggerResponse<SaleOrderItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as SaleOrderItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<SaleOrderItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  forceSaleOrderItemDelivery(
    id: string,
    itemId: string
  ): Promise<SwaggerResponse<SaleOrderItemDto>> {
    let url_ = this.baseUrl + "/saleOrders/{id}/items/{itemId}/forceDelivered";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (itemId === undefined || itemId === null)
      throw new Error("The parameter 'itemId' must be defined.");
    url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processForceSaleOrderItemDelivery(_response);
      });
  }

  protected processForceSaleOrderItemDelivery(
    response: Response
  ): Promise<SwaggerResponse<SaleOrderItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as SaleOrderItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<SaleOrderItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  unforceSaleOrderItemDelivery(
    id: string,
    itemId: string
  ): Promise<SwaggerResponse<SaleOrderItemDto>> {
    let url_ =
      this.baseUrl + "/saleOrders/{id}/items/{itemId}/unforceDelivered";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (itemId === undefined || itemId === null)
      throw new Error("The parameter 'itemId' must be defined.");
    url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUnforceSaleOrderItemDelivery(_response);
      });
  }

  protected processUnforceSaleOrderItemDelivery(
    response: Response
  ): Promise<SwaggerResponse<SaleOrderItemDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as SaleOrderItemDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<SaleOrderItemDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateSaleOrderItemOrder(
    id: string,
    itemId: string,
    model: ManageOrderItemsOrderDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/saleOrders/{id}/items/{itemId}/sort";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (itemId === undefined || itemId === null)
      throw new Error("The parameter 'itemId' must be defined.");
    url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateSaleOrderItemOrder(_response);
      });
  }

  protected processUpdateSaleOrderItemOrder(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportItemLabels(
    id: string,
    model: CreateLabelDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/saleOrders/{id}/labels";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportItemLabels(_response);
      });
  }

  protected processExportItemLabels(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }
}

export class SavedQueriesClient extends GestitClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: GestitClientOptions,
    baseUrl?: string,
    http?: {
      fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
    }
  ) {
    super(configuration);

    // @ts-ignore
    this.http = http ? http : (window as any);
    // @ts-ignore
    this.baseUrl = this.getBaseUrl("", baseUrl);

    this.jsonParseReviver = (k, v) => dateReviver(k, v, dateProperties);
  }

  getSavedQueries(
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfSavedQueryDto>> {
    let url_ = this.baseUrl + "/savedQueries?";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetSavedQueries(_response);
      });
  }

  protected processGetSavedQueries(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfSavedQueryDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfSavedQueryDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfSavedQueryDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  saveQuery(
    data: CreateSavedQueryDto
  ): Promise<SwaggerResponse<SavedQueryDto>> {
    let url_ = this.baseUrl + "/savedQueries";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(data);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSaveQuery(_response);
      });
  }

  protected processSaveQuery(
    response: Response
  ): Promise<SwaggerResponse<SavedQueryDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        result201 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as SavedQueryDto);
        return new SwaggerResponse(status, _headers, result201);
      });
    } else {
      return response.text().then((_responseText) => {
        let resultdefault: any = null;
        resultdefault =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as ProblemDetails);
        return throwException(
          "A server side error occurred.",
          status,
          _responseText,
          _headers,
          resultdefault
        );
      });
    }
  }

  getSavedQuery(id: string): Promise<SwaggerResponse<SavedQueryDto>> {
    let url_ = this.baseUrl + "/savedQueries/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetSavedQuery(_response);
      });
  }

  protected processGetSavedQuery(
    response: Response
  ): Promise<SwaggerResponse<SavedQueryDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as SavedQueryDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<SavedQueryDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateSavedQuery(
    id: string,
    data: UpdateSavedQueryDto
  ): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + "/savedQueries/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(data);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateSavedQuery(_response);
      });
  }

  protected processUpdateSavedQuery(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, null as any);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteSavedQuery(id: string): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + "/savedQueries/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteSavedQuery(_response);
      });
  }

  protected processDeleteSavedQuery(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, null as any);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getScheduledExports(
    savedQueryId: string,
    sortBy: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfSavedQueryScheduledExportDto>> {
    let url_ = this.baseUrl + "/savedQueries/{savedQueryId}/scheduledExports?";
    if (savedQueryId === undefined || savedQueryId === null)
      throw new Error("The parameter 'savedQueryId' must be defined.");
    url_ = url_.replace(
      "{savedQueryId}",
      encodeURIComponent("" + savedQueryId)
    );
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetScheduledExports(_response);
      });
  }

  protected processGetScheduledExports(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfSavedQueryScheduledExportDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfSavedQueryScheduledExportDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<
      SwaggerResponse<PaginatedOfSavedQueryScheduledExportDto>
    >(new SwaggerResponse(status, _headers, null as any));
  }

  scheduleExport(
    savedQueryId: string,
    data: ManageSavedQueryScheduledExportDto
  ): Promise<SwaggerResponse<SavedQueryScheduledExportDto>> {
    let url_ = this.baseUrl + "/savedQueries/{savedQueryId}/scheduledExports";
    if (savedQueryId === undefined || savedQueryId === null)
      throw new Error("The parameter 'savedQueryId' must be defined.");
    url_ = url_.replace(
      "{savedQueryId}",
      encodeURIComponent("" + savedQueryId)
    );
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(data);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processScheduleExport(_response);
      });
  }

  protected processScheduleExport(
    response: Response
  ): Promise<SwaggerResponse<SavedQueryScheduledExportDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        result201 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as SavedQueryScheduledExportDto);
        return new SwaggerResponse(status, _headers, result201);
      });
    } else {
      return response.text().then((_responseText) => {
        let resultdefault: any = null;
        resultdefault =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as ProblemDetails);
        return throwException(
          "A server side error occurred.",
          status,
          _responseText,
          _headers,
          resultdefault
        );
      });
    }
  }

  getScheduledExport(
    savedQueryId: string,
    id: string
  ): Promise<SwaggerResponse<SavedQueryScheduledExportDto>> {
    let url_ =
      this.baseUrl + "/savedQueries/{savedQueryId}/scheduledExports/{id}";
    if (savedQueryId === undefined || savedQueryId === null)
      throw new Error("The parameter 'savedQueryId' must be defined.");
    url_ = url_.replace(
      "{savedQueryId}",
      encodeURIComponent("" + savedQueryId)
    );
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetScheduledExport(_response);
      });
  }

  protected processGetScheduledExport(
    response: Response
  ): Promise<SwaggerResponse<SavedQueryScheduledExportDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as SavedQueryScheduledExportDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<SavedQueryScheduledExportDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateScheduledExport(
    savedQueryId: string,
    id: string,
    data: ManageSavedQueryScheduledExportDto
  ): Promise<SwaggerResponse<void>> {
    let url_ =
      this.baseUrl + "/savedQueries/{savedQueryId}/scheduledExports/{id}";
    if (savedQueryId === undefined || savedQueryId === null)
      throw new Error("The parameter 'savedQueryId' must be defined.");
    url_ = url_.replace(
      "{savedQueryId}",
      encodeURIComponent("" + savedQueryId)
    );
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(data);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateScheduledExport(_response);
      });
  }

  protected processUpdateScheduledExport(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, null as any);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteScheduledExport(
    savedQueryId: string,
    id: string
  ): Promise<SwaggerResponse<void>> {
    let url_ =
      this.baseUrl + "/savedQueries/{savedQueryId}/scheduledExports/{id}";
    if (savedQueryId === undefined || savedQueryId === null)
      throw new Error("The parameter 'savedQueryId' must be defined.");
    url_ = url_.replace(
      "{savedQueryId}",
      encodeURIComponent("" + savedQueryId)
    );
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteScheduledExport(_response);
      });
  }

  protected processDeleteScheduledExport(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, null as any);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }
}

export class SkillsClient extends GestitClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: GestitClientOptions,
    baseUrl?: string,
    http?: {
      fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
    }
  ) {
    super(configuration);

    // @ts-ignore
    this.http = http ? http : (window as any);
    // @ts-ignore
    this.baseUrl = this.getBaseUrl("", baseUrl);

    this.jsonParseReviver = (k, v) => dateReviver(k, v, dateProperties);
  }

  getSkills(
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfSkillDto>> {
    let url_ = this.baseUrl + "/skills?";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetSkills(_response);
      });
  }

  protected processGetSkills(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfSkillDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfSkillDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfSkillDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createSkill(model: ManageSkillDto): Promise<SwaggerResponse<SkillDto>> {
    let url_ = this.baseUrl + "/skills";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateSkill(_response);
      });
  }

  protected processCreateSkill(
    response: Response
  ): Promise<SwaggerResponse<SkillDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as SkillDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<SkillDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportSkills(
    fields: string | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/skills/export?";
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportSkills(_response);
      });
  }

  protected processExportSkills(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getSkill(id: string): Promise<SwaggerResponse<SkillDto>> {
    let url_ = this.baseUrl + "/skills/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetSkill(_response);
      });
  }

  protected processGetSkill(
    response: Response
  ): Promise<SwaggerResponse<SkillDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as SkillDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<SkillDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateSkill(
    id: string,
    model: ManageSkillDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/skills/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateSkill(_response);
      });
  }

  protected processUpdateSkill(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteSkill(id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/skills/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteSkill(_response);
      });
  }

  protected processDeleteSkill(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getEmployeeSkills(
    employeeId: string,
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfSkillDto>> {
    let url_ = this.baseUrl + "/employees/{employeeId}/skills?";
    if (employeeId === undefined || employeeId === null)
      throw new Error("The parameter 'employeeId' must be defined.");
    url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetEmployeeSkills(_response);
      });
  }

  protected processGetEmployeeSkills(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfSkillDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfSkillDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfSkillDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  addSkillToEmployee(
    employeeId: string,
    model: AddSkillToEmployeeDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/employees/{employeeId}/skills";
    if (employeeId === undefined || employeeId === null)
      throw new Error("The parameter 'employeeId' must be defined.");
    url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAddSkillToEmployee(_response);
      });
  }

  protected processAddSkillToEmployee(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getSkillsAvailableForEmployee(
    employeeId: string,
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfSkillDto>> {
    let url_ = this.baseUrl + "/employees/{employeeId}/skills/available?";
    if (employeeId === undefined || employeeId === null)
      throw new Error("The parameter 'employeeId' must be defined.");
    url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetSkillsAvailableForEmployee(_response);
      });
  }

  protected processGetSkillsAvailableForEmployee(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfSkillDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfSkillDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfSkillDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  removeSkillFromEmployee(
    employeeId: string,
    skillId: string
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/employees/{employeeId}/skills/{skillId}";
    if (employeeId === undefined || employeeId === null)
      throw new Error("The parameter 'employeeId' must be defined.");
    url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
    if (skillId === undefined || skillId === null)
      throw new Error("The parameter 'skillId' must be defined.");
    url_ = url_.replace("{skillId}", encodeURIComponent("" + skillId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processRemoveSkillFromEmployee(_response);
      });
  }

  protected processRemoveSkillFromEmployee(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }
}

export class StatisticsClient extends GestitClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: GestitClientOptions,
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    super(configuration);
    this.http = http ? http : (window as any);
    this.baseUrl = this.getBaseUrl("", baseUrl);
  }

  getCounters(): Promise<SwaggerResponse<CountersDto>> {
    let url_ = this.baseUrl + "/statistics/counters";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCounters(_response);
      });
  }

  protected processGetCounters(
    response: Response
  ): Promise<SwaggerResponse<CountersDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as CountersDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<CountersDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getTurnovers(
    fromDate: Date | undefined,
    toDate: Date | undefined,
    comparedMonth: number | null | undefined,
    customersId: string[] | null | undefined,
    period: TurnoverPeriod | undefined,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfTurnoverDto>> {
    let url_ = this.baseUrl + "/statistics/turnovers?";
    if (fromDate === null)
      throw new Error("The parameter 'fromDate' cannot be null.");
    else if (fromDate !== undefined)
      url_ +=
        "FromDate=" +
        encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") +
        "&";
    if (toDate === null)
      throw new Error("The parameter 'toDate' cannot be null.");
    else if (toDate !== undefined)
      url_ +=
        "ToDate=" +
        encodeURIComponent(toDate ? "" + toDate.toISOString() : "") +
        "&";
    if (comparedMonth !== undefined && comparedMonth !== null)
      url_ += "ComparedMonth=" + encodeURIComponent("" + comparedMonth) + "&";
    if (customersId !== undefined && customersId !== null)
      customersId &&
        customersId.forEach((item) => {
          url_ += "CustomersId=" + encodeURIComponent("" + item) + "&";
        });
    if (period === null)
      throw new Error("The parameter 'period' cannot be null.");
    else if (period !== undefined)
      url_ += "Period=" + encodeURIComponent("" + period) + "&";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetTurnovers(_response);
      });
  }

  protected processGetTurnovers(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfTurnoverDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfTurnoverDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfTurnoverDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportTurnovers(
    fromDate: Date | undefined,
    toDate: Date | undefined,
    comparedMonth: number | null | undefined,
    customersId: string[] | null | undefined,
    period: TurnoverPeriod | undefined,
    fields: string | undefined,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/statistics/turnovers/export?";
    if (fromDate === null)
      throw new Error("The parameter 'fromDate' cannot be null.");
    else if (fromDate !== undefined)
      url_ +=
        "FromDate=" +
        encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") +
        "&";
    if (toDate === null)
      throw new Error("The parameter 'toDate' cannot be null.");
    else if (toDate !== undefined)
      url_ +=
        "ToDate=" +
        encodeURIComponent(toDate ? "" + toDate.toISOString() : "") +
        "&";
    if (comparedMonth !== undefined && comparedMonth !== null)
      url_ += "ComparedMonth=" + encodeURIComponent("" + comparedMonth) + "&";
    if (customersId !== undefined && customersId !== null)
      customersId &&
        customersId.forEach((item) => {
          url_ += "CustomersId=" + encodeURIComponent("" + item) + "&";
        });
    if (period === null)
      throw new Error("The parameter 'period' cannot be null.");
    else if (period !== undefined)
      url_ += "Period=" + encodeURIComponent("" + period) + "&";
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportTurnovers(_response);
      });
  }

  protected processExportTurnovers(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getCustomersTurnovers(
    fromDate: Date | undefined,
    toDate: Date | undefined,
    comparedMonth: number | null | undefined,
    customersId: string[] | null | undefined,
    period: TurnoverPeriod | undefined,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfCustomerTurnoverDto>> {
    let url_ = this.baseUrl + "/statistics/customers/turnovers?";
    if (fromDate === null)
      throw new Error("The parameter 'fromDate' cannot be null.");
    else if (fromDate !== undefined)
      url_ +=
        "FromDate=" +
        encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") +
        "&";
    if (toDate === null)
      throw new Error("The parameter 'toDate' cannot be null.");
    else if (toDate !== undefined)
      url_ +=
        "ToDate=" +
        encodeURIComponent(toDate ? "" + toDate.toISOString() : "") +
        "&";
    if (comparedMonth !== undefined && comparedMonth !== null)
      url_ += "ComparedMonth=" + encodeURIComponent("" + comparedMonth) + "&";
    if (customersId !== undefined && customersId !== null)
      customersId &&
        customersId.forEach((item) => {
          url_ += "CustomersId=" + encodeURIComponent("" + item) + "&";
        });
    if (period === null)
      throw new Error("The parameter 'period' cannot be null.");
    else if (period !== undefined)
      url_ += "Period=" + encodeURIComponent("" + period) + "&";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCustomersTurnovers(_response);
      });
  }

  protected processGetCustomersTurnovers(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfCustomerTurnoverDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfCustomerTurnoverDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfCustomerTurnoverDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getItemsTurnovers(
    fromDate: Date | undefined,
    toDate: Date | undefined,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfItemTurnoverDto>> {
    let url_ = this.baseUrl + "/statistics/items/turnovers?";
    if (fromDate === null)
      throw new Error("The parameter 'fromDate' cannot be null.");
    else if (fromDate !== undefined)
      url_ +=
        "FromDate=" +
        encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") +
        "&";
    if (toDate === null)
      throw new Error("The parameter 'toDate' cannot be null.");
    else if (toDate !== undefined)
      url_ +=
        "ToDate=" +
        encodeURIComponent(toDate ? "" + toDate.toISOString() : "") +
        "&";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetItemsTurnovers(_response);
      });
  }

  protected processGetItemsTurnovers(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfItemTurnoverDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfItemTurnoverDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfItemTurnoverDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportItemsTurnovers(
    fromDate: Date | undefined,
    toDate: Date | undefined,
    fields: string | undefined,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/statistics/items/turnovers/export?";
    if (fromDate === null)
      throw new Error("The parameter 'fromDate' cannot be null.");
    else if (fromDate !== undefined)
      url_ +=
        "FromDate=" +
        encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") +
        "&";
    if (toDate === null)
      throw new Error("The parameter 'toDate' cannot be null.");
    else if (toDate !== undefined)
      url_ +=
        "ToDate=" +
        encodeURIComponent(toDate ? "" + toDate.toISOString() : "") +
        "&";
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportItemsTurnovers(_response);
      });
  }

  protected processExportItemsTurnovers(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }
}

export class SuppliersClient extends GestitClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: GestitClientOptions,
    baseUrl?: string,
    http?: {
      fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
    }
  ) {
    super(configuration);

    // @ts-ignore
    this.http = http ? http : (window as any);
    // @ts-ignore
    this.baseUrl = this.getBaseUrl("", baseUrl);

    this.jsonParseReviver = (k, v) => dateReviver(k, v, dateProperties);
  }

  getSuppliers(
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfSupplierDto>> {
    let url_ = this.baseUrl + "/suppliers?";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetSuppliers(_response);
      });
  }

  protected processGetSuppliers(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfSupplierDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfSupplierDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfSupplierDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createSupplier(
    model: ManageSupplierDto
  ): Promise<SwaggerResponse<SupplierDto>> {
    let url_ = this.baseUrl + "/suppliers";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateSupplier(_response);
      });
  }

  protected processCreateSupplier(
    response: Response
  ): Promise<SwaggerResponse<SupplierDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as SupplierDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<SupplierDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportSuppliers(
    fields: string | undefined,
    sortBy: string | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/suppliers/export?";
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportSuppliers(_response);
      });
  }

  protected processExportSuppliers(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getDefaultSupplier(): Promise<SwaggerResponse<SupplierDto>> {
    let url_ = this.baseUrl + "/suppliers/default";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetDefaultSupplier(_response);
      });
  }

  protected processGetDefaultSupplier(
    response: Response
  ): Promise<SwaggerResponse<SupplierDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as SupplierDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<SupplierDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getSupplier(id: string): Promise<SwaggerResponse<SupplierDto>> {
    let url_ = this.baseUrl + "/suppliers/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetSupplier(_response);
      });
  }

  protected processGetSupplier(
    response: Response
  ): Promise<SwaggerResponse<SupplierDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as SupplierDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<SupplierDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateSupplier(
    id: string,
    model: ManageSupplierDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/suppliers/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateSupplier(_response);
      });
  }

  protected processUpdateSupplier(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteSupplier(id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/suppliers/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteSupplier(_response);
      });
  }

  protected processDeleteSupplier(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getSupplierOffices(
    id: string,
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfSupplierOfficeDto>> {
    let url_ = this.baseUrl + "/suppliers/{id}/offices?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetSupplierOffices(_response);
      });
  }

  protected processGetSupplierOffices(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfSupplierOfficeDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfSupplierOfficeDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfSupplierOfficeDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createSupplierOffice(
    id: string,
    model: SupplierOfficeManageDto
  ): Promise<SwaggerResponse<SupplierOfficeDto>> {
    let url_ = this.baseUrl + "/suppliers/{id}/offices";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateSupplierOffice(_response);
      });
  }

  protected processCreateSupplierOffice(
    response: Response
  ): Promise<SwaggerResponse<SupplierOfficeDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as SupplierOfficeDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<SupplierOfficeDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateSupplierOffice(
    id: string,
    supplierOfficeId: string,
    model: SupplierOfficeManageDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/suppliers/{id}/offices/{supplierOfficeId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (supplierOfficeId === undefined || supplierOfficeId === null)
      throw new Error("The parameter 'supplierOfficeId' must be defined.");
    url_ = url_.replace(
      "{supplierOfficeId}",
      encodeURIComponent("" + supplierOfficeId)
    );
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateSupplierOffice(_response);
      });
  }

  protected processUpdateSupplierOffice(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getSupplierOffice(
    id: string,
    supplierOfficeId: string
  ): Promise<SwaggerResponse<SupplierOfficeDto>> {
    let url_ = this.baseUrl + "/suppliers/{id}/offices/{supplierOfficeId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (supplierOfficeId === undefined || supplierOfficeId === null)
      throw new Error("The parameter 'supplierOfficeId' must be defined.");
    url_ = url_.replace(
      "{supplierOfficeId}",
      encodeURIComponent("" + supplierOfficeId)
    );
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetSupplierOffice(_response);
      });
  }

  protected processGetSupplierOffice(
    response: Response
  ): Promise<SwaggerResponse<SupplierOfficeDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as SupplierOfficeDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<SupplierOfficeDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteSupplierOffice(
    id: string,
    supplierOfficeId: string
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/suppliers/{id}/offices/{supplierOfficeId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (supplierOfficeId === undefined || supplierOfficeId === null)
      throw new Error("The parameter 'supplierOfficeId' must be defined.");
    url_ = url_.replace(
      "{supplierOfficeId}",
      encodeURIComponent("" + supplierOfficeId)
    );
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteSupplierOffice(_response);
      });
  }

  protected processDeleteSupplierOffice(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }
}

export class TaxCodesClient extends GestitClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: GestitClientOptions,
    baseUrl?: string,
    http?: {
      fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
    }
  ) {
    super(configuration);

    // @ts-ignore
    this.http = http ? http : (window as any);
    // @ts-ignore
    this.baseUrl = this.getBaseUrl("", baseUrl);

    this.jsonParseReviver = (k, v) => dateReviver(k, v, dateProperties);
  }

  getTaxCodes(
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfTaxCodeDto>> {
    let url_ = this.baseUrl + "/taxCodes?";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetTaxCodes(_response);
      });
  }

  protected processGetTaxCodes(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfTaxCodeDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfTaxCodeDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfTaxCodeDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createTaxCode(model: ManageTaxCodeDto): Promise<SwaggerResponse<TaxCodeDto>> {
    let url_ = this.baseUrl + "/taxCodes";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateTaxCode(_response);
      });
  }

  protected processCreateTaxCode(
    response: Response
  ): Promise<SwaggerResponse<TaxCodeDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as TaxCodeDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<TaxCodeDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getEiCodes(
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfEiCodingDto>> {
    let url_ = this.baseUrl + "/taxCodes/eiCodes?";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetEiCodes(_response);
      });
  }

  protected processGetEiCodes(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfEiCodingDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfEiCodingDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfEiCodingDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportTaxCodes(
    fields: string | undefined,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    accept: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/taxCodes/export?";
    if (fields === null)
      throw new Error("The parameter 'fields' cannot be null.");
    else if (fields !== undefined)
      url_ += "fields=" + encodeURIComponent("" + fields) + "&";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: accept !== undefined && accept !== null ? "" + accept : "",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportTaxCodes(_response);
      });
  }

  protected processExportTaxCodes(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getTaxCode(id: string): Promise<SwaggerResponse<TaxCodeDto>> {
    let url_ = this.baseUrl + "/taxCodes/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetTaxCode(_response);
      });
  }

  protected processGetTaxCode(
    response: Response
  ): Promise<SwaggerResponse<TaxCodeDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as TaxCodeDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<TaxCodeDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateTaxCode(
    id: string,
    model: ManageTaxCodeDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/taxCodes/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateTaxCode(_response);
      });
  }

  protected processUpdateTaxCode(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteTaxCode(id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/taxCodes/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteTaxCode(_response);
      });
  }

  protected processDeleteTaxCode(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }
}

export class TimeSheetClient extends GestitClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: GestitClientOptions,
    baseUrl?: string,
    http?: {
      fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
    }
  ) {
    super(configuration);

    // @ts-ignore
    this.http = http ? http : (window as any);
    // @ts-ignore
    this.baseUrl = this.getBaseUrl("", baseUrl);

    this.jsonParseReviver = (k, v) => dateReviver(k, v, dateProperties);
  }

  getAllEntries(
    startAt: Date | undefined,
    endAt: Date | undefined,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined
  ): Promise<SwaggerResponse<PaginatedOfTimeSheetEntryDto>> {
    let url_ = this.baseUrl + "/timesheet/entries?";
    if (startAt === null)
      throw new Error("The parameter 'startAt' cannot be null.");
    else if (startAt !== undefined)
      url_ +=
        "startAt=" +
        encodeURIComponent(startAt ? "" + startAt.toISOString() : "") +
        "&";
    if (endAt === null)
      throw new Error("The parameter 'endAt' cannot be null.");
    else if (endAt !== undefined)
      url_ +=
        "endAt=" +
        encodeURIComponent(endAt ? "" + endAt.toISOString() : "") +
        "&";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAllEntries(_response);
      });
  }

  protected processGetAllEntries(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfTimeSheetEntryDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfTimeSheetEntryDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfTimeSheetEntryDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getEntryEmployees(
    id: string,
    startAt: Date | undefined,
    endAt: Date | undefined
  ): Promise<SwaggerResponse<TimeSheetEntryEmployeeDto[]>> {
    let url_ = this.baseUrl + "/timesheet/entries/{id}/employees?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (startAt === null)
      throw new Error("The parameter 'startAt' cannot be null.");
    else if (startAt !== undefined)
      url_ +=
        "startAt=" +
        encodeURIComponent(startAt ? "" + startAt.toISOString() : "") +
        "&";
    if (endAt === null)
      throw new Error("The parameter 'endAt' cannot be null.");
    else if (endAt !== undefined)
      url_ +=
        "endAt=" +
        encodeURIComponent(endAt ? "" + endAt.toISOString() : "") +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetEntryEmployees(_response);
      });
  }

  protected processGetEntryEmployees(
    response: Response
  ): Promise<SwaggerResponse<TimeSheetEntryEmployeeDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as TimeSheetEntryEmployeeDto[]);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<TimeSheetEntryEmployeeDto[]>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getEmployeeEntries(
    id: string,
    startAt: Date | undefined,
    endAt: Date | undefined,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined
  ): Promise<SwaggerResponse<PaginatedOfTimeSheetEntryDto>> {
    let url_ = this.baseUrl + "/timesheet/employees/{id}/entries?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (startAt === null)
      throw new Error("The parameter 'startAt' cannot be null.");
    else if (startAt !== undefined)
      url_ +=
        "startAt=" +
        encodeURIComponent(startAt ? "" + startAt.toISOString() : "") +
        "&";
    if (endAt === null)
      throw new Error("The parameter 'endAt' cannot be null.");
    else if (endAt !== undefined)
      url_ +=
        "endAt=" +
        encodeURIComponent(endAt ? "" + endAt.toISOString() : "") +
        "&";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetEmployeeEntries(_response);
      });
  }

  protected processGetEmployeeEntries(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfTimeSheetEntryDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfTimeSheetEntryDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfTimeSheetEntryDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getMyEntries(
    startAt: Date | undefined,
    endAt: Date | undefined,
    sortBy: string | null | undefined,
    q: string | null | undefined,
    offset: number | null | undefined,
    limit: number | null | undefined
  ): Promise<SwaggerResponse<PaginatedOfTimeSheetEntryDto>> {
    let url_ = this.baseUrl + "/timesheet/employees/me/entries?";
    if (startAt === null)
      throw new Error("The parameter 'startAt' cannot be null.");
    else if (startAt !== undefined)
      url_ +=
        "startAt=" +
        encodeURIComponent(startAt ? "" + startAt.toISOString() : "") +
        "&";
    if (endAt === null)
      throw new Error("The parameter 'endAt' cannot be null.");
    else if (endAt !== undefined)
      url_ +=
        "endAt=" +
        encodeURIComponent(endAt ? "" + endAt.toISOString() : "") +
        "&";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset !== undefined && offset !== null)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetMyEntries(_response);
      });
  }

  protected processGetMyEntries(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfTimeSheetEntryDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfTimeSheetEntryDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfTimeSheetEntryDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getAllTimes(
    startAt: Date | undefined,
    endAt: Date | undefined,
    sortBy: string | null | undefined,
    q: string | null | undefined
  ): Promise<SwaggerResponse<TimeSheetTimeDto[]>> {
    let url_ = this.baseUrl + "/timesheet/times?";
    if (startAt === null)
      throw new Error("The parameter 'startAt' cannot be null.");
    else if (startAt !== undefined)
      url_ +=
        "startAt=" +
        encodeURIComponent(startAt ? "" + startAt.toISOString() : "") +
        "&";
    if (endAt === null)
      throw new Error("The parameter 'endAt' cannot be null.");
    else if (endAt !== undefined)
      url_ +=
        "endAt=" +
        encodeURIComponent(endAt ? "" + endAt.toISOString() : "") +
        "&";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAllTimes(_response);
      });
  }

  protected processGetAllTimes(
    response: Response
  ): Promise<SwaggerResponse<TimeSheetTimeDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as TimeSheetTimeDto[]);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<TimeSheetTimeDto[]>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportAllTimes(
    startAt: Date | undefined,
    endAt: Date | undefined,
    sortBy: string | undefined,
    exportBy: TimeSheetExportBy | undefined,
    q: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/timesheet/times/export?";
    if (startAt === null)
      throw new Error("The parameter 'startAt' cannot be null.");
    else if (startAt !== undefined)
      url_ +=
        "startAt=" +
        encodeURIComponent(startAt ? "" + startAt.toISOString() : "") +
        "&";
    if (endAt === null)
      throw new Error("The parameter 'endAt' cannot be null.");
    else if (endAt !== undefined)
      url_ +=
        "endAt=" +
        encodeURIComponent(endAt ? "" + endAt.toISOString() : "") +
        "&";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (exportBy === null)
      throw new Error("The parameter 'exportBy' cannot be null.");
    else if (exportBy !== undefined)
      url_ += "exportBy=" + encodeURIComponent("" + exportBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportAllTimes(_response);
      });
  }

  protected processExportAllTimes(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getEmployeeTimes(
    id: string,
    startAt: Date | undefined,
    endAt: Date | undefined,
    sortBy: string | null | undefined,
    q: string | null | undefined
  ): Promise<SwaggerResponse<TimeSheetTimeDto[]>> {
    let url_ = this.baseUrl + "/timesheet/employees/{id}/times?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (startAt === null)
      throw new Error("The parameter 'startAt' cannot be null.");
    else if (startAt !== undefined)
      url_ +=
        "startAt=" +
        encodeURIComponent(startAt ? "" + startAt.toISOString() : "") +
        "&";
    if (endAt === null)
      throw new Error("The parameter 'endAt' cannot be null.");
    else if (endAt !== undefined)
      url_ +=
        "endAt=" +
        encodeURIComponent(endAt ? "" + endAt.toISOString() : "") +
        "&";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetEmployeeTimes(_response);
      });
  }

  protected processGetEmployeeTimes(
    response: Response
  ): Promise<SwaggerResponse<TimeSheetTimeDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as TimeSheetTimeDto[]);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<TimeSheetTimeDto[]>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportEmployeeTimes(
    id: string,
    startAt: Date | undefined,
    endAt: Date | undefined,
    exportBy: TimeSheetExportBy | undefined,
    sortBy: string | null | undefined,
    q: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/timesheet/employees/{id}/times/export?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (startAt === null)
      throw new Error("The parameter 'startAt' cannot be null.");
    else if (startAt !== undefined)
      url_ +=
        "startAt=" +
        encodeURIComponent(startAt ? "" + startAt.toISOString() : "") +
        "&";
    if (endAt === null)
      throw new Error("The parameter 'endAt' cannot be null.");
    else if (endAt !== undefined)
      url_ +=
        "endAt=" +
        encodeURIComponent(endAt ? "" + endAt.toISOString() : "") +
        "&";
    if (exportBy === null)
      throw new Error("The parameter 'exportBy' cannot be null.");
    else if (exportBy !== undefined)
      url_ += "exportBy=" + encodeURIComponent("" + exportBy) + "&";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportEmployeeTimes(_response);
      });
  }

  protected processExportEmployeeTimes(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getMyTimes(
    startAt: Date | undefined,
    endAt: Date | undefined,
    sortBy: string | null | undefined,
    q: string | null | undefined
  ): Promise<SwaggerResponse<TimeSheetTimeDto[]>> {
    let url_ = this.baseUrl + "/timesheet/employees/me/times?";
    if (startAt === null)
      throw new Error("The parameter 'startAt' cannot be null.");
    else if (startAt !== undefined)
      url_ +=
        "startAt=" +
        encodeURIComponent(startAt ? "" + startAt.toISOString() : "") +
        "&";
    if (endAt === null)
      throw new Error("The parameter 'endAt' cannot be null.");
    else if (endAt !== undefined)
      url_ +=
        "endAt=" +
        encodeURIComponent(endAt ? "" + endAt.toISOString() : "") +
        "&";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetMyTimes(_response);
      });
  }

  protected processGetMyTimes(
    response: Response
  ): Promise<SwaggerResponse<TimeSheetTimeDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as TimeSheetTimeDto[]);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<TimeSheetTimeDto[]>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createMyTime(
    model: ManageTimeSheetTimeDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/timesheet/employees/me/times";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateMyTime(_response);
      });
  }

  protected processCreateMyTime(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportMyTimes(
    startAt: Date | undefined,
    endAt: Date | undefined,
    exportBy: TimeSheetExportBy | undefined,
    sortBy: string | null | undefined,
    q: string | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/timesheet/employees/me/times/export?";
    if (startAt === null)
      throw new Error("The parameter 'startAt' cannot be null.");
    else if (startAt !== undefined)
      url_ +=
        "startAt=" +
        encodeURIComponent(startAt ? "" + startAt.toISOString() : "") +
        "&";
    if (endAt === null)
      throw new Error("The parameter 'endAt' cannot be null.");
    else if (endAt !== undefined)
      url_ +=
        "endAt=" +
        encodeURIComponent(endAt ? "" + endAt.toISOString() : "") +
        "&";
    if (exportBy === null)
      throw new Error("The parameter 'exportBy' cannot be null.");
    else if (exportBy !== undefined)
      url_ += "exportBy=" + encodeURIComponent("" + exportBy) + "&";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportMyTimes(_response);
      });
  }

  protected processExportMyTimes(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getPublicHolidays(
    startAt: Date | undefined,
    endAt: Date | undefined
  ): Promise<SwaggerResponse<PublicHolidayDto[]>> {
    let url_ = this.baseUrl + "/timesheet/holidays?";
    if (startAt === null)
      throw new Error("The parameter 'startAt' cannot be null.");
    else if (startAt !== undefined)
      url_ +=
        "startAt=" +
        encodeURIComponent(startAt ? "" + startAt.toISOString() : "") +
        "&";
    if (endAt === null)
      throw new Error("The parameter 'endAt' cannot be null.");
    else if (endAt !== undefined)
      url_ +=
        "endAt=" +
        encodeURIComponent(endAt ? "" + endAt.toISOString() : "") +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetPublicHolidays(_response);
      });
  }

  protected processGetPublicHolidays(
    response: Response
  ): Promise<SwaggerResponse<PublicHolidayDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PublicHolidayDto[]);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PublicHolidayDto[]>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getMyConfirmedTime(
    startAt: Date | undefined,
    endAt: Date | undefined
  ): Promise<SwaggerResponse<ConfirmedTimeDto[]>> {
    let url_ = this.baseUrl + "/timesheet/employees/me/times/confirmed?";
    if (startAt === null)
      throw new Error("The parameter 'startAt' cannot be null.");
    else if (startAt !== undefined)
      url_ +=
        "startAt=" +
        encodeURIComponent(startAt ? "" + startAt.toISOString() : "") +
        "&";
    if (endAt === null)
      throw new Error("The parameter 'endAt' cannot be null.");
    else if (endAt !== undefined)
      url_ +=
        "endAt=" +
        encodeURIComponent(endAt ? "" + endAt.toISOString() : "") +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetMyConfirmedTime(_response);
      });
  }

  protected processGetMyConfirmedTime(
    response: Response
  ): Promise<SwaggerResponse<ConfirmedTimeDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as ConfirmedTimeDto[]);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ConfirmedTimeDto[]>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getConfirmedTime(
    employeeId: string,
    startAt: Date | undefined,
    endAt: Date | undefined
  ): Promise<SwaggerResponse<ConfirmedTimeDto[]>> {
    let url_ =
      this.baseUrl + "/timesheet/employees/{employeeId}/times/confirmed?";
    if (employeeId === undefined || employeeId === null)
      throw new Error("The parameter 'employeeId' must be defined.");
    url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
    if (startAt === null)
      throw new Error("The parameter 'startAt' cannot be null.");
    else if (startAt !== undefined)
      url_ +=
        "startAt=" +
        encodeURIComponent(startAt ? "" + startAt.toISOString() : "") +
        "&";
    if (endAt === null)
      throw new Error("The parameter 'endAt' cannot be null.");
    else if (endAt !== undefined)
      url_ +=
        "endAt=" +
        encodeURIComponent(endAt ? "" + endAt.toISOString() : "") +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetConfirmedTime(_response);
      });
  }

  protected processGetConfirmedTime(
    response: Response
  ): Promise<SwaggerResponse<ConfirmedTimeDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as ConfirmedTimeDto[]);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ConfirmedTimeDto[]>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getEntryStats(
    id: string,
    startAt: Date | null | undefined,
    endAt: Date | null | undefined,
    employeeId: string | null | undefined
  ): Promise<SwaggerResponse<TimeSheetEntryStatsDto>> {
    let url_ = this.baseUrl + "/timesheet/entries/{id}/times/stats?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (startAt !== undefined && startAt !== null)
      url_ +=
        "startAt=" +
        encodeURIComponent(startAt ? "" + startAt.toISOString() : "") +
        "&";
    if (endAt !== undefined && endAt !== null)
      url_ +=
        "endAt=" +
        encodeURIComponent(endAt ? "" + endAt.toISOString() : "") +
        "&";
    if (employeeId !== undefined && employeeId !== null)
      url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetEntryStats(_response);
      });
  }

  protected processGetEntryStats(
    response: Response
  ): Promise<SwaggerResponse<TimeSheetEntryStatsDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as TimeSheetEntryStatsDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<TimeSheetEntryStatsDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  exportEntryTimesStats(
    id: string,
    exportBy: TimeSheetEntryStatsExportBy | undefined,
    startAt: Date | null | undefined,
    endAt: Date | null | undefined
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/timesheet/entries/{id}/times/stats/export?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (exportBy === null)
      throw new Error("The parameter 'exportBy' cannot be null.");
    else if (exportBy !== undefined)
      url_ += "exportBy=" + encodeURIComponent("" + exportBy) + "&";
    if (startAt !== undefined && startAt !== null)
      url_ +=
        "startAt=" +
        encodeURIComponent(startAt ? "" + startAt.toISOString() : "") +
        "&";
    if (endAt !== undefined && endAt !== null)
      url_ +=
        "endAt=" +
        encodeURIComponent(endAt ? "" + endAt.toISOString() : "") +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processExportEntryTimesStats(_response);
      });
  }

  protected processExportEntryTimesStats(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getEntryStatsForPeriods(
    id: string,
    startAt: Date | undefined,
    endAt: Date | undefined,
    splitBy: SplitBy | undefined,
    employeeId: string | null | undefined
  ): Promise<SwaggerResponse<TimeSheetEntryPeriodStatsDto[]>> {
    let url_ = this.baseUrl + "/timesheet/entries/{id}/times/stats/periods?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (startAt === null)
      throw new Error("The parameter 'startAt' cannot be null.");
    else if (startAt !== undefined)
      url_ +=
        "startAt=" +
        encodeURIComponent(startAt ? "" + startAt.toISOString() : "") +
        "&";
    if (endAt === null)
      throw new Error("The parameter 'endAt' cannot be null.");
    else if (endAt !== undefined)
      url_ +=
        "endAt=" +
        encodeURIComponent(endAt ? "" + endAt.toISOString() : "") +
        "&";
    if (splitBy === null)
      throw new Error("The parameter 'splitBy' cannot be null.");
    else if (splitBy !== undefined)
      url_ += "splitBy=" + encodeURIComponent("" + splitBy) + "&";
    if (employeeId !== undefined && employeeId !== null)
      url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetEntryStatsForPeriods(_response);
      });
  }

  protected processGetEntryStatsForPeriods(
    response: Response
  ): Promise<SwaggerResponse<TimeSheetEntryPeriodStatsDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as TimeSheetEntryPeriodStatsDto[]);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<TimeSheetEntryPeriodStatsDto[]>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getEntryStatsForEmployees(
    id: string,
    startAt: Date | undefined,
    endAt: Date | undefined
  ): Promise<SwaggerResponse<TimeSheetEntryEmployeeStatsDto[]>> {
    let url_ = this.baseUrl + "/timesheet/entries/{id}/times/stats/employees?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (startAt === null)
      throw new Error("The parameter 'startAt' cannot be null.");
    else if (startAt !== undefined)
      url_ +=
        "startAt=" +
        encodeURIComponent(startAt ? "" + startAt.toISOString() : "") +
        "&";
    if (endAt === null)
      throw new Error("The parameter 'endAt' cannot be null.");
    else if (endAt !== undefined)
      url_ +=
        "endAt=" +
        encodeURIComponent(endAt ? "" + endAt.toISOString() : "") +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetEntryStatsForEmployees(_response);
      });
  }

  protected processGetEntryStatsForEmployees(
    response: Response
  ): Promise<SwaggerResponse<TimeSheetEntryEmployeeStatsDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as TimeSheetEntryEmployeeStatsDto[]);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<TimeSheetEntryEmployeeStatsDto[]>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createEmployeeTime(
    employeeId: string,
    model: ManageTimeSheetTimeDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/timesheet/employees/{employeeId}/times";
    if (employeeId === undefined || employeeId === null)
      throw new Error("The parameter 'employeeId' must be defined.");
    url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateEmployeeTime(_response);
      });
  }

  protected processCreateEmployeeTime(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateMyTime(
    id: string,
    model: ManageTimeSheetTimeDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/timesheet/employees/me/times/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateMyTime(_response);
      });
  }

  protected processUpdateMyTime(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteMyTime(id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/timesheet/employees/me/times/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteMyTime(_response);
      });
  }

  protected processDeleteMyTime(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  lockEmployeeTime(
    employeeId: string,
    model: ManageConfirmedTimeDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/timesheet/employees/{employeeId}/times/lock";
    if (employeeId === undefined || employeeId === null)
      throw new Error("The parameter 'employeeId' must be defined.");
    url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processLockEmployeeTime(_response);
      });
  }

  protected processLockEmployeeTime(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  lockMyTime(
    model: ManageConfirmedTimeDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/timesheet/employees/me/times/lock";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processLockMyTime(_response);
      });
  }

  protected processLockMyTime(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateEmployeeTime(
    employeeId: string,
    id: string,
    model: ManageTimeSheetTimeDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/timesheet/employees/{employeeId}/times/{id}";
    if (employeeId === undefined || employeeId === null)
      throw new Error("The parameter 'employeeId' must be defined.");
    url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateEmployeeTime(_response);
      });
  }

  protected processUpdateEmployeeTime(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteEmployeeTime(
    employeeId: string,
    id: string
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/timesheet/employees/{employeeId}/times/{id}";
    if (employeeId === undefined || employeeId === null)
      throw new Error("The parameter 'employeeId' must be defined.");
    url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteEmployeeTime(_response);
      });
  }

  protected processDeleteEmployeeTime(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  unlockTime(
    employeeId: string,
    model: ManageConfirmedTimeDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/timesheet/employees/{employeeId}/times/unlock";
    if (employeeId === undefined || employeeId === null)
      throw new Error("The parameter 'employeeId' must be defined.");
    url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUnlockTime(_response);
      });
  }

  protected processUnlockTime(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }
}

export class UnitOfMeasureClient extends GestitClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: GestitClientOptions,
    baseUrl?: string,
    http?: {
      fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
    }
  ) {
    super(configuration);

    // @ts-ignore
    this.http = http ? http : (window as any);
    // @ts-ignore
    this.baseUrl = this.getBaseUrl("", baseUrl);

    this.jsonParseReviver = (k, v) => dateReviver(k, v, dateProperties);
  }

  getUnitsOfMeasure(
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfUnitOfMeasureDto>> {
    let url_ = this.baseUrl + "/unitsOfMeasure?";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetUnitsOfMeasure(_response);
      });
  }

  protected processGetUnitsOfMeasure(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfUnitOfMeasureDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfUnitOfMeasureDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfUnitOfMeasureDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createUnitOfMeasure(
    model: ManageUnitOfMeasureDto
  ): Promise<SwaggerResponse<UnitOfMeasureDto>> {
    let url_ = this.baseUrl + "/unitsOfMeasure";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateUnitOfMeasure(_response);
      });
  }

  protected processCreateUnitOfMeasure(
    response: Response
  ): Promise<SwaggerResponse<UnitOfMeasureDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as UnitOfMeasureDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<UnitOfMeasureDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getUnitOfMeasure(id: string): Promise<SwaggerResponse<UnitOfMeasureDto>> {
    let url_ = this.baseUrl + "/unitsOfMeasure/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetUnitOfMeasure(_response);
      });
  }

  protected processGetUnitOfMeasure(
    response: Response
  ): Promise<SwaggerResponse<UnitOfMeasureDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as UnitOfMeasureDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<UnitOfMeasureDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  updateUnitOfMeasure(
    id: string,
    model: ManageUnitOfMeasureDto
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/unitsOfMeasure/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateUnitOfMeasure(_response);
      });
  }

  protected processUpdateUnitOfMeasure(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  deleteUnitOfMeasure(id: string): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/unitsOfMeasure/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteUnitOfMeasure(_response);
      });
  }

  protected processDeleteUnitOfMeasure(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }
}

export class UsersClient extends GestitClientBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: GestitClientOptions,
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    super(configuration);
    this.http = http ? http : (window as any);
    this.baseUrl = this.getBaseUrl("", baseUrl);
  }

  getMe(): Promise<SwaggerResponse<CurrentUserDto>> {
    let url_ = this.baseUrl + "/users/me";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetMe(_response);
      });
  }

  protected processGetMe(
    response: Response
  ): Promise<SwaggerResponse<CurrentUserDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as CurrentUserDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<CurrentUserDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getUsers(
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfUserDto>> {
    let url_ = this.baseUrl + "/users?";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetUsers(_response);
      });
  }

  protected processGetUsers(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfUserDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfUserDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfUserDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  createUser(model: ManageUserDto): Promise<SwaggerResponse<ManageUserDto>> {
    let url_ = this.baseUrl + "/users";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateUser(_response);
      });
  }

  protected processCreateUser(
    response: Response
  ): Promise<SwaggerResponse<ManageUserDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as ManageUserDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ManageUserDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getAvailableUsers(
    sortBy: string | undefined,
    q: string | null | undefined,
    offset: number | undefined,
    limit: number | undefined
  ): Promise<SwaggerResponse<PaginatedOfUserDto>> {
    let url_ = this.baseUrl + "/users/available?";
    if (sortBy === null)
      throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (q !== undefined && q !== null)
      url_ += "q=" + encodeURIComponent("" + q) + "&";
    if (offset === null)
      throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined)
      url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null)
      throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined)
      url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAvailableUsers(_response);
      });
  }

  protected processGetAvailableUsers(
    response: Response
  ): Promise<SwaggerResponse<PaginatedOfUserDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as PaginatedOfUserDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PaginatedOfUserDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getUser(id: string): Promise<SwaggerResponse<UserDto>> {
    let url_ = this.baseUrl + "/users/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetUser(_response);
      });
  }

  protected processGetUser(
    response: Response
  ): Promise<SwaggerResponse<UserDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as UserDto);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<UserDto>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getUserRoles(id: string): Promise<SwaggerResponse<string[]>> {
    let url_ = this.baseUrl + "/users/{id}/roles";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetUserRoles(_response);
      });
  }

  protected processGetUserRoles(
    response: Response
  ): Promise<SwaggerResponse<string[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as string[]);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<string[]>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  addRoleToUser(
    id: string,
    role: string
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/users/{id}/roles";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(role);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAddRoleToUser(_response);
      });
  }

  protected processAddRoleToUser(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  removeRoleFromUser(
    id: string,
    role: string
  ): Promise<SwaggerResponse<FileResponse>> {
    let url_ = this.baseUrl + "/users/{id}/roles/{role}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (role === undefined || role === null)
      throw new Error("The parameter 'role' must be defined.");
    url_ = url_.replace("{role}", encodeURIComponent("" + role));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processRemoveRoleFromUser(_response);
      });
  }

  protected processRemoveRoleFromUser(
    response: Response
  ): Promise<SwaggerResponse<FileResponse>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return new SwaggerResponse(status, _headers, {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        });
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<FileResponse>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getRoles(): Promise<SwaggerResponse<string[]>> {
    let url_ = this.baseUrl + "/users/roles";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetRoles(_response);
      });
  }

  protected processGetRoles(
    response: Response
  ): Promise<SwaggerResponse<string[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as string[]);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<string[]>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }

  getDomains(): Promise<SwaggerResponse<string[]>> {
    let url_ = this.baseUrl + "/users/domains";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetDomains(_response);
      });
  }

  protected processGetDomains(
    response: Response
  ): Promise<SwaggerResponse<string[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as string[]);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<string[]>>(
      new SwaggerResponse(status, _headers, null as any)
    );
  }
}

export interface PaginatedOfDeadlineItemDto {
  items: DeadlineItemDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface DeadlineItemDto {
  deliveryDate: Date | undefined;
  deliveryDateIsConfirmed: boolean;
  item: ItemOverviewDto;
  department: DepartmentDto | undefined;
  orderId: string;
  orderExternalCode: string | undefined;
  orderInternalCode: string | undefined;
  orderItemId: string;
  orderItemDescription: string | undefined;
  commission: CommissionOverviewDto;
  commissionItem: CommissionItemOverviewDto;
  unitOfMeasure: UnitOfMeasureDto;
  quantity: number;
  deliveredQuantity: number;
  remainingQuantity: number;
  createdAt: Date;
  updatedAt: Date;
}

export interface ItemOverviewDto {
  id: string;
  code: string;
  description: string;
  type: ItemType;
}

export enum ItemType {
  Service = "Service",
  Inventory = "Inventory",
}

export interface DepartmentDto {
  id: string;
  code: string;
  description: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface CommissionOverviewDto {
  id: string;
  code: string;
  title: string;
  description: string;
  customer: CommissionCustomerDto | undefined;
  isInternal: boolean;
  status: CommissionStatus;
}

export interface CommissionCustomerDto {
  id: string;
  name: string;
  companyType: string;
  completeName: string;
  code: string | undefined;
}

export enum CommissionStatus {
  Open = "Open",
  Closed = "Closed",
  Suspended = "Suspended",
}

export interface CommissionItemOverviewDto {
  id: string;
  itemId: string;
  code: string;
  description: string;
  notes: string | undefined;
  type: ItemType;
}

export interface UnitOfMeasureDto {
  id: string;
  code: string;
  symbol: string;
  description: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface PaginatedOfCommissionDto {
  items: CommissionDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface CommissionDto {
  id: string;
  title: string;
  code: string;
  openedAt: Date;
  closedAt: Date | undefined;
  isSuspended: boolean;
  status: CommissionStatus;
  description: string;
  customer: CustomerOverviewDto | undefined;
  color: string;
  isInternal: boolean;
  isDefault: boolean;
  hasTimes: boolean;
  areNotesMandatory: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface CustomerOverviewDto {
  id: string;
  name: string;
  companyType: string;
  completeName: string;
  code: string | undefined;
  defaultCurrency: CurrencyDto | undefined;
  defaultBankAccount: BankAccountDto | undefined;
}

export interface CurrencyDto {
  id: string;
  code: string;
  symbol: string;
  internationalCode: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface BankAccountDto {
  id: string;
  bankId: string;
  bank: BankDto;
  code: string;
  iban: string;
}

export interface BankDto {
  id: string;
  description: string;
  address: AddressDto;
  createdAt: Date;
  updatedAt: Date;
}

export interface AddressDto {
  street: string;
  city: string;
  postalCode: string;
  stateProvince: string;
  country: string;
}

export interface PaginatedOfBankDto {
  items: BankDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface ManageBankDto {
  description: string;
  address: AddressDto;
}

export interface PaginatedOfBankAccountDto {
  items: BankAccountDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface ManageBankAccountDto {
  code: string;
  iban: string;
}

export interface PaginatedOfBillingDocumentDto {
  items: BillingDocumentDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface PaginatedWithTotalOfBillingDocumentDto
  extends PaginatedOfBillingDocumentDto {
  currency: CurrencyDto | undefined;
  total: number | undefined;
  totalTaxable: number | undefined;
  totalTax: number | undefined;
}

export interface BillingDocumentDto {
  id: string;
  date: Date;
  code: string;
  customer: CustomerOverviewDto | undefined;
  paymentTerms: PaymentTermsDto | undefined;
  currency: CurrencyDto | undefined;
  bankAccount: BankAccountOverviewDto | undefined;
  priceList: PriceListOverviewDto | undefined;
  lastTransmissionStatus: InvoiceTransmissionFlattenDto | undefined;
  createdAt: Date;
  updatedAt: Date;
  type: BillingDocumentType;
  total: number;
  totalTaxable: number;
  totalExemptTaxable: number;
  totalTax: number;
  stampsChargesTaxCode: TaxCodeDto | undefined;
  stampsCharges: number;
  customerOfficeId: string | undefined;
  customerOffice: CustomerOffice | undefined;
  companyOfficeId: string;
  companyOffice: CompanyOfficeDto;
}

export interface PaymentTermsDto {
  id: string;
  code: string;
  description: string;
  paymentType: PaymentType;
  numberOfInstallments: number;
  daysBetweenInstallments: number;
  dueDateType: DueDateType;
  isSoftDeleted: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export enum PaymentType {
  Cash = "Cash",
  DirectPayment = "DirectPayment",
  CashOnDelivery = "CashOnDelivery",
  InvoiceAtSight = "InvoiceAtSight",
  BillOfExchange = "BillOfExchange",
  CashOrder = "CashOrder",
  BankTransfer = "BankTransfer",
  Check = "Check",
  BankDraft = "BankDraft",
  PostalMoneyOrder = "PostalMoneyOrder",
  NationalMoneyOrder = "NationalMoneyOrder",
  InternationalMoneyOrder = "InternationalMoneyOrder",
  PaN = "PaN",
  DD = "DD",
  ForeignCheck = "ForeignCheck",
  ForeignBankTransfer = "ForeignBankTransfer",
  CreditCard = "CreditCard",
  BankSlip = "BankSlip",
  PostalSlip = "PostalSlip",
  LetterOfCredit = "LetterOfCredit",
  Factoring = "Factoring",
  FastDD = "FastDD",
  Bancomat = "Bancomat",
  Ticket = "Ticket",
  Carne = "Carne",
  PromissoryNote = "PromissoryNote",
  Duplicate = "Duplicate",
  Voucher = "Voucher",
}

export enum DueDateType {
  SpecificDate = "SpecificDate",
  InvoiceDate = "InvoiceDate",
  EndOfMonth = "EndOfMonth",
}

export interface BankAccountOverviewDto {
  id: string;
  code: string;
  iban: string;
}

export interface PriceListOverviewDto {
  id: string;
  code: string;
  description: string | undefined;
}

export interface InvoiceTransmissionFlattenDto {
  code: string;
  direction: InvoiceTransmissionDirection;
  date: Date;
  status: InvoiceTransmissionStatus;
  message: string | undefined;
}

export enum InvoiceTransmissionDirection {
  Send = "Send",
  Receive = "Receive",
}

export enum InvoiceTransmissionStatus {
  ToSend = "ToSend",
  Sending = "Sending",
  Sent = "Sent",
  Error = "Error",
}

export enum BillingDocumentType {
  Invoice = "Invoice",
  CreditNote = "CreditNote",
  DebitNote = "DebitNote",
  Proforma = "Proforma",
}

export interface TaxCodeDto {
  id: string;
  code: string;
  description: string;
  percentage: number;
  undeductiblePercentage: number;
  isExempt: boolean;
  eiCodingCode: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface CustomerOffice {
  id: string;
  name: string;
  address: Address;
  customerId: string;
  isSoftDeleted: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface Address {
  street: string;
  city: string;
  postalCode: string;
  stateProvince: string;
  country: string;
}

export interface CompanyOfficeDto {
  id: string | undefined;
  name: string;
  address: Address;
  isSoftDeleted: boolean | undefined;
  createdAt: Date | undefined;
  updatedAt: Date | undefined;
}

export interface ManageBillingDocumentDto {
  date: Date;
  customerId: string;
  paymentTermsId: string;
  currencyId: string;
  bankAccountId: string | undefined;
  priceListId: string | undefined;
  type: BillingDocumentType;
  stampsChargesTaxCodeId: string | undefined;
  stampsCharges: number;
  customerOfficeId: string | undefined;
  companyOfficeId: string;
}

export interface DeliveryDocumentDto {
  id: string;
  code: string;
  date: Date;
  currency: CurrencyDto;
  customer: CustomerDto | undefined;
  customerOffice: CustomerOfficeDto | undefined;
  supplier: SupplierDto | undefined;
  supplierOffice: SupplierOfficeDto | undefined;
  companyOffice: CompanyOfficeDto;
  package: PackageDto;
  deliveryMethod: DeliveryMethod;
  freightPaymentType: FreightPaymentType;
  carrier: CarrierDto | undefined;
  packageAppearance: PackageAppearanceDto;
  movementReason: MovementReasonDto;
  numberOfPackages: number;
  hasSupplier: boolean;
  hasCustomer: boolean;
  total: number;
  totalTaxable: number;
  totalTax: number;
  createdAt: Date;
  updatedAt: Date;
}

export interface CustomerDto {
  id: string;
  name: string;
  companyType: string;
  completeName: string;
  code: string | undefined;
  vatNumber: string;
  reaCode: string | undefined;
  registeredOffice: AddressDto;
  emailAddress: string | undefined;
  pecAddress: string | undefined;
  sdiCode: string | undefined;
  priceList: PriceListOverviewDto | undefined;
  defaultTaxCode: TaxCode | undefined;
  defaultPaymentTerms: PaymentTerms | undefined;
  defaultCurrency: Currency | undefined;
  defaultBankAccount: BankAccountDto | undefined;
  parentId: string | undefined;
  createdAt: Date;
  updatedAt: Date;
}

export interface TaxCode {
  id: string;
  code: string;
  description: string;
  percentage: number;
  undeductiblePercentage: number;
  isExempt: boolean;
  eiCodingCode: string | undefined;
  eiCoding: EiCoding | undefined;
  isSoftDeleted: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface EiCoding {
  code: string;
  description: string;
  isTaxCodeCompatible: boolean;
}

export interface PaymentTerms {
  id: string;
  code: string;
  description: string;
  paymentType: PaymentType;
  numberOfInstallments: number;
  daysBetweenInstallments: number;
  dueDateType: DueDateType;
  isSoftDeleted: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface Currency {
  id: string;
  code: string;
  symbol: string;
  internationalCode: string;
  isSoftDeleted: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface CustomerOfficeDto {
  id: string;
  name: string;
  address: AddressDto;
}

export interface SupplierDto {
  id: string;
  name: string;
  companyType: string;
  completeName: string;
  code: string | undefined;
  vatNumber: string;
  reaCode: string | undefined;
  registeredOffice: AddressDto;
  emailAddress: string;
  pecAddress: string | undefined;
  sdiCode: string | undefined;
  createdAt: Date;
  updatedAt: Date;
}

export interface SupplierOfficeDto {
  id: string;
  name: string;
  address: AddressDto;
}

export interface PackageDto {
  id: string;
  code: string;
  description: string;
  createdAt: Date;
  updatedAt: Date;
}

export enum DeliveryMethod {
  Sender = "Sender",
  Recipient = "Recipient",
  Carrier = "Carrier",
}

export enum FreightPaymentType {
  Collect = "Collect",
  Prepaid = "Prepaid",
}

export interface CarrierDto {
  id: string;
  code: string;
  name: string;
  companyType: string;
  completeName: string;
  address: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface PackageAppearanceDto {
  id: string;
  code: string;
  description: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface MovementReasonDto {
  id: string;
  code: string;
  description: string;
  invoiceFollows: boolean;
  isWarehouseEnabled: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface CreateBillingDocumentsFromDeliveryDocumentsDto {
  deliveryDocumentsIds: string[];
  date: Date;
  type: BillingDocumentType;
  includeNotes: boolean;
}

export interface PaginatedOfDeliveryDocumentDto {
  items: DeliveryDocumentDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface PaginatedOfSaleOrderDto {
  items: SaleOrderDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface SaleOrderDto {
  id: string;
  date: Date;
  externalDate: Date | undefined;
  internalCode: string;
  externalCode: string | undefined;
  expectedDeliveryDate: Date | undefined;
  confirmedDeliveryDate: Date | undefined;
  customerOffice: CustomerOfficeDto | undefined;
  customer: CustomerDto | undefined;
  paymentTerms: PaymentTermsDto | undefined;
  currency: CurrencyDto | undefined;
  bankAccount: BankAccountDto | undefined;
  priceList: PriceListDto | undefined;
  itemsCount: number;
  total: number;
  totalTaxable: number;
  totalTax: number;
  isSoftDeleted: boolean;
  createdAt: Date;
  updatedAt: Date;
  status: OrderStatus;
}

export interface PriceListDto {
  id: string;
  code: string;
  currency: CurrencyDto;
  description: string | undefined;
  validity: string;
  createdAt: Date;
  updatedAt: Date;
  startDate: Date | undefined;
  endDate: Date | undefined;
}

export enum OrderStatus {
  Canceled = "Canceled",
  FullyDelivered = "FullyDelivered",
  PartiallyDelivered = "PartiallyDelivered",
  Open = "Open",
}

export interface PaginatedOfBillingDocumentItemDto {
  items: BillingDocumentItemDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface BillingDocumentItemDto {
  id: string;
  type: LineItemType;
  item: ItemDto | undefined;
  deliveryDocumentItem: DeliveryDocumentItemDto | undefined;
  description: string;
  quantity: number;
  unitPrice: number;
  tax: number;
  taxable: number;
  total: number;
  taxCode: TaxCodeDto | undefined;
}

export enum LineItemType {
  Item = "Item",
  Notes = "Notes",
}

export interface ItemDto {
  id: string;
  code: string;
  description: string;
  type: ItemType;
  category: ItemCategoryDto | undefined;
  commodityCategory: CommodityCategoryDto | undefined;
  nature: ItemNature;
  department: DepartmentDto | undefined;
  isSample: boolean;
  isAccepted: boolean;
  hasSampleAssociated: boolean;
  sample: ItemOverviewDto | undefined;
  archiveCode: string | undefined;
  unitOfMeasure: UnitOfMeasureDto;
  stockQuantity: number;
  createdAt: Date;
  updatedAt: Date;
  suppliers: ItemSupplierDto[];
  customers: ItemCustomerDto[];
}

export interface ItemCategoryDto {
  id: string;
  code: string;
  description: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface CommodityCategoryDto {
  id: string;
  code: string;
  description: string;
  createdAt: Date;
  updatedAt: Date;
}

export enum ItemNature {
  Semifinished = "Semifinished",
  FinalProduct = "FinalProduct",
  Purchase = "Purchase",
}

export interface ItemSupplierDto {
  supplier: SupplierOverviewDto;
  itemCode: string | undefined;
}

export interface SupplierOverviewDto {
  id: string;
  code: string | undefined;
  name: string;
  companyType: string;
  completeName: string;
}

export interface ItemCustomerDto {
  customer: CustomerOverviewDto;
  itemCode: string | undefined;
}

export interface DeliveryDocumentItemDto {
  id: string;
  deliveryDocument: DeliveryDocumentDto;
  type: LineItemType;
  item: ItemDto | undefined;
  orderItem: SaleOrderItemDto | undefined;
  description: string | undefined;
  quantity: number;
  unitPrice: number;
  taxable: number;
  tax: number;
  total: number;
  taxCode: TaxCodeDto | undefined;
  isWarehouseEnabled: boolean;
}

export interface SaleOrderItemDto {
  id: string;
  type: LineItemType;
  item: ItemDto | undefined;
  itemId: string | undefined;
  saleOrder: SaleOrderDto | undefined;
  description: string;
  quantity: number;
  unitPrice: number;
  taxable: number;
  tax: number;
  total: number;
  taxCodeId: string | undefined;
  taxCode: TaxCodeDto | undefined;
  positionIndex: number;
  isCancelled: boolean;
  isForcedDelivered: boolean;
  deliveryDate: Date | undefined;
  expectedDeliveryDate: Date | undefined;
  confirmedDeliveryDate: Date | undefined;
  deliveredQuantity: number;
}

export interface ManageBillingDocumentItemDto {
  type: LineItemType;
  itemId: string | undefined;
  deliveryDocumentItemId: string | undefined;
  description: string;
  quantity: number;
  unitPrice: number;
  afterPositionIndex: number | undefined;
  taxCodeId: string | undefined;
}

export interface ManageBillingDocumentItemsOrderDto {
  move: ItemsOrderDirection;
}

export enum ItemsOrderDirection {
  Up = "Up",
  Down = "Down",
}

export interface PaginatedOfItemDto {
  items: ItemDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface PaginatedOfInvoiceTransmissionFlattenDto {
  items: InvoiceTransmissionFlattenDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface UpdateInvoiceTransmissionStatusDto {
  status: InvoiceTransmissionStatus;
  message: string | undefined;
}

export interface PaginatedOfBillOfMaterialDto {
  items: BillOfMaterialDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface BillOfMaterialDto {
  id: string;
  itemId: string;
  itemCode: string;
  itemDescription: string;
  operations: OperationDto[];
  components: BillOfMaterialComponentDto[];
  createdAt: Date;
  updatedAt: Date;
}

export interface OperationDto {
  id: string;
  code: string;
  description: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface BillOfMaterialComponentDto {
  billOfMaterial: BillOfMaterialDto;
  component: ItemDto;
  quantity: number;
}

export interface PaginatedOfOperationDto {
  items: OperationDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface PaginatedOfBillOfMaterialComponentDto {
  items: BillOfMaterialComponentDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface ManageBillOfMaterialDto {
  itemId: string;
}

export interface PaginatedOfBillOfLadingDto {
  items: BillOfLadingDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface PaginatedWithTotalOfBillOfLadingDto
  extends PaginatedOfBillOfLadingDto {
  currency: CurrencyDto | undefined;
  total: number | undefined;
  totalTaxable: number | undefined;
  totalTax: number | undefined;
}

export interface BillOfLadingDto {
  id: string;
  internalCode: string;
  externalCode: string | undefined;
  date: Date;
  externalDate: Date | undefined;
  currency: CurrencyDto;
  customer: CustomerDto | undefined;
  supplier: SupplierDto | undefined;
  customerOffice: CustomerOfficeDto | undefined;
  supplierOffice: SupplierOfficeDto | undefined;
  movementReason: MovementReasonDto;
  hasSupplier: boolean;
  hasCustomer: boolean;
  createdAt: Date;
  updatedAt: Date;
  total: number;
  totalTaxable: number;
  totalTax: number;
}

export enum DocumentTarget {
  Customers = "Customers",
  Suppliers = "Suppliers",
}

export interface ManageBillOfLadingDto {
  externalCode: string | undefined;
  date: Date;
  externalDate: Date | undefined;
  currencyId: string;
  customerId: string | undefined;
  supplierId: string | undefined;
  customerOfficeId: string | undefined;
  supplierOfficeId: string | undefined;
  movementReasonId: string;
  hasSupplier: boolean;
  hasCustomer: boolean;
}

export interface PaginatedOfBillOfLadingItemDto {
  items: BillOfLadingItemDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface BillOfLadingItemDto {
  id: string;
  billOfLading: BillOfLadingDto;
  type: LineItemType;
  item: ItemDto | undefined;
  description: string | undefined;
  quantity: number;
  unitPrice: number;
  taxable: number;
  tax: number;
  total: number;
  taxCode: TaxCodeDto | undefined;
  positionIndex: number;
}

export interface ManageBillOfLadingItemDto {
  type: LineItemType;
  itemId: string | undefined;
  description: string | undefined;
  quantity: number;
  unitPrice: number;
  afterPositionIndex: number | undefined;
  taxCodeId: string | undefined;
}

export interface ManageBillOfLadingItemsOrderDto {
  move: ItemsOrderDirection;
}

export interface PaginatedOfCarrierDto {
  items: CarrierDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface ManageCarrierDto {
  code: string;
  name: string;
  companyType: string;
  address: string;
}

export interface EmployeeCommissionDto {
  id: string;
  code: string;
  title: string;
  description: string;
  customer: CustomerOverviewDto | undefined;
  color: string;
  isInternal: boolean;
  assignments: EmployeeCommissionAssignmentDto[];
  areNotesMandatory: boolean;
}

export interface EmployeeCommissionAssignmentDto {
  task: CommissionTaskOverviewDto;
  skill: SkillDto;
  estimatedTime: string;
  periods: PeriodDto[];
}

export interface CommissionTaskOverviewDto {
  id: string;
  title: string;
  priority: number | undefined;
}

export interface SkillDto {
  id: string;
  code: string;
  description: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface PeriodDto {
  startAt: Date;
  endAt: Date | undefined;
}

export interface ManageCommissionDto {
  title: string;
  openedAt: Date;
  closedAt: Date | undefined;
  description: string;
  customerId: string | undefined;
  isInternal: boolean;
  color: string;
  isDefault: boolean;
  areNotesMandatory: boolean;
}

export interface CreateCommissionDto extends ManageCommissionDto {
  fromTemplateId: string | undefined;
}

export interface PaginatedOfEmployeeOverviewDto {
  items: EmployeeOverviewDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface EmployeeOverviewDto {
  id: string;
  name: string;
  surname: string;
}

export interface PaginatedOfCommissionEmployeeDto {
  items: CommissionEmployeeDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface CommissionEmployeeDto {
  id: string;
  name: string;
  surname: string;
  assignments: EmployeeCommissionAssignmentDto[];
}

export interface AddCommissionEmployeesDto {
  employeesIds: string[] | undefined;
}

export interface PaginatedOfCommissionTaskDto {
  items: CommissionTaskDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface CommissionTaskDto {
  id: string;
  title: string;
  path: string;
  parentId: string | undefined;
  isBilled: boolean;
  priority: number | undefined;
  estimatedTime: string;
  estimatedHours: number;
  estimatedMinutes: number;
}

export interface ManageCommissionTaskDto {
  title: string;
  parentId: string | undefined;
  isBilled: boolean;
}

export interface ManageCommissionTasksOrderDto {
  move: ItemsOrderDirection;
}

export interface PaginatedOfCommissionAssignmentDto {
  items: CommissionAssignmentDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface CommissionAssignmentDto {
  skill: SkillDto;
  skillPrice: number | undefined;
  employee: EmployeeOverviewDto;
  estimatedTime: string;
  periods: CommissionAssignmentPeriodDto[];
  isEnabledForFullCommissionDuration: boolean;
}

export interface CommissionAssignmentPeriodDto {
  startAt: Date;
  endAt: Date | undefined;
}

export interface ManageCommissionAssignmentDto {
  skillPrice: number | undefined;
  specificPeriods: CommissionAssignmentSpecificPeriodDto[];
  estimatedTime: string;
}

export interface CommissionAssignmentSpecificPeriodDto {
  startAt: Date;
  endAt: Date;
}

export interface PaginatedOfCommissionItemDto {
  items: CommissionItemDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface CommissionItemDto {
  id: string;
  item: ItemOverviewDto | undefined;
  quantity: number;
  notes: string | undefined;
  orderItem: SaleOrderItemDto | undefined;
  operations: OperationDto[] | undefined;
}

export interface ManageCommissionItemDto {
  itemId: string;
  quantity: number;
  notes: string | undefined;
}

export interface CommissionItemsReportDto {
  commissionItemsIds: string[] | undefined;
}

export interface PaginatedOfTemplateCommissionDto {
  items: TemplateCommissionDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface TemplateCommissionDto {
  id: string;
  name: string;
  priority: number | undefined;
}

export interface ManageTemplateCommissionDto {
  name: string;
}

export interface PaginatedOfTemplateCommissionTaskDto {
  items: TemplateCommissionTaskDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface TemplateCommissionTaskDto {
  id: string;
  title: string;
  parentId: string | undefined;
  isBilled: boolean;
}

export interface ManageTemplateCommissionTaskDto {
  title: string;
  parentId: string | undefined;
  isBilled: boolean;
}

export interface PaginatedOfTemplateCommissionEmployeeDto {
  items: TemplateCommissionEmployeeDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface TemplateCommissionEmployeeDto {
  id: string;
  name: string;
  surname: string;
}

export interface AddTemplateCommissionEmployeesDto {
  employeesIds: string[] | undefined;
}

export interface PaginatedOfTemplateCommissionAssignmentDto {
  items: TemplateCommissionAssignmentDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface TemplateCommissionAssignmentDto {
  skill: SkillDto;
  employee: EmployeeOverviewDto;
}

export interface ConfigurationDto {
  id: string;
  companyName: string;
  companyLegalEntityType: string | undefined;
  companyRegisteredOffice: Address | undefined;
  companyOperationalOffice: Address | undefined;
  operationalOfficeId: string | undefined;
  companyVatNumber: string | undefined;
  companyEmailAddress: string | undefined;
  companyPecAddress: string | undefined;
  companyPhoneNumber: string | undefined;
  companyFaxNumber: string | undefined;
  companyWebsite: string | undefined;
  minWorkingHours: number;
  workingDays: number[];
  canCompileTimeInNotWorkingDays: boolean;
  confirmTimeSize: ConfirmTimeSize;
  canWriteUsers: boolean;
  enabledFeatures: GestitFeature[];
  exemptBillingLimitAmount: number;
  exemptBillingStampsChargesTaxCode: TaxCodeDto | undefined;
  exemptBillingStampsCharges: number;
  uiSettings: JsonDocument | undefined;
}

export enum ConfirmTimeSize {
  Month = "Month",
  Week = "Week",
}

export enum GestitFeature {
  WarehouseManagement = "WarehouseManagement",
  CommissionManagement = "CommissionManagement",
}

export interface JsonDocument {
  isDisposable: boolean;
  rootElement: any;
}

export interface ManageCompanyConfigurationDto {
  companyName: string;
  companyLegalEntityType: string | undefined;
  companyRegisteredOffice: Address | undefined;
  companyOperationalOffice: Address | undefined;
  operationalOfficeId: string | undefined;
  companyVatNumber: string | undefined;
  companyEmailAddress: string | undefined;
  companyPecAddress: string | undefined;
  companyPhoneNumber: string | undefined;
  companyFaxNumber: string | undefined;
}

export interface PaginatedOfCompanyOfficeDto {
  items: CompanyOfficeDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface CompanyOfficeManageDto {
  name: string;
  address: ManageAddressDto;
}

export interface ManageAddressDto {
  street: string;
  city: string;
  postalCode: string;
  stateProvince: string;
  country: string;
}

export interface PaginatedOfCountryDto {
  items: CountryDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface CountryDto {
  code: string;
  name: string;
  translations: { [key: string]: string };
}

export interface PaginatedOfCurrencyDto {
  items: CurrencyDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface ManageCurrencyDto {
  code: string;
  symbol: string;
  internationalCode: string;
}

export interface PaginatedOfCustomerDto {
  items: CustomerDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface ManageCustomerDto {
  name: string;
  companyType: string;
  vatNumber: string;
  reaCode: string | undefined;
  registeredOffice: ManageAddressDto;
  emailAddress: string | undefined;
  pecAddress: string | undefined;
  sdiCode: string | undefined;
  priceListId: string | undefined;
  defaultTaxCodeId: string | undefined;
  defaultPaymentTermsId: string | undefined;
  defaultCurrencyId: string | undefined;
  defaultBankAccountId: string | undefined;
  parentId: string | undefined;
}

export interface PaginatedOfCustomerContactDto {
  items: CustomerContactDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface CustomerContactDto {
  id: string;
  name: string;
  surname: string;
  phoneNumber: string;
  mobileNumber: string;
  email: string | undefined;
}

export interface CustomerContactManageDto {
  name: string;
  surname: string;
  phoneNumber: string;
  mobileNumber: string;
  email: string | undefined;
}

export interface PaginatedOfCustomerOfficeDto {
  items: CustomerOfficeDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface CustomerOfficeManageDto {
  name: string;
  address: ManageAddressDto;
}

export interface PaginatedOfCustomerDeclarationOfIntentDto {
  items: CustomerDeclarationOfIntentDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface CustomerDeclarationOfIntentDto {
  id: string;
  customer: CustomerDto;
  taxCode: TaxCodeDto;
  year: number;
  receivedAt: Date;
  issuedAt: Date;
  revokedAt: Date | undefined;
  internalProtocolNumber: string;
  telematicProtocolNumber: string;
  telematicSequentialNumber: string;
  notes: string | undefined;
  type: DeclarationOfIntentType;
  limitAmount: number | undefined;
  usage: number | undefined;
  isLimitOver: boolean;
  validFrom: Date | undefined;
  validUntil: Date | undefined;
}

export enum DeclarationOfIntentType {
  Plafond = "Plafond",
  Period = "Period",
}

export interface ManageCustomerDeclarationOfIntentDto {
  taxCodeId: string;
  year: number;
  receivedAt: Date;
  issuedAt: Date;
  revokedAt: Date | undefined;
  telematicProtocolNumber: string;
  telematicSequentialNumber: string;
  notes: string | undefined;
  type: DeclarationOfIntentType;
  limitAmount: number | undefined;
  validFrom: Date | undefined;
  validUntil: Date | undefined;
}

export interface DefaultsDto {
  taxCode: TaxCode | undefined;
  paymentTerms: PaymentTerms | undefined;
  currency: Currency | undefined;
  bankAccount: BankAccount | undefined;
}

export interface BankAccount {
  id: string;
  bankId: string;
  bank: Bank;
  code: string;
  iban: string;
  isSoftDeleted: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface Bank {
  id: string;
  description: string;
  address: Address;
  isSoftDeleted: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface ManageDefaultsDto {
  taxCodeId: string | undefined;
  paymentTermsId: string | undefined;
  currencyId: string | undefined;
  bankAccountId: string | undefined;
}

export interface PaginatedWithTotalOfDeliveryDocumentDto
  extends PaginatedOfDeliveryDocumentDto {
  currency: CurrencyDto | undefined;
  total: number | undefined;
  totalTaxable: number | undefined;
  totalTax: number | undefined;
}

export interface ManageDeliveryDocumentDto {
  date: Date;
  currencyId: string;
  customerId: string | undefined;
  customerOfficeId: string | undefined;
  supplierId: string | undefined;
  supplierOfficeId: string | undefined;
  companyOfficeId: string;
  packageId: string;
  deliveryMethod: DeliveryMethod;
  freightPaymentType: FreightPaymentType;
  carrierId: string | undefined;
  packageAppearanceId: string;
  movementReasonId: string;
  numberOfPackages: number;
  hasSupplier: boolean;
  hasCustomer: boolean;
}

export enum DeliveryDocumentReportType {
  WithoutPrice = "WithoutPrice",
  WithPrice = "WithPrice",
}

export interface PaginatedOfDeliveryDocumentItemDto {
  items: DeliveryDocumentItemDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface PaginatedOfSaleOrderItemDto {
  items: SaleOrderItemDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface ManageDeliveryDocumentItemDto {
  type: LineItemType;
  itemId: string | undefined;
  orderItemId: string | undefined;
  description: string | undefined;
  quantity: number;
  unitPrice: number;
  afterPositionIndex: number | undefined;
  taxCodeId: string | undefined;
  isWarehouseEnabled: boolean;
}

export interface ManageSaleOrderItemForDocumentDto {
  saleOrderItemId: string;
  partialQuantity: number;
  isWarehouseEnabled: boolean;
}

export interface ManageDeliveryDocumentItemsOrderDto {
  move: ItemsOrderDirection;
}

export interface PaginatedOfDepartmentDto {
  items: DepartmentDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface PaginatedOfDepartmentEmployeeDto {
  items: DepartmentEmployeeDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface DepartmentEmployeeDto {
  id: string;
  name: string;
  surname: string;
}

export interface AddDepartmentEmployeesDto {
  employeesIds: string[] | undefined;
}

export interface ManageDepartmentDto {
  code: string;
  description: string;
}

export interface PaginatedOfEmployeeDto {
  items: EmployeeDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface EmployeeDto {
  id: string;
  name: string;
  surname: string;
  registrationNumber: string;
  recruitmentDate: Date;
  terminationDate: Date | undefined;
  taxCode: string;
  birthDate: Date;
  birthPlace: string;
  birthStateProvince: string;
  birthCountry: string;
  user: UserOverviewDto | undefined;
  department: Department[];
  createdAt: Date;
  updatedAt: Date;
}

export interface UserOverviewDto {
  id: string | undefined;
  displayName: string | undefined;
  userPrincipalName: string | undefined;
}

export interface Department {
  id: string;
  code: string;
  description: string;
  isSoftDeleted: boolean;
  employees: Employee[];
  createdAt: Date;
  updatedAt: Date;
}

export interface Employee {
  id: string;
  userId: string | undefined;
  name: string;
  surname: string;
  registrationNumber: string;
  recruitmentDate: Date;
  terminationDate: Date | undefined;
  taxCode: string;
  birthDate: Date;
  birthPlace: string;
  birthStateProvince: string;
  birthCountry: string;
  isSoftDeleted: boolean;
  commissions: CommissionEmployee[];
  skills: Skill[];
  departments: Department[];
  createdAt: Date;
  updatedAt: Date;
}

export interface CommissionEmployee {
  commissionId: string;
  commission: Commission | undefined;
  employeeId: string;
  employee: Employee | undefined;
  createdAt: Date;
  updatedAt: Date;
  periods: CommissionEmployeePeriod[];
  tasks: CommissionTask[];
}

export interface Commission {
  id: string;
  title: string | undefined;
  incrementalNumber: number | undefined;
  code: string;
  description: string | undefined;
  openedAt: Date;
  closedAt: Date | undefined;
  customerId: string | undefined;
  customer: Customer | undefined;
  color: string;
  isSoftDeleted: boolean;
  createdAt: Date;
  updatedAt: Date;
  isSuspended: boolean;
  tasks: CommissionTask[];
  items: CommissionItem[];
  isMigrated: boolean;
  employees: CommissionEmployee[];
  isDefault: boolean;
  times: EmployeeCommissionTime[];
  areNotesMandatory: boolean;
}

export interface Customer {
  id: string;
  name: string;
  companyType: string;
  completeName: string;
  code: string | undefined;
  isSoftDeleted: boolean;
  vatNumber: string;
  reaCode: string | undefined;
  registeredOffice: Address;
  emailAddress: string | undefined;
  pecAddress: string | undefined;
  sdiCode: string | undefined;
  items: ItemCustomer[];
  priceListId: string | undefined;
  priceList: PriceList | undefined;
  defaultTaxCodeId: string | undefined;
  defaultTaxCode: TaxCode | undefined;
  defaultPaymentTermsId: string | undefined;
  defaultPaymentTerms: PaymentTerms | undefined;
  defaultCurrencyId: string | undefined;
  defaultCurrency: Currency | undefined;
  defaultBankAccountId: string | undefined;
  defaultBankAccount: BankAccount | undefined;
  createdAt: Date;
  updatedAt: Date;
  parentId: string | undefined;
  declarationsOfIntent: CustomerDeclarationOfIntent[];
  acceptedSamples: ItemSampleCustomerAcceptance[];
  billingDocuments: BillingDocument[];
}

export interface ItemCustomer {
  itemId: string;
  item: Item | undefined;
  customerId: string;
  customer: Customer | undefined;
  itemCode: string | undefined;
}

export interface Item {
  id: string;
  code: string;
  description: string;
  type: ItemType;
  categoryId: string | undefined;
  category: ItemCategory | undefined;
  commodityCategoryId: string | undefined;
  commodityCategory: CommodityCategory | undefined;
  billOfMaterial: BillOfMaterial | undefined;
  billOfMaterialComponents: BillOfMaterialComponent[];
  isSoftDeleted: boolean;
  customers: ItemCustomer[];
  suppliers: ItemSupplier[];
  sampleCustomersAcceptances: ItemSampleCustomerAcceptance[];
  sampleId: string | undefined;
  sample: Item | undefined;
  nature: ItemNature;
  departmentId: string | undefined;
  department: Department | undefined;
  isSample: boolean;
  archiveCode: string | undefined;
  unitOfMeasureId: string;
  unitOfMeasure: UnitOfMeasure;
  createdAt: Date;
  updatedAt: Date;
  saleOrdersItems: SaleOrderItem[];
  warehouseMovements: WarehouseMovement[];
}

export interface ItemCategory {
  id: string;
  code: string;
  description: string;
  isSoftDeleted: boolean;
  items: Item[];
  createdAt: Date;
  updatedAt: Date;
}

export interface CommodityCategory {
  id: string;
  code: string;
  description: string;
  items: Item[];
  createdAt: Date;
  updatedAt: Date;
}

export interface BillOfMaterial {
  id: string;
  itemId: string;
  item: Item;
  operations: Operation[];
  components: BillOfMaterialComponent[];
  isSoftDeleted: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface Operation {
  id: string;
  code: string;
  description: string;
  isSoftDeleted: boolean;
  billOfMaterials: BillOfMaterial[];
  createdAt: Date;
  updatedAt: Date;
}

export interface BillOfMaterialComponent {
  componentId: string;
  component: Item;
  billOfMaterialId: string;
  billOfMaterial: BillOfMaterial;
  quantity: number;
  createdAt: Date;
  updatedAt: Date;
}

export interface ItemSupplier {
  itemId: string;
  item: Item | undefined;
  supplierId: string;
  supplier: Supplier | undefined;
  itemCode: string | undefined;
}

export interface Supplier {
  id: string;
  name: string;
  companyType: string;
  completeName: string;
  code: string | undefined;
  isSoftDeleted: boolean;
  vatNumber: string;
  reaCode: string | undefined;
  registeredOffice: Address;
  items: ItemSupplier[];
  emailAddress: string;
  pecAddress: string | undefined;
  sdiCode: string | undefined;
  createdAt: Date;
  updatedAt: Date;
}

export interface ItemSampleCustomerAcceptance {
  sampleId: string;
  sample: Item;
  customerId: string;
  customer: Customer;
  deliveryDocumentId: string | undefined;
  deliveryDocument: DeliveryDocument | undefined;
  acceptedAt: Date;
}

export interface DeliveryDocument {
  id: string;
  code: string;
  date: Date;
  currencyId: string;
  currency: Currency;
  customerId: string | undefined;
  customer: Customer | undefined;
  customerOfficeId: string | undefined;
  customerOffice: CustomerOffice | undefined;
  supplierId: string | undefined;
  supplier: Supplier | undefined;
  supplierOfficeId: string | undefined;
  supplierOffice: SupplierOffice | undefined;
  companyOfficeId: string;
  companyOffice: CompanyOffice;
  packageId: string;
  package: Package;
  deliveryMethod: DeliveryMethod;
  freightPaymentType: FreightPaymentType;
  carrierId: string | undefined;
  carrier: Carrier | undefined;
  packageAppearanceId: string;
  packageAppearance: PackageAppearance;
  movementReasonId: string;
  movementReason: MovementReason;
  numberOfPackages: number;
  items: DeliveryDocumentItem[];
  isSoftDeleted: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface SupplierOffice {
  id: string;
  name: string;
  address: Address;
  supplierId: string;
  isSoftDeleted: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface CompanyOffice {
  id: string;
  name: string;
  address: Address;
  isSoftDeleted: boolean;
  createdAt: Date;
  updatedAt: Date;
  deliveryDocuments: DeliveryDocument[];
}

export interface Package {
  id: string;
  code: string;
  description: string;
  isSoftDeleted: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface Carrier {
  id: string;
  code: string;
  completeName: string;
  name: string;
  companyType: string;
  address: string;
  isSoftDeleted: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface PackageAppearance {
  id: string;
  code: string;
  description: string;
  isSoftDeleted: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface MovementReason {
  id: string;
  code: string;
  description: string;
  invoiceFollows: boolean;
  isWarehouseEnabled: boolean;
  isSoftDeleted: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface DeliveryDocumentItem {
  id: string;
  deliveryDocument: DeliveryDocument;
  deliveryDocumentId: string;
  type: LineItemType;
  itemId: string | undefined;
  item: Item | undefined;
  orderItemId: string | undefined;
  orderItem: SaleOrderItem | undefined;
  description: string | undefined;
  quantity: number;
  unitPrice: number;
  taxCodeId: string | undefined;
  taxCode: TaxCode | undefined;
  positionIndex: number;
  isSoftDeleted: boolean;
  createdAt: Date;
  updatedAt: Date;
  isWarehouseEnabled: boolean;
}

export interface SaleOrderItem {
  id: string;
  saleOrderId: string;
  saleOrder: SaleOrder;
  type: LineItemType;
  itemId: string | undefined;
  item: Item | undefined;
  description: string;
  quantity: number;
  unitPrice: number;
  taxCodeId: string | undefined;
  taxCode: TaxCode;
  positionIndex: number;
  isCancelled: boolean;
  isForcedDelivered: boolean;
  expectedDeliveryDate: Date | undefined;
  confirmedDeliveryDate: Date | undefined;
  documents: DeliveryDocumentItem[];
  isSoftDeleted: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface SaleOrder {
  id: string;
  date: Date;
  externalDate: Date | undefined;
  internalCode: string;
  externalCode: string | undefined;
  expectedDeliveryDate: Date | undefined;
  confirmedDeliveryDate: Date | undefined;
  customerOfficeId: string | undefined;
  customerOffice: CustomerOffice | undefined;
  customerId: string;
  customer: Customer;
  paymentTermsId: string;
  paymentTerms: PaymentTerms;
  currencyId: string;
  currency: Currency;
  bankAccountId: string | undefined;
  bankAccount: BankAccount | undefined;
  priceListId: string | undefined;
  priceList: PriceList | undefined;
  items: SaleOrderItem[];
  isSoftDeleted: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface PriceList {
  id: string;
  code: string;
  currencyId: string;
  currency: Currency;
  description: string | undefined;
  startDate: Date | undefined;
  endDate: Date | undefined;
  validity: string;
  isSoftDeleted: boolean;
  items: PriceListItem[];
  createdAt: Date;
  updatedAt: Date;
}

export interface PriceListItem {
  id: string;
  itemId: string;
  item: Item;
  priceListId: string;
  minQuantity: number;
  maxQuantity: number | undefined;
  price: number;
  createdAt: Date;
  updatedAt: Date;
}

export interface UnitOfMeasure {
  id: string;
  code: string;
  symbol: string;
  description: string;
  isSoftDeleted: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface WarehouseMovement {
  id: string;
  itemId: string;
  item: Item;
  deliveryDocumentItemId: string | undefined;
  deliveryDocumentItem: DeliveryDocumentItem | undefined;
  billOfLadingItemId: string | undefined;
  billOfLadingItem: BillOfLadingItem | undefined;
  quantity: number;
  createdAt: Date;
  updatedAt: Date;
}

export interface BillOfLadingItem {
  id: string;
  billOfLading: BillOfLading;
  billOfLadingId: string;
  type: LineItemType;
  itemId: string | undefined;
  item: Item | undefined;
  description: string | undefined;
  quantity: number;
  unitPrice: number;
  taxCodeId: string | undefined;
  taxCode: TaxCode | undefined;
  positionIndex: number;
  isSoftDeleted: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface BillOfLading {
  id: string;
  internalCode: string;
  externalCode: string | undefined;
  date: Date;
  externalDate: Date | undefined;
  currencyId: string;
  currency: Currency;
  customerId: string | undefined;
  customer: Customer | undefined;
  customerOfficeId: string | undefined;
  customerOffice: CustomerOffice | undefined;
  supplierId: string | undefined;
  supplier: Supplier | undefined;
  supplierOfficeId: string | undefined;
  supplierOffice: SupplierOffice | undefined;
  movementReasonId: string;
  movementReason: MovementReason;
  items: BillOfLadingItem[];
  isSoftDeleted: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface CustomerDeclarationOfIntent {
  id: string;
  customerId: string;
  customer: Customer;
  taxCodeId: string;
  taxCode: TaxCode;
  year: number;
  receivedAt: Date;
  issuedAt: Date;
  revokedAt: Date | undefined;
  internalProtocolNumber: string;
  telematicProtocolNumber: string;
  telematicSequentialNumber: string;
  notes: string | undefined;
  type: DeclarationOfIntentType;
  limitAmount: number | undefined;
  validFrom: Date | undefined;
  validUntil: Date | undefined;
  createdAt: Date;
  updatedAt: Date;
}

export interface BillingDocument {
  id: string;
  date: Date;
  code: string;
  customerId: string;
  customer: Customer;
  paymentTermsId: string;
  paymentTerms: PaymentTerms;
  currencyId: string;
  currency: Currency;
  bankAccount: BankAccount | undefined;
  bankAccountId: string | undefined;
  priceListId: string | undefined;
  priceList: PriceList | undefined;
  type: BillingDocumentType;
  items: BillingDocumentItem[];
  transmissions: InvoiceTransmission[];
  customerOfficeId: string | undefined;
  customerOffice: CustomerOffice | undefined;
  companyOfficeId: string;
  companyOffice: CompanyOffice;
  isSoftDeleted: boolean;
  createdAt: Date;
  updatedAt: Date;
  stampsChargesTaxCodeId: string | undefined;
  stampsChargesTaxCode: TaxCode | undefined;
  stampsCharges: number;
}

export interface BillingDocumentItem {
  id: string;
  billingDocumentId: string;
  billingDocument: BillingDocument;
  type: LineItemType;
  itemId: string | undefined;
  item: Item | undefined;
  deliveryDocumentItemId: string | undefined;
  deliveryDocumentItem: DeliveryDocumentItem | undefined;
  orderItemId: string | undefined;
  orderItem: SaleOrderItem | undefined;
  description: string;
  quantity: number;
  unitPrice: number;
  taxCodeId: string | undefined;
  taxCode: TaxCode;
  positionIndex: number;
  isSoftDeleted: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface InvoiceTransmission {
  code: string;
  billingDocumentId: string;
  billingDocument: BillingDocument;
  content: string;
  contentType: string;
  direction: InvoiceTransmissionDirection;
  statuses: InvoiceTransmissionStatusDetail[];
}

export interface InvoiceTransmissionStatusDetail {
  id: string;
  invoiceTransmissionCode: string;
  invoiceTransmission: InvoiceTransmission;
  date: Date;
  status: InvoiceTransmissionStatus;
  message: string | undefined;
}

export interface CommissionTask {
  id: string;
  commissionId: string;
  commission: Commission;
  title: string;
  parentId: string | undefined;
  parent: CommissionTask | undefined;
  legacyEstimatedTime: string | undefined;
  estimatedTime: string;
  path: string;
  isBilled: boolean;
  priority: number | undefined;
  createdAt: Date;
  updatedAt: Date;
  isSoftDeleted: boolean;
  assignments: CommissionAssignment[];
  employees: CommissionEmployee[];
}

export interface CommissionAssignment {
  estimatedTime: string;
  taskId: string;
  task: CommissionTask;
  employeeId: string;
  employee: Employee;
  skillId: string;
  skill: Skill;
  skillPrice: number | undefined;
  createdAt: Date;
  updatedAt: Date;
  periods: CommissionAssignmentPeriod[];
}

export interface Skill {
  id: string;
  code: string;
  description: string;
  employees: Employee[];
  isSoftDeleted: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface CommissionAssignmentPeriod {
  startAt: Date;
  endAt: Date;
}

export interface CommissionItem {
  id: string;
  commissionId: string;
  commission: Commission;
  itemId: string;
  item: Item;
  quantity: number;
  isSoftDeleted: boolean;
  createdAt: Date;
  updatedAt: Date;
  notes: string | undefined;
  orderItem: SaleOrderItem | undefined;
  orderItemId: string | undefined;
}

export interface EmployeeCommissionTime {
  id: string;
  commissionId: string;
  commission: Commission;
  employeeId: string;
  employee: Employee;
  date: Date;
  notes: string | undefined;
  isSoftDeleted: boolean;
  createdAt: Date;
  updatedAt: Date;
  timeSpent: string;
  tasksTimes: EmployeeTaskTime[];
  itemsTimes: EmployeeItemTime[];
}

export interface EmployeeTaskTime {
  employeeCommissionTimeId: string;
  employeeCommissionTime: EmployeeCommissionTime | undefined;
  taskId: string;
  task: CommissionTask | undefined;
  skillId: string;
  skill: Skill | undefined;
  timeSpent: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface EmployeeItemTime {
  employeeCommissionTimeId: string;
  employeeCommissionTime: EmployeeCommissionTime | undefined;
  itemId: string;
  item: Item;
  operationId: string;
  operation: Operation;
  quantity: number;
  timeSpent: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface CommissionEmployeePeriod {
  id: string;
  startAt: Date;
  endAt: Date;
}

export interface ManageEmployeeDto {
  name: string;
  surname: string;
  registrationNumber: string;
  recruitmentDate: Date;
  terminationDate: Date | undefined;
  taxCode: string;
  birthDate: Date;
  birthPlace: string;
  birthStateProvince: string;
  birthCountry: string;
  userId: string | undefined;
}

export interface PaginatedOfItemMovementDto {
  items: ItemMovementDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface ItemMovementsPage extends PaginatedOfItemMovementDto {
  entringSum: number;
  leavingSum: number;
  difference: number;
  startDate: Date | undefined;
  endDate: Date | undefined;
}

export interface ItemMovementDto {
  movementId: string | undefined;
  item: ItemOverviewDto;
  date: Date;
  movementReason: MovementReasonDto | undefined;
  movementSource: MovementSource;
  documentId: string | undefined;
  documentCode: string | undefined;
  description: string | undefined;
  customer: CustomerDto | undefined;
  supplier: SupplierDto | undefined;
  quantity: number;
  unitOfMeasure: UnitOfMeasureDto | undefined;
  currency: CurrencyDto | undefined;
  unitPrice: number | undefined;
  total: number | undefined;
}

export enum MovementSource {
  Inventory = "Inventory",
  DeliveryDocument = "DeliveryDocument",
  BillOfLading = "BillOfLading",
}

export interface ManageWarehouseMovementDto {
  updatedQuantity: number;
}

export interface PaginatedOfItemInBomHierarchyDto {
  items: ItemInBomHierarchyDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface ItemInBomHierarchyDto extends ItemDto {
  operations: OperationDto[] | undefined;
}

export interface ItemStockDto {
  id: string;
  code: string;
  description: string;
  stockQuantity: number;
  requiredQuantity: number | undefined;
  hasEnoughStock: boolean | undefined;
}

export interface ManageItemDto {
  code: string;
  description: string;
  type: ItemType;
  categoryId: string | undefined;
  commodityCategoryId: string | undefined;
  nature: ItemNature;
  departmentId: string | undefined;
  isSample: boolean;
  unitOfMeasureId: string;
  quantity: number | undefined;
}

export interface PaginatedOfItemCategoryDto {
  items: ItemCategoryDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface ManageItemCategoryDto {
  code: string;
  description: string;
}

export interface PaginatedOfCommodityCategoryDto {
  items: CommodityCategoryDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface ManageCommodityCategoryDto {
  code: string;
  description: string;
}

export interface PaginatedOfItemCustomerDto {
  items: ItemCustomerDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface PaginatedOfItemSupplierDto {
  items: ItemSupplierDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface PaginatedOfSupplierDto {
  items: SupplierDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface PaginatedOfPriceListItemDto {
  items: PriceListItemDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface PriceListItemDto {
  id: string;
  itemId: string;
  priceListId: string;
  currencySymbol: string | undefined;
  itemCode: string;
  itemDescription: string;
  startDate: Date | undefined;
  endDate: Date | undefined;
  validity: string;
  priceListCode: string;
  minQuantity: number;
  maxQuantity: number | undefined;
  price: number;
}

export interface PaginatedOfPriceListDto {
  items: PriceListDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface ItemPriceListManageDto {
  priceListId: string;
  minQuantity: number;
  maxQuantity: number | undefined;
  price: number;
}

export interface PaginatedOfItemSampleCustomerAcceptanceDto {
  items: ItemSampleCustomerAcceptanceDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface ItemSampleCustomerAcceptanceDto {
  sample: ItemDto;
  customer: CustomerDto;
  deliveryDocument: DeliveryDocumentDto | undefined;
  acceptedAt: Date;
  isAccepted: boolean;
}

export interface CreateLabelDto {
  customerId: string;
  subCustomerId: string | undefined;
  itemId: string;
  orderItemId: string | undefined;
  totalQuantity: number;
  quantityForPackage: number;
  showQuantityInLastPage: boolean;
  showHeader: boolean;
  notes: string | undefined;
}

export interface PaginatedOfJustificativeDto {
  items: JustificativeDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface JustificativeDto {
  id: string;
  title: string;
  code: string;
  color: string;
  notes: string | undefined;
  createdAt: Date;
  updatedAt: Date;
}

export interface ManageJustificativeDto {
  title: string;
  code: string;
  color: string;
}

export interface PaginatedOfMovementReasonDto {
  items: MovementReasonDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface ManageMovementReasonDto {
  code: string;
  description: string;
  invoiceFollows: boolean;
  isWarehouseEnabled: boolean;
}

export interface ManageOperationDto {
  code: string;
  description: string;
}

export interface PaginatedOfPackageAppearanceDto {
  items: PackageAppearanceDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface ManagePackageAppearanceDto {
  code: string;
  description: string;
}

export interface PaginatedOfPackageDto {
  items: PackageDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface PackageManageDto {
  code: string;
  description: string;
}

export interface PaginatedOfPaymentTermsDto {
  items: PaymentTermsDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface ManagePaymentTermsDto {
  code: string;
  description: string;
  paymentType: PaymentType;
  numberOfInstallments: number;
  daysBetweenInstallments: number;
  dueDateType: DueDateType;
}

export interface PriceListManageDto {
  code: string;
  currencyId: string;
  description: string | undefined;
  startDate: Date | undefined;
  endDate: Date | undefined;
}

export interface PriceListCustomManageDto {
  priceListId: string;
  code: string;
  description: string | undefined;
  startDate: Date | undefined;
  endDate: Date | undefined;
  variationPercentage: number;
  roundingDecimals: number;
  roundingType: RoundingType;
}

export enum RoundingType {
  Up = "Up",
  Down = "Down",
  Standard = "Standard",
}

export interface PriceListItemManageDto {
  itemId: string;
  minQuantity: number;
  maxQuantity: number | undefined;
  price: number;
}

export interface PaginatedOfPurchaseOrderDto {
  items: PurchaseOrderDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface PaginatedWithTotalOfPurchaseOrderDto
  extends PaginatedOfPurchaseOrderDto {
  currency: CurrencyDto | undefined;
  total: number | undefined;
  totalTaxable: number | undefined;
  totalTax: number | undefined;
}

export interface PurchaseOrderDto {
  id: string;
  date: Date;
  externalDate: Date | undefined;
  internalCode: string;
  externalCode: string | undefined;
  expectedDeliveryDate: Date | undefined;
  confirmedDeliveryDate: Date | undefined;
  supplierId: string;
  supplier: SupplierDto;
  supplierOfficeId: string | undefined;
  supplierOffice: SupplierOfficeDto | undefined;
  paymentTermsId: string;
  paymentTerms: PaymentTermsDto;
  currencyId: string;
  currency: CurrencyDto;
  bankAccountId: string;
  bankAccount: BankAccountDto;
  isSoftDeleted: boolean;
  createdAt: Date;
  updatedAt: Date;
  itemsCount: number;
  total: number;
  totalTaxable: number;
  totalTax: number;
}

export interface ManagePurchaseOrderDto {
  date: Date;
  externalDate: Date | undefined;
  externalCode: string | undefined;
  expectedDeliveryDate: Date | undefined;
  confirmedDeliveryDate: Date | undefined;
  supplierId: string;
  supplierOfficeId: string | undefined;
  paymentTermsId: string;
  currencyId: string;
  bankAccountId: string | undefined;
}

export interface PaginatedOfPurchaseOrderItemDto {
  items: PurchaseOrderItemDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface PurchaseOrderItemDto {
  id: string;
  purchaseOrder: PurchaseOrderDto;
  type: LineItemType;
  item: ItemDto | undefined;
  description: string;
  quantity: number;
  unitPrice: number;
  taxCode: TaxCodeDto | undefined;
  taxable: number;
  tax: number;
  total: number;
  positionIndex: number;
  isSoftDeleted: boolean;
  expectedDeliveryDate: Date | undefined;
  confirmedDeliveryDate: Date | undefined;
  createdAt: Date;
  updatedAt: Date;
}

export interface ManagePurchaseOrderItemDto {
  type: LineItemType;
  itemId: string | undefined;
  description: string;
  quantity: number;
  unitPrice: number;
  afterPositionIndex: number | undefined;
  taxCodeId: string | undefined;
  expectedDeliveryDate: Date | undefined;
  confirmedDeliveryDate: Date | undefined;
}

export interface ManageOrderItemsOrderDto {
  move: ItemsOrderDirection;
}

export interface PaginatedOfSaleOfferDto {
  items: SaleOfferDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface PaginatedWithTotalOfSaleOfferDto
  extends PaginatedOfSaleOfferDto {
  currency: CurrencyDto | undefined;
  total: number | undefined;
  totalTaxable: number | undefined;
  totalTax: number | undefined;
}

export interface SaleOfferDto {
  id: string;
  date: Date;
  code: string;
  customer: CustomerDto | undefined;
  paymentTerms: PaymentTermsDto | undefined;
  currency: CurrencyDto | undefined;
  bankAccount: BankAccountDto | undefined;
  priceList: PriceListDto | undefined;
  itemsCount: number;
  createdAt: Date;
  updatedAt: Date;
  total: number;
  totalTaxable: number;
  totalTax: number;
}

export interface ManageSaleOfferDto {
  date: Date;
  customerId: string;
  paymentTermsId: string;
  currencyId: string;
  bankAccountId: string | undefined;
  priceListId: string | undefined;
}

export interface PaginatedOfSaleOfferItemDto {
  items: SaleOfferItemDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface SaleOfferItemDto {
  id: string;
  type: LineItemType;
  item: ItemDto | undefined;
  description: string;
  quantity: number;
  unitPrice: number;
  taxable: number;
  tax: number;
  total: number;
  taxCode: TaxCodeDto | undefined;
}

export interface ManageSaleOfferItemDto {
  type: LineItemType;
  itemId: string | undefined;
  description: string;
  quantity: number;
  unitPrice: number;
  afterPositionIndex: number | undefined;
  taxCodeId: string | undefined;
}

export interface ManageSaleOfferItemsOrderDto {
  move: ItemsOrderDirection;
}

export interface PaginatedWithTotalOfSaleOrderDto
  extends PaginatedOfSaleOrderDto {
  currency: CurrencyDto | undefined;
  total: number | undefined;
  totalTaxable: number | undefined;
  totalTax: number | undefined;
}

export interface PaginatedSaleOrderWithTotal
  extends PaginatedWithTotalOfSaleOrderDto {
  totalUndelivered: number | undefined;
  totalUndeliveredTaxable: number | undefined;
  totalUndeliveredTax: number | undefined;
}

export interface ManageSaleOrderDto {
  date: Date;
  externalDate: Date | undefined;
  externalCode: string | undefined;
  expectedDeliveryDate: Date | undefined;
  confirmedDeliveryDate: Date | undefined;
  customerId: string;
  customerOfficeId: string | undefined;
  paymentTermsId: string;
  currencyId: string;
  bankAccountId: string | undefined;
  priceListId: string | undefined;
}

export interface ManageSaleOrderItemDto {
  type: LineItemType;
  itemId: string | undefined;
  description: string;
  quantity: number;
  unitPrice: number;
  afterPositionIndex: number | undefined;
  taxCodeId: string | undefined;
  expectedDeliveryDate: Date | undefined;
  confirmedDeliveryDate: Date | undefined;
}

export interface PaginatedOfSavedQueryDto {
  items: SavedQueryDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface SavedQueryDto {
  id: string;
  userId: string;
  endpoint: string;
  name: string;
  sortBy: string;
  q: string;
  fields: string;
  limit: number;
  createdAt: Date;
}

export interface ProblemDetails {
  type: string | undefined;
  title: string | undefined;
  status: number | undefined;
  detail: string | undefined;
  instance: string | undefined;

  [key: string]: any;
}

export interface CreateSavedQueryDto {
  endpoint: string;
  name: string;
  sortBy: string;
  q: string;
  fields: string;
  limit: number;
}

export interface UpdateSavedQueryDto {
  name: string;
}

export interface PaginatedOfSavedQueryScheduledExportDto {
  items: SavedQueryScheduledExportDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface SavedQueryScheduledExportDto {
  id: string;
  to: string[];
  cc: string[];
  bcc: string[];
  fields: string;
  cronSchedule: string;
  createdAt: Date;
}

export interface ManageSavedQueryScheduledExportDto {
  to: string[];
  cc: string[];
  bcc: string[];
  fields: string;
  cronSchedule: string;
}

export interface PaginatedOfSkillDto {
  items: SkillDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface ManageSkillDto {
  code: string;
  description: string;
}

export interface AddSkillToEmployeeDto {
  skillId: string;
}

export interface CountersDto {
  customers: number;
  suppliers: number;
  employees: number;
  commissions: number;
}

export interface PaginatedOfTurnoverDto {
  items: TurnoverDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface TurnoverDto {
  startAt: Date;
  period: TurnoverPeriod;
  total: number;
  totalTaxable: number;
  totalTax: number;
  prevTotal: number | undefined;
  prevTotalTaxable: number | undefined;
  prevTotalTax: number | undefined;
  performance: number | undefined;
  currency: CurrencyDto;
}

export enum TurnoverPeriod {
  Monthly = "Monthly",
  Yearly = "Yearly",
}

export interface PaginatedOfCustomerTurnoverDto {
  items: CustomerTurnoverDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface CustomerTurnoverDto {
  startAt: Date;
  customer: CustomerOverviewDto;
  totalTax: number;
  totalTaxable: number;
  total: number;
  currency: CurrencyDto;
}

export interface PaginatedOfItemTurnoverDto {
  items: ItemTurnoverDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface ItemTurnoverDto {
  startAt: Date;
  item: ItemDto;
  totalTax: number;
  totalTaxable: number;
  total: number;
  currency: CurrencyDto;
}

export interface ManageSupplierDto {
  name: string;
  companyType: string;
  vatNumber: string;
  reaCode: string | undefined;
  registeredOffice: ManageAddressDto;
  emailAddress: string;
  pecAddress: string | undefined;
  sdiCode: string | undefined;
}

export interface PaginatedOfSupplierOfficeDto {
  items: SupplierOfficeDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface SupplierOfficeManageDto {
  name: string;
  address: ManageAddressDto;
}

export interface PaginatedOfTaxCodeDto {
  items: TaxCodeDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface PaginatedOfEiCodingDto {
  items: EiCodingDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface EiCodingDto {
  code: string;
  description: string;
}

export interface ManageTaxCodeDto {
  code: string;
  description: string;
  percentage: number;
  undeductiblePercentage: number;
  isExempt: boolean;
  eiCodingCode: string | undefined;
}

export interface PaginatedOfTimeSheetEntryDto {
  items: TimeSheetEntryDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface TimeSheetEntryDto {
  id: string;
  type: TimeSheetEntryType;
  title: string;
  code: string;
  customer: CustomerOverviewDto | undefined;
  color: string;
  areNotesMandatory: boolean;
  periods: TimeSheetEntryPeriodDto[];
}

export enum TimeSheetEntryType {
  Commission = "Commission",
  Justificative = "Justificative",
}

export interface TimeSheetEntryPeriodDto {
  startAt: Date;
  endAt: Date;
  task: CommissionTaskOverviewDto | undefined;
  skill: SkillDto | undefined;
  item: ItemOverviewDto | undefined;
}

export interface TimeSheetEntryEmployeeDto {
  id: string;
  name: string;
  surname: string;
  periods: TimeSheetEntryPeriodDto[];
}

export interface TimeSheetTimeDto {
  id: string;
  date: Date;
  entry: TimeSheetEntryOverviewDto;
  timeSpent: string;
  tasksTimes: TimeSheetTaskTimeDto[] | undefined;
  itemsTimes: TimeSheetItemTimeDto[] | undefined;
  totalHoursSpent: number;
  totalMinutesSpent: number;
  notes: string | undefined;
  employee: EmployeeOverviewDto | undefined;
}

export interface TimeSheetEntryOverviewDto {
  id: string;
  type: TimeSheetEntryType;
  title: string;
  code: string;
}

export interface TimeSheetTaskTimeDto {
  task: CommissionTaskOverviewDto;
  skill: SkillDto;
  timeSpent: string;
  totalHoursSpent: number;
  totalMinutesSpent: number;
}

export interface TimeSheetItemTimeDto {
  item: CommissionItemOverviewDto;
  operation: OperationDto;
  quantity: number;
  timeSpent: string;
  totalHoursSpent: number;
  totalMinutesSpent: number;
}

export enum TimeSheetExportBy {
  Entries = "Entries",
  Employees = "Employees",
  Date = "Date",
}

export interface PublicHolidayDto {
  date: Date;
  name: string;
}

export interface ConfirmedTimeDto {
  employeeId: string;
  startAt: Date;
  endAt: Date;
}

export interface TimeSheetEntryStatsDto {
  timeSpent: string;
  totalHoursSpent: number;
  totalMinutesSpent: number;
  estimatedTime: string | undefined;
  estimatedHours: number | undefined;
  estimatedMinutes: number | undefined;
  timeSpentPercentage: number | undefined;
  tasks: TimeSheetEntryTaskStatsDto[] | undefined;
}

export interface TimeSheetEntryTaskStatsDto {
  id: string;
  title: string;
  estimatedTime: string | undefined;
  estimatedHours: number | undefined;
  estimatedMinutes: number | undefined;
  timeSpentPercentage: number | undefined;
  totalTimeSpent: string;
  totalHoursSpent: number;
  totalMinutesSpent: number;
}

export enum TimeSheetEntryStatsExportBy {
  Employees = "Employees",
  Skills = "Skills",
}

export interface TimeSheetEntryPeriodStatsDto {
  timeSpent: string;
  totalHoursSpent: number;
  totalMinutesSpent: number;
  tasks: TimeSheetEntryTaskStatsDto[];
  from: Date;
  to: Date;
}

export enum SplitBy {
  Month = "Month",
}

export interface TimeSheetEntryEmployeeStatsDto {
  employee: EmployeeOverviewDto;
  totalTimeSpent: string;
  totalHoursSpent: number;
  totalMinutesSpent: number;
}

export interface ManageTimeSheetTimeDto {
  entryId: string;
  date: Date;
  notes: string | undefined;
  timeSpent: string | undefined;
  tasksTimes: ManageTimeSheetTaskTimeDto[] | undefined;
  itemsTimes: ManageTimeSheetItemTimeDto[] | undefined;
}

export interface ManageTimeSheetTaskTimeDto {
  taskId: string;
  skillId: string;
  timeSpent: string;
}

export interface ManageTimeSheetItemTimeDto {
  itemId: string;
  operationId: string;
  quantity: number;
  timeSpent: string;
}

export interface ManageConfirmedTimeDto {
  startAt: Date;
  endAt: Date;
}

export interface PaginatedOfUnitOfMeasureDto {
  items: UnitOfMeasureDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface ManageUnitOfMeasureDto {
  code: string;
  symbol: string;
  description: string;
}

export interface CurrentUserDto {
  id: string;
  userName: string;
  employeeId: string | undefined;
  isEmployee: boolean;
}

export interface PaginatedOfUserDto {
  items: UserDto[];
  totalCount: number;
  hasMoreItems: boolean;
}

export interface UserDto {
  id: string;
  displayName: string;
  userPrincipalName: string;
}

export interface ManageUserDto {
  id: string | undefined;
  name: string;
  surname: string;
  displayName: string;
  username: string;
  domain: string;
  generatePassword: boolean;
  password: string;
  confirmPassword: string;
  forceChangePasswordNextSignIn: boolean;
}

export class SwaggerResponse<TResult> {
  status: number;
  headers: { [key: string]: any };
  result: TResult;

  constructor(
    status: number,
    headers: { [key: string]: any },
    result: TResult
  ) {
    this.status = status;
    this.headers = headers;
    this.result = result;
  }
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isSwaggerException = true;

  static isSwaggerException(obj: any): obj is SwaggerException {
    return obj.isSwaggerException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new SwaggerException(message, status, response, headers, null);
}

function dateReviver(
  key: string,
  value: any,
  whitelist: string[] | undefined = undefined
) {
  if (
    typeof value === "string" &&
    (whitelist === undefined || whitelist.indexOf(key) > -1)
  ) {
    const date = parseJSON(value);
    if (isValid(date)) {
      return date;
    }
  }
  return value;
}

const dateProperties = [
  "openedAt",
  "closedAt",
  "createdAt",
  "updatedAt",
  "startAt",
  "endAt",
  "date",
  "from",
  "to",
  "recruitmentDate",
  "birthDate",
  "terminationDate",
  "acceptedAt",
  "receivedAt",
  "issuedAt",
  "revokedAt",
  "validFrom",
  "validUntil",
  "expectedDeliveryDate",
  "confirmedDeliveryDate",
  "deliveryDate",
  "externalDate",
];

// eslint-disable-next-line @typescript-eslint/no-unused-vars

// eslint-disable-next-line @typescript-eslint/no-unused-vars

// eslint-disable-next-line @typescript-eslint/no-unused-vars

// eslint-disable-next-line @typescript-eslint/no-unused-vars

// eslint-disable-next-line @typescript-eslint/no-unused-vars

// eslint-disable-next-line @typescript-eslint/no-unused-vars

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export interface GestitClientOptions {
  accessToken?: string;
  role?: string;
}

export enum FilterOperator {
  Eq = "eq",
  Neq = "neq",
  Gt = "gt",
  Gte = "gte",
  Lt = "lt",
  Lte = "lte",
  Cnt = "cnt",
}

export enum ExportFormat {
  Excel = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  Pdf = "application/pdf",
}
